// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AbortMediaDownloadData, AbortMediaDownloadErrors, AbortMediaDownloadResponses, AbortStorageOperationsData, AbortStorageOperationsErrors, AbortStorageOperationsResponses, AddReservableItemData, AddReservableItemErrors, AddReservableItemResponses, AdminAddMigrationExceptionData, AdminAddMigrationExceptionErrors, AdminAddMigrationExceptionResponses, AdminAllowedUpdateData, AdminAllowedUpdateErrors, AdminAllowedUpdateResponses, AdminAuthenticationPoliciesData, AdminAuthenticationPoliciesErrors, AdminAuthenticationPoliciesResponses, AdminAuthenticationPolicyAddData, AdminAuthenticationPolicyAddErrors, AdminAuthenticationPolicyAddResponses, AdminAuthenticationPolicyData, AdminAuthenticationPolicyDeleteData, AdminAuthenticationPolicyDeleteErrors, AdminAuthenticationPolicyDeleteResponses, AdminAuthenticationPolicyEditData, AdminAuthenticationPolicyEditErrors, AdminAuthenticationPolicyEditResponses, AdminAuthenticationPolicyErrors, AdminAuthenticationPolicyResponses, AdminAuthenticationProvidersData, AdminAuthenticationProvidersErrors, AdminAuthenticationProvidersResponses, AdminAutoRegisterData, AdminAutoRegisterErrors, AdminAutoRegisterResponses, AdminBackupConfigData, AdminBackupConfigErrors, AdminBackupConfigResponses, AdminBackupGetData, AdminBackupGetErrors, AdminBackupGetResponses, AdminBackupIntegrityGetData, AdminBackupIntegrityGetErrors, AdminBackupIntegrityGetResponses, AdminBackupIntegritySetData, AdminBackupIntegritySetErrors, AdminBackupIntegritySetResponses, AdminBackupReportData, AdminBackupReportErrors, AdminBackupReportResponses, AdminBackupsListData, AdminBackupsListErrors, AdminBackupsListResponses, AdminBroadcastData2, AdminBroadcastErrors, AdminBroadcastResponses, AdminBulkCreateUsersData, AdminBulkCreateUsersErrors, AdminBulkCreateUsersResponses, AdminCancelTaskData, AdminCancelTaskErrors, AdminCancelTaskResponses, AdminCategoryDeleteCheckData, AdminCategoryDeleteCheckErrors, AdminCategoryDeleteCheckResponses, AdminCheckDisclaimerData, AdminCheckDisclaimerErrors, AdminCheckDisclaimerResponses, AdminCheckEmailVerificationData, AdminCheckEmailVerificationErrors, AdminCheckEmailVerificationResponses, AdminCheckGroupCategoryData2, AdminCheckGroupCategoryErrors, AdminCheckGroupCategoryResponses, AdminCheckMigratedData2, AdminCheckMigratedErrors, AdminCheckMigratedResponses, AdminCheckMigrationData, AdminCheckMigrationErrors, AdminCheckMigrationRequiredData, AdminCheckMigrationRequiredErrors, AdminCheckMigrationRequiredResponses, AdminCheckMigrationResponses, AdminCheckPasswordResetRequiredData, AdminCheckPasswordResetRequiredErrors, AdminCheckPasswordResetRequiredResponses, AdminCreateCategoryData, AdminCreateCategoryErrors, AdminCreateCategoryResponses, AdminCreateGroupData, AdminCreateGroupErrors, AdminCreateGroupResponses, AdminCreateNotificationData, AdminCreateNotificationErrors, AdminCreateNotificationResponses, AdminCreateNotificationTemplateData, AdminCreateNotificationTemplateErrors, AdminCreateNotificationTemplateResponses, AdminCreateSecretData, AdminCreateSecretErrors, AdminCreateSecretResponses, AdminCreateUserData, AdminCreateUserErrors, AdminCreateUserResponses, AdminDeleteAllNotificationDataData, AdminDeleteAllNotificationDataErrors, AdminDeleteAllNotificationDataResponses, AdminDeleteCategoryData, AdminDeleteCategoryErrors, AdminDeleteCategoryResponses, AdminDeleteGroupData, AdminDeleteGroupErrors, AdminDeleteGroupResponses, AdminDeleteMigrationExceptionData, AdminDeleteMigrationExceptionErrors, AdminDeleteMigrationExceptionResponses, AdminDeleteNotificationData, AdminDeleteNotificationDataData, AdminDeleteNotificationDataErrors, AdminDeleteNotificationDataResponses, AdminDeleteNotificationErrors, AdminDeleteNotificationResponses, AdminDeleteNotificationTemplateData, AdminDeleteNotificationTemplateErrors, AdminDeleteNotificationTemplateResponses, AdminDeleteOldTasksAutoData, AdminDeleteOldTasksAutoErrors, AdminDeleteOldTasksAutoResponses, AdminDeleteOldTasksData, AdminDeleteOldTasksErrors, AdminDeleteOldTasksResponses, AdminDeleteSecretData, AdminDeleteSecretErrors, AdminDeleteSecretResponses, AdminDeleteUserNotificationDataData, AdminDeleteUserNotificationDataErrors, AdminDeleteUserNotificationDataResponses, AdminDeleteUsersData, AdminDeleteUsersErrors, AdminDeleteUsersResponses, AdminDesktopsStatusCategoryData, AdminDesktopsStatusCategoryErrors, AdminDesktopsStatusCategoryResponses, AdminDesktopsStatusData, AdminDesktopsStatusErrors, AdminDesktopsStatusResponses, AdminDesktopsTreeListData, AdminDesktopsTreeListErrors, AdminDesktopsTreeListResponses, AdminDomainDetailsData, AdminDomainDetailsErrors, AdminDomainDetailsResponses, AdminDomainHardwareData, AdminDomainHardwareErrors, AdminDomainHardwareResponses, AdminDomainLiveXmlData, AdminDomainLiveXmlErrors, AdminDomainLiveXmlResponses, AdminDomainSearchInfoData, AdminDomainSearchInfoErrors, AdminDomainSearchInfoResponses, AdminDomainsFieldData, AdminDomainsFieldErrors, AdminDomainsFieldResponses, AdminDomainsNameSearchData, AdminDomainsNameSearchErrors, AdminDomainsNameSearchResponses, AdminDomainsStartedCountData, AdminDomainsStartedCountErrors, AdminDomainsStartedCountResponses, AdminDomainsStatusData, AdminDomainsStatusErrors, AdminDomainsStatusResponses, AdminDomainStorageData, AdminDomainStorageErrors, AdminDomainStoragePathData2, AdminDomainStoragePathErrors, AdminDomainStoragePathResponses, AdminDomainStorageResponses, AdminDomainTemplateTreeData, AdminDomainTemplateTreeErrors, AdminDomainTemplateTreeResponses, AdminDomainViewerDataData, AdminDomainViewerDataErrors, AdminDomainViewerDataResponses, AdminDomainXmlCapabilitiesData, AdminDomainXmlCapabilitiesErrors, AdminDomainXmlCapabilitiesResponses, AdminDomainXmlGetData, AdminDomainXmlGetErrors, AdminDomainXmlGetResponses, AdminDomainXmlSectionsGetData, AdminDomainXmlSectionsGetErrors, AdminDomainXmlSectionsGetResponses, AdminDomainXmlSectionsParseData, AdminDomainXmlSectionsParseErrors, AdminDomainXmlSectionsParseResponses, AdminDomainXmlSectionsSaveAsVirtInstallData, AdminDomainXmlSectionsSaveAsVirtInstallErrors, AdminDomainXmlSectionsSaveAsVirtInstallResponses, AdminDomainXmlSectionsSaveData2, AdminDomainXmlSectionsSaveErrors, AdminDomainXmlSectionsSaveResponses, AdminDomainXmlUpdateData, AdminDomainXmlUpdateErrors, AdminDomainXmlUpdateResponses, AdminDownloadsActionData, AdminDownloadsActionErrors, AdminDownloadsActionIdData, AdminDownloadsActionIdErrors, AdminDownloadsActionIdResponses, AdminDownloadsActionResponses, AdminDownloadsData, AdminDownloadsErrors, AdminDownloadsKindData, AdminDownloadsKindErrors, AdminDownloadsKindResponses, AdminDownloadsRegisterData, AdminDownloadsRegisterErrors, AdminDownloadsRegisterResponses, AdminDownloadsResponses, AdminEchartDailyItemsData, AdminEchartDailyItemsErrors, AdminEchartDailyItemsResponses, AdminEchartData, AdminEchartErrors, AdminEchartResponses, AdminEditCsvUsersData, AdminEditCsvUsersErrors, AdminEditCsvUsersResponses, AdminEmitSocketioData, AdminEmitSocketioErrors, AdminEmitSocketioResponses, AdminFindStoragesByDomainStatusData, AdminFindStoragesByDomainStatusErrors, AdminFindStoragesByDomainStatusResponses, AdminForceDisclaimerData, AdminForceDisclaimerErrors, AdminForceDisclaimerResponses, AdminForceEmailData, AdminForceEmailErrors, AdminForceEmailResponses, AdminForcePasswordData, AdminForcePasswordErrors, AdminForcePasswordResponses, AdminGetBastionDomainData, AdminGetBastionDomainErrors, AdminGetBastionDomainResponses, AdminGetCategoryByNameData, AdminGetCategoryByNameErrors, AdminGetCategoryByNameResponses, AdminGetCategoryData, AdminGetCategoryErrors, AdminGetCategoryResponses, AdminGetCategoryUsersData, AdminGetCategoryUsersErrors, AdminGetCategoryUsersResponses, AdminGetGroupByNameCategoryData, AdminGetGroupByNameCategoryErrors, AdminGetGroupByNameCategoryResponses, AdminGetGroupData, AdminGetGroupErrors, AdminGetGroupResponses, AdminGetGroupUsersData, AdminGetGroupUsersErrors, AdminGetGroupUsersResponses, AdminGetJwtData, AdminGetJwtErrors, AdminGetJwtResponses, AdminGetMigrationExceptionsData, AdminGetMigrationExceptionsErrors, AdminGetMigrationExceptionsResponses, AdminGetNotificationData, AdminGetNotificationErrors, AdminGetNotificationResponses, AdminGetNotificationsDataByStatusData, AdminGetNotificationsDataByStatusErrors, AdminGetNotificationsDataByStatusResponses, AdminGetNotificationsGroupedByStatusData, AdminGetNotificationsGroupedByStatusErrors, AdminGetNotificationsGroupedByStatusResponses, AdminGetNotificationStatusesData, AdminGetNotificationStatusesErrors, AdminGetNotificationStatusesResponses, AdminGetNotificationTemplateData, AdminGetNotificationTemplateErrors, AdminGetNotificationTemplateResponses, AdminGetOldTasksConfigData, AdminGetOldTasksConfigErrors, AdminGetOldTasksConfigResponses, AdminGetOldTasksData, AdminGetOldTasksErrors, AdminGetOldTasksResponses, AdminGetPasswordPolicyData, AdminGetPasswordPolicyErrors, AdminGetPasswordPolicyResponses, AdminGetQuotaByKindData, AdminGetQuotaByKindErrors, AdminGetQuotaByKindItemData, AdminGetQuotaByKindItemErrors, AdminGetQuotaByKindItemResponses, AdminGetQuotaByKindResponses, AdminGetQuotasData, AdminGetQuotasErrors, AdminGetQuotasResponses, AdminGetRoleData, AdminGetRoleErrors, AdminGetRoleResponses, AdminGetRolesData, AdminGetRolesErrors, AdminGetRolesResponses, AdminGetSecretsData, AdminGetSecretsErrors, AdminGetSecretsResponses, AdminGetStorageSchedulerConfigData, AdminGetStorageSchedulerConfigErrors, AdminGetStorageSchedulerConfigResponses, AdminGetTemplatesData, AdminGetTemplatesErrors, AdminGetTemplatesResponses, AdminGetUserAppliedQuotaData, AdminGetUserAppliedQuotaErrors, AdminGetUserAppliedQuotaResponses, AdminGetUserByEmailCategoryData, AdminGetUserByEmailCategoryErrors, AdminGetUserByEmailCategoryResponses, AdminGetUserData, AdminGetUserDesktopsData, AdminGetUserDesktopsErrors, AdminGetUserDesktopsResponses, AdminGetUserErrors, AdminGetUserNotificationDisplaysData, AdminGetUserNotificationDisplaysErrors, AdminGetUserNotificationDisplaysResponses, AdminGetUserRawData, AdminGetUserRawErrors, AdminGetUserRawResponses, AdminGetUserResponses, AdminGetUserSchemaData, AdminGetUserSchemaErrors, AdminGetUserSchemaResponses, AdminGetUserTemplatesData, AdminGetUserTemplatesErrors, AdminGetUserTemplatesResponses, AdminGetUserVpnData, AdminGetUserVpnErrors, AdminGetUserVpnResponses, AdminGetUserVpnWithOsData, AdminGetUserVpnWithOsErrors, AdminGetUserVpnWithOsResponses, AdminGpuForceProfilePreviewData, AdminGpuForceProfilePreviewErrors, AdminGpuForceProfilePreviewResponses, AdminGroupDeleteCheckData, AdminGroupDeleteCheckErrors, AdminGroupDeleteCheckResponses, AdminGroupEnrollmentData2, AdminGroupEnrollmentErrors, AdminGroupEnrollmentResponses, AdminHypervisorBootProgressData, AdminHypervisorBootProgressErrors, AdminHypervisorBootProgressResponses, AdminHypervisorCreateData2, AdminHypervisorCreateErrors, AdminHypervisorCreateResponses, AdminHypervisorDeleteData, AdminHypervisorDeleteErrors, AdminHypervisorDeleteResponses, AdminHypervisorDisksFoundData2, AdminHypervisorDisksFoundErrors, AdminHypervisorDisksFoundResponses, AdminHypervisorEnableData2, AdminHypervisorEnableErrors, AdminHypervisorEnableResponses, AdminHypervisorGpuAppliedData, AdminHypervisorGpuAppliedErrors, AdminHypervisorGpuAppliedResponses, AdminHypervisorMediaDeleteData2, AdminHypervisorMediaDeleteErrors, AdminHypervisorMediaDeleteResponses, AdminHypervisorMediaFoundData2, AdminHypervisorMediaFoundErrors, AdminHypervisorMediaFoundResponses, AdminHypervisorMountpointsData, AdminHypervisorMountpointsErrors, AdminHypervisorMountpointsResponses, AdminHypervisorsListByStatusData, AdminHypervisorsListByStatusErrors, AdminHypervisorsListByStatusResponses, AdminHypervisorsListData, AdminHypervisorsListErrors, AdminHypervisorsListResponses, AdminHypervisorStartedDomainsData, AdminHypervisorStartedDomainsErrors, AdminHypervisorStartedDomainsResponses, AdminHypervisorStatusData, AdminHypervisorStatusErrors, AdminHypervisorStatusResponses, AdminHypervisorStopDomainsData, AdminHypervisorStopDomainsErrors, AdminHypervisorStopDomainsResponses, AdminHypervisorVirtPoolsGetData, AdminHypervisorVirtPoolsGetErrors, AdminHypervisorVirtPoolsGetResponses, AdminHypervisorVirtPoolsUpdateData, AdminHypervisorVirtPoolsUpdateErrors, AdminHypervisorVirtPoolsUpdateResponses, AdminHypervisorVpnData, AdminHypervisorVpnErrors, AdminHypervisorVpnResponses, AdminHypervisorWgAddrData2, AdminHypervisorWgAddrErrors, AdminHypervisorWgAddrResponses, AdminImportCsvUsersData, AdminImportCsvUsersErrors, AdminImportCsvUsersResponses, AdminListCategoriesData, AdminListCategoriesErrors, AdminListCategoriesFrontendData, AdminListCategoriesFrontendErrors, AdminListCategoriesFrontendResponses, AdminListCategoriesNavData, AdminListCategoriesNavErrors, AdminListCategoriesNavResponses, AdminListCategoriesResponses, AdminListCustomNotificationTemplatesData, AdminListCustomNotificationTemplatesErrors, AdminListCustomNotificationTemplatesResponses, AdminListDomainsData2, AdminListDomainsErrors, AdminListDomainsResponses, AdminListGroupsData, AdminListGroupsErrors, AdminListGroupsNavData, AdminListGroupsNavErrors, AdminListGroupsNavResponses, AdminListGroupsResponses, AdminListNotificationActionsData, AdminListNotificationActionsErrors, AdminListNotificationActionsResponses, AdminListNotificationsData, AdminListNotificationsErrors, AdminListNotificationsResponses, AdminListNotificationTemplatesData, AdminListNotificationTemplatesErrors, AdminListNotificationTemplatesResponses, AdminListSystemNotificationTemplatesData, AdminListSystemNotificationTemplatesErrors, AdminListSystemNotificationTemplatesResponses, AdminListUsersData, AdminListUsersErrors, AdminListUsersNavData, AdminListUsersNavErrors, AdminListUsersNavResponses, AdminListUsersResponses, AdminLoginConfigByCategoryData, AdminLoginConfigByCategoryErrors, AdminLoginConfigByCategoryResponses, AdminLoginConfigGetData, AdminLoginConfigGetErrors, AdminLoginConfigGetResponses, AdminLoginNotificationCoverEnableData, AdminLoginNotificationCoverEnableErrors, AdminLoginNotificationCoverEnableResponses, AdminLoginNotificationFormEnableData, AdminLoginNotificationFormEnableErrors, AdminLoginNotificationFormEnableResponses, AdminLoginNotificationUpdateData, AdminLoginNotificationUpdateErrors, AdminLoginNotificationUpdateResponses, AdminLogsDesktopsActionData, AdminLogsDesktopsActionErrors, AdminLogsDesktopsActionResponses, AdminLogsDesktopsConfigData, AdminLogsDesktopsConfigErrors, AdminLogsDesktopsConfigResponses, AdminLogsDesktopsDeleteAllData, AdminLogsDesktopsDeleteAllErrors, AdminLogsDesktopsDeleteAllResponses, AdminLogsDesktopsDeleteData, AdminLogsDesktopsDeleteErrors, AdminLogsDesktopsDeleteResponses, AdminLogsDesktopsListData, AdminLogsDesktopsListErrors, AdminLogsDesktopsListResponses, AdminLogsDesktopsMaxTimeData, AdminLogsDesktopsMaxTimeErrors, AdminLogsDesktopsMaxTimeResponses, AdminLogsDesktopsRawData, AdminLogsDesktopsRawErrors, AdminLogsDesktopsRawResponses, AdminLogsDesktopsViewData, AdminLogsDesktopsViewErrors, AdminLogsDesktopsViewResponses, AdminLogsUsersActionData, AdminLogsUsersActionErrors, AdminLogsUsersActionResponses, AdminLogsUsersConfigData, AdminLogsUsersConfigErrors, AdminLogsUsersConfigResponses, AdminLogsUsersDeleteAllData, AdminLogsUsersDeleteAllErrors, AdminLogsUsersDeleteAllResponses, AdminLogsUsersDeleteData, AdminLogsUsersDeleteErrors, AdminLogsUsersDeleteResponses, AdminLogsUsersListData, AdminLogsUsersListErrors, AdminLogsUsersListResponses, AdminLogsUsersMaxTimeData, AdminLogsUsersMaxTimeErrors, AdminLogsUsersMaxTimeResponses, AdminLogsUsersRawData, AdminLogsUsersRawErrors, AdminLogsUsersRawResponses, AdminLogsUsersViewData, AdminLogsUsersViewErrors, AdminLogsUsersViewResponses, AdminMediaByStatusData, AdminMediaByStatusErrors, AdminMediaByStatusResponses, AdminMediaDomainsData, AdminMediaDomainsErrors, AdminMediaDomainsResponses, AdminMediaListData, AdminMediaListErrors, AdminMediaListResponses, AdminMediaStatusData, AdminMediaStatusErrors, AdminMediaStatusResponses, AdminMigrateUserData, AdminMigrateUserDeploymentsData, AdminMigrateUserDeploymentsErrors, AdminMigrateUserDeploymentsResponses, AdminMigrateUserDesktopsData, AdminMigrateUserDesktopsErrors, AdminMigrateUserDesktopsResponses, AdminMigrateUserErrors, AdminMigrateUserMediaData, AdminMigrateUserMediaErrors, AdminMigrateUserMediaResponses, AdminMigrateUserResponses, AdminMigrateUserTemplatesData, AdminMigrateUserTemplatesErrors, AdminMigrateUserTemplatesResponses, AdminMultipleActionsData2, AdminMultipleActionsErrors, AdminMultipleActionsResponses, AdminNotifyDesktopData, AdminNotifyDesktopErrors, AdminNotifyDesktopQueueData, AdminNotifyDesktopQueueErrors, AdminNotifyDesktopQueueResponses, AdminNotifyDesktopResponses, AdminNotifyUserDesktopData, AdminNotifyUserDesktopErrors, AdminNotifyUserDesktopResponses, AdminOperationsHypervisorsData, AdminOperationsHypervisorsErrors, AdminOperationsHypervisorsResponses, AdminOperationsHypervisorStartData, AdminOperationsHypervisorStartErrors, AdminOperationsHypervisorStartResponses, AdminOperationsHypervisorStopData, AdminOperationsHypervisorStopErrors, AdminOperationsHypervisorStopResponses, AdminOrchestratorConfigData, AdminOrchestratorConfigErrors, AdminOrchestratorConfigResponses, AdminOrchestratorConfigUpdateData, AdminOrchestratorConfigUpdateErrors, AdminOrchestratorConfigUpdateResponses, AdminOrchestratorDeadRowResetData, AdminOrchestratorDeadRowResetErrors, AdminOrchestratorDeadRowResetResponses, AdminOrchestratorDeadRowSetData, AdminOrchestratorDeadRowSetErrors, AdminOrchestratorDeadRowSetResponses, AdminOrchestratorHypervisorGetData, AdminOrchestratorHypervisorGetErrors, AdminOrchestratorHypervisorGetResponses, AdminOrchestratorHypervisorsListData, AdminOrchestratorHypervisorsListErrors, AdminOrchestratorHypervisorsListResponses, AdminOrchestratorManagedListData, AdminOrchestratorManagedListErrors, AdminOrchestratorManagedListResponses, AdminOrchestratorManageSetData, AdminOrchestratorManageSetErrors, AdminOrchestratorManageSetResponses, AdminOrchestratorManageUnsetData, AdminOrchestratorManageUnsetErrors, AdminOrchestratorManageUnsetResponses, AdminOrchestratorOnlyForcedSetData, AdminOrchestratorOnlyForcedSetErrors, AdminOrchestratorOnlyForcedSetResponses, AdminOrchestratorStopDesktopsData, AdminOrchestratorStopDesktopsErrors, AdminOrchestratorStopDesktopsResponses, AdminPreviewNotificationTemplateData, AdminPreviewNotificationTemplateErrors, AdminPreviewNotificationTemplateResponses, AdminQosDiskAddData, AdminQosDiskAddErrors, AdminQosDiskAddResponses, AdminQosDiskUpdateData, AdminQosDiskUpdateErrors, AdminQosDiskUpdateResponses, AdminQueuesBacklogData, AdminQueuesBacklogErrors, AdminQueuesBacklogResponses, AdminQueuesConsumersData, AdminQueuesConsumersErrors, AdminQueuesConsumersResponses, AdminQueuesGovernorData, AdminQueuesGovernorErrors, AdminQueuesGovernorResponses, AdminQueuesJobsData, AdminQueuesJobsErrors, AdminQueuesJobsResponses, AdminQueuesLaneHealthData, AdminQueuesLaneHealthErrors, AdminQueuesLaneHealthResponses, AdminQueuesProblemTasksData, AdminQueuesProblemTasksErrors, AdminQueuesProblemTasksResponses, AdminRegisterVlansData, AdminRegisterVlansErrors, AdminRegisterVlansResponses, AdminRemoteVpnData, AdminRemoteVpnErrors, AdminRemoteVpnResponses, AdminRemoteVpnWithOsData, AdminRemoteVpnWithOsErrors, AdminRemoteVpnWithOsResponses, AdminResetPasswordData, AdminResetPasswordErrors, AdminResetPasswordResponses, AdminResetVpnData, AdminResetVpnErrors, AdminResetVpnResponses, AdminSchedulerJobsBookingsData, AdminSchedulerJobsBookingsErrors, AdminSchedulerJobsBookingsResponses, AdminSchedulerJobsSystemData, AdminSchedulerJobsSystemErrors, AdminSchedulerJobsSystemResponses, AdminSearchUsersData, AdminSearchUsersErrors, AdminSearchUsersResponses, AdminSecondaryGroupsAddData, AdminSecondaryGroupsAddErrors, AdminSecondaryGroupsAddResponses, AdminSecondaryGroupsDeleteData, AdminSecondaryGroupsDeleteErrors, AdminSecondaryGroupsDeleteResponses, AdminSecondaryGroupsOverwriteData, AdminSecondaryGroupsOverwriteErrors, AdminSecondaryGroupsOverwriteResponses, AdminSetOldTasksEnabledData, AdminSetOldTasksEnabledErrors, AdminSetOldTasksEnabledResponses, AdminSetOldTasksMaxTimeData, AdminSetOldTasksMaxTimeErrors, AdminSetOldTasksMaxTimeResponses, AdminSetOldTasksQueueRegistriesData, AdminSetOldTasksQueueRegistriesErrors, AdminSetOldTasksQueueRegistriesResponses, AdminSetStorageSchedulerConfigData, AdminSetStorageSchedulerConfigErrors, AdminSetStorageSchedulerConfigResponses, AdminSmtpEnabledGetData, AdminSmtpEnabledGetErrors, AdminSmtpEnabledGetResponses, AdminSmtpGetData, AdminSmtpGetErrors, AdminSmtpGetResponses, AdminSmtpPutData, AdminSmtpPutErrors, AdminSmtpPutResponses, AdminSmtpTestPostData, AdminSmtpTestPostErrors, AdminSmtpTestPostResponses, AdminStorageByRoleData, AdminStorageByRoleErrors, AdminStorageByRoleResponses, AdminStorageByStatusData, AdminStorageByStatusErrors, AdminStorageByStatusFilteredData, AdminStorageByStatusFilteredErrors, AdminStorageByStatusFilteredResponses, AdminStorageByStatusResponses, AdminStorageDeleteData, AdminStorageDeleteErrors, AdminStorageDeleteResponses, AdminStorageDomainsData, AdminStorageDomainsErrors, AdminStorageDomainsResponses, AdminStorageInfoData, AdminStorageInfoErrors, AdminStorageInfoResponses, AdminStorageListData, AdminStorageListErrors, AdminStorageListFilteredData, AdminStorageListFilteredErrors, AdminStorageListFilteredResponses, AdminStorageListResponses, AdminStorageMigrationActionData, AdminStorageMigrationActionErrors, AdminStorageMigrationActionResponses, AdminStorageMigrationConfigData, AdminStorageMigrationConfigErrors, AdminStorageMigrationConfigResponses, AdminStorageMigrationCreateData, AdminStorageMigrationCreateErrors, AdminStorageMigrationCreateResponses, AdminStorageMigrationListData, AdminStorageMigrationListErrors, AdminStorageMigrationListResponses, AdminStorageMigrationLogData, AdminStorageMigrationLogErrors, AdminStorageMigrationLogResponses, AdminStorageMigrationPathPrefixesData, AdminStorageMigrationPathPrefixesErrors, AdminStorageMigrationPathPrefixesResponses, AdminStorageMigrationPlanData, AdminStorageMigrationPlanErrors, AdminStorageMigrationPlanResponses, AdminStorageMigrationStatusData, AdminStorageMigrationStatusErrors, AdminStorageMigrationStatusResponses, AdminStoragePoolMigrationPlanData, AdminStoragePoolMigrationPlanErrors, AdminStoragePoolMigrationPlanResponses, AdminStorageRefreshRunningSizesData, AdminStorageRefreshRunningSizesErrors, AdminStorageRefreshRunningSizesResponses, AdminStorageSearchInfoData, AdminStorageSearchInfoErrors, AdminStorageSearchInfoResponses, AdminStorageStatusData, AdminStorageStatusErrors, AdminStorageStatusResponses, AdminSystemLogoGetData, AdminSystemLogoGetErrors, AdminSystemLogoGetResponses, AdminSystemLogoPutData, AdminSystemLogoPutErrors, AdminSystemLogoPutResponses, AdminTableDeleteData, AdminTableDeleteErrors, AdminTableDeleteResponses, AdminTableGetData, AdminTableGetErrors, AdminTableGetResponses, AdminTableInsertData, AdminTableInsertErrors, AdminTableInsertResponses, AdminTableListData, AdminTableListErrors, AdminTableListResponses, AdminTableUpdateData, AdminTableUpdateErrors, AdminTableUpdateResponses, AdminTemplateDeleteData, AdminTemplateDeleteErrors, AdminTemplateDeleteResponses, AdminUpdateBastionDomainData, AdminUpdateBastionDomainErrors, AdminUpdateBastionDomainResponses, AdminUpdateCategoryData, AdminUpdateCategoryErrors, AdminUpdateCategoryLimitsData, AdminUpdateCategoryLimitsErrors, AdminUpdateCategoryLimitsResponses, AdminUpdateCategoryQuotaData, AdminUpdateCategoryQuotaErrors, AdminUpdateCategoryQuotaResponses, AdminUpdateCategoryResponses, AdminUpdateGroupData, AdminUpdateGroupErrors, AdminUpdateGroupLimitsData, AdminUpdateGroupLimitsErrors, AdminUpdateGroupLimitsResponses, AdminUpdateGroupQuotaData, AdminUpdateGroupQuotaErrors, AdminUpdateGroupQuotaResponses, AdminUpdateGroupResponses, AdminUpdateNotificationData, AdminUpdateNotificationErrors, AdminUpdateNotificationResponses, AdminUpdateNotificationTemplateData, AdminUpdateNotificationTemplateErrors, AdminUpdateNotificationTemplateResponses, AdminUpdateRoleData, AdminUpdateRoleErrors, AdminUpdateRoleResponses, AdminUpdateUserData, AdminUpdateUserErrors, AdminUpdateUserResponses, AdminUpdateUsersBulkData, AdminUpdateUsersBulkErrors, AdminUpdateUsersBulkResponses, AdminUsageAllCreditsData, AdminUsageAllCreditsErrors, AdminUsageAllCreditsResponses, AdminUsageCheckOverlappingData, AdminUsageCheckOverlappingErrors, AdminUsageCheckOverlappingResponses, AdminUsageConsolidateData, AdminUsageConsolidateErrors, AdminUsageConsolidateItemData, AdminUsageConsolidateItemDaysData, AdminUsageConsolidateItemDaysErrors, AdminUsageConsolidateItemDaysResponses, AdminUsageConsolidateItemErrors, AdminUsageConsolidateItemResponses, AdminUsageConsolidateResponses, AdminUsageConsumersCountData, AdminUsageConsumersCountErrors, AdminUsageConsumersCountResponses, AdminUsageConsumersData, AdminUsageConsumersErrors, AdminUsageConsumersResponses, AdminUsageConsumptionData, AdminUsageConsumptionErrors, AdminUsageConsumptionResponses, AdminUsageCreditsAddData, AdminUsageCreditsAddErrors, AdminUsageCreditsAddResponses, AdminUsageCreditsByIdData, AdminUsageCreditsByIdErrors, AdminUsageCreditsByIdResponses, AdminUsageCreditsData, AdminUsageCreditsDeleteData, AdminUsageCreditsDeleteErrors, AdminUsageCreditsDeleteResponses, AdminUsageCreditsErrors, AdminUsageCreditsResponses, AdminUsageCreditsUpdateData, AdminUsageCreditsUpdateErrors, AdminUsageCreditsUpdateResponses, AdminUsageDeleteConsumptionDataData, AdminUsageDeleteConsumptionDataErrors, AdminUsageDeleteConsumptionDataResponses, AdminUsageDistinctItemsData, AdminUsageDistinctItemsErrors, AdminUsageDistinctItemsResponses, AdminUsageGroupingGetData, AdminUsageGroupingGetErrors, AdminUsageGroupingGetResponses, AdminUsageGroupingsAddData, AdminUsageGroupingsAddErrors, AdminUsageGroupingsAddResponses, AdminUsageGroupingsDeleteData, AdminUsageGroupingsDeleteErrors, AdminUsageGroupingsDeleteResponses, AdminUsageGroupingsDropdownData, AdminUsageGroupingsDropdownErrors, AdminUsageGroupingsDropdownResponses, AdminUsageGroupingsListData, AdminUsageGroupingsListErrors, AdminUsageGroupingsListResponses, AdminUsageGroupingsUpdateData, AdminUsageGroupingsUpdateErrors, AdminUsageGroupingsUpdateResponses, AdminUsageLimitsAddData, AdminUsageLimitsAddErrors, AdminUsageLimitsAddResponses, AdminUsageLimitsDeleteData, AdminUsageLimitsDeleteErrors, AdminUsageLimitsDeleteResponses, AdminUsageLimitsListData, AdminUsageLimitsListErrors, AdminUsageLimitsListResponses, AdminUsageLimitsUpdateData, AdminUsageLimitsUpdateErrors, AdminUsageLimitsUpdateResponses, AdminUsageListParametersData, AdminUsageListParametersErrors, AdminUsageListParametersResponses, AdminUsageParametersAddData, AdminUsageParametersAddErrors, AdminUsageParametersAddResponses, AdminUsageParametersDeleteData, AdminUsageParametersDeleteErrors, AdminUsageParametersDeleteResponses, AdminUsageParametersListData, AdminUsageParametersListErrors, AdminUsageParametersListResponses, AdminUsageParametersUpdateData, AdminUsageParametersUpdateErrors, AdminUsageParametersUpdateResponses, AdminUsageResetDatesAddData, AdminUsageResetDatesAddErrors, AdminUsageResetDatesAddResponses, AdminUsageResetDatesAllData, AdminUsageResetDatesAllErrors, AdminUsageResetDatesAllResponses, AdminUsageResetDatesRangeData, AdminUsageResetDatesRangeErrors, AdminUsageResetDatesRangeResponses, AdminUsageRetentionGetData, AdminUsageRetentionGetErrors, AdminUsageRetentionGetResponses, AdminUsageRetentionUpdateData, AdminUsageRetentionUpdateErrors, AdminUsageRetentionUpdateResponses, AdminUsageStartEndData, AdminUsageStartEndErrors, AdminUsageStartEndResponses, AdminUsageUnifyItemNameData, AdminUsageUnifyItemNameErrors, AdminUsageUnifyItemNameResponses, AdminUserDeleteCheckData, AdminUserDeleteCheckErrors, AdminUserDeleteCheckResponses, AdminUserExistsData, AdminUserExistsErrors, AdminUserExistsResponses, AdminUserLogoutData, AdminUserLogoutErrors, AdminUserLogoutResponses, AdminUserStorageAddData, AdminUserStorageAddErrors, AdminUserStorageAddResponses, AdminUserStorageAutoRegisterData, AdminUserStorageAutoRegisterErrors, AdminUserStorageAutoRegisterResponses, AdminUserStorageGetData, AdminUserStorageGetErrors, AdminUserStorageGetResponses, AdminUserStorageListData, AdminUserStorageListErrors, AdminUserStorageListResponses, AdminUserStorageLoginAuthData, AdminUserStorageLoginAuthErrors, AdminUserStorageLoginAuthResponses, AdminUserStorageRemoveData, AdminUserStorageRemoveErrors, AdminUserStorageRemoveResponses, AdminUserStorageResetAllData, AdminUserStorageResetAllErrors, AdminUserStorageResetAllResponses, AdminUserStorageResetData, AdminUserStorageResetErrors, AdminUserStorageResetResponses, AdminUserStorageSyncData, AdminUserStorageSyncErrors, AdminUserStorageSyncResponses, AdminUserStorageTestData, AdminUserStorageTestErrors, AdminUserStorageTestResponses, AdminUserStorageUsersData, AdminUserStorageUsersErrors, AdminUserStorageUsersResponses, AdminValidateCsvUsersData, AdminValidateCsvUsersEditData, AdminValidateCsvUsersEditErrors, AdminValidateCsvUsersEditResponses, AdminValidateCsvUsersErrors, AdminValidateCsvUsersResponses, AdminViewersConfigData, AdminViewersConfigErrors, AdminViewersConfigResetData, AdminViewersConfigResetErrors, AdminViewersConfigResetResponses, AdminViewersConfigResponses, AdminViewersConfigUpdateData, AdminViewersConfigUpdateErrors, AdminViewersConfigUpdateResponses, AdminVirtInstallXmlSectionsGetData, AdminVirtInstallXmlSectionsGetErrors, AdminVirtInstallXmlSectionsGetResponses, AdminVirtInstallXmlSectionsSaveData, AdminVirtInstallXmlSectionsSaveErrors, AdminVirtInstallXmlSectionsSaveResponses, AllowedsTableTermData, AllowedsTableTermErrors, AllowedsTableTermResponses, AllowedTableData, AllowedTableErrors, AllowedTableResponses, AnalyticsDesktopsLessUsedData, AnalyticsDesktopsLessUsedErrors, AnalyticsDesktopsLessUsedResponses, AnalyticsDesktopsMostUsedData, AnalyticsDesktopsMostUsedErrors, AnalyticsDesktopsMostUsedResponses, AnalyticsDesktopsRecentlyUsedData, AnalyticsDesktopsRecentlyUsedErrors, AnalyticsDesktopsRecentlyUsedResponses, AnalyticsGraphConfAddData, AnalyticsGraphConfAddErrors, AnalyticsGraphConfAddResponses, AnalyticsGraphConfDeleteData, AnalyticsGraphConfDeleteErrors, AnalyticsGraphConfDeleteResponses, AnalyticsGraphConfGetData, AnalyticsGraphConfGetErrors, AnalyticsGraphConfGetResponses, AnalyticsGraphConfUpdateData, AnalyticsGraphConfUpdateErrors, AnalyticsGraphConfUpdateResponses, AnalyticsGraphsConfListData, AnalyticsGraphsConfListErrors, AnalyticsGraphsConfListResponses, AnalyticsResourceCountData, AnalyticsResourceCountErrors, AnalyticsResourceCountResponses, AnalyticsStorageData, AnalyticsStorageErrors, AnalyticsStorageResponses, AnalyticsSuggestedRemovalsData, AnalyticsSuggestedRemovalsErrors, AnalyticsSuggestedRemovalsResponses, ApiV4CategoriesData, ApiV4CategoriesErrors, ApiV4CategoriesResponses, ApiV4CategoryCustomUrlData, ApiV4CategoryCustomUrlErrors, ApiV4CategoryCustomUrlResponses, ApiV4CategoryData, ApiV4CategoryErrors, ApiV4CategoryResponses, ApiV4DisclaimerData, ApiV4DisclaimerErrors, ApiV4DisclaimerResponses, ApiV4LoginConfigData, ApiV4LoginConfigErrors, ApiV4LoginConfigResponses, ApiVersionData, ApiVersionResponses, BatchCheckBackingChainByStatusData, BatchCheckBackingChainByStatusErrors, BatchCheckBackingChainByStatusResponses, BatchCheckBackingChainData, BatchCheckBackingChainErrors, BatchCheckBackingChainResponses, BatchFindStoragesByStatusData, BatchFindStoragesByStatusErrors, BatchFindStoragesByStatusResponses, BatchFindStoragesData, BatchFindStoragesErrors, BatchFindStoragesResponses, BatchSparsifyStoragesByStatusData, BatchSparsifyStoragesByStatusErrors, BatchSparsifyStoragesByStatusResponses, BatchSparsifyStoragesData, BatchSparsifyStoragesErrors, BatchSparsifyStoragesResponses, BookingProvisioningData, BookingProvisioningErrors, BookingProvisioningResponses, BulkCreatePersistentDesktopsData, BulkCreatePersistentDesktopsErrors, BulkCreatePersistentDesktopsResponses, BulkDeleteDeploymentsData, BulkDeleteDeploymentsErrors, BulkDeleteDeploymentsResponses, BulkDeleteRecycleBinData, BulkDeleteRecycleBinErrors, BulkDeleteRecycleBinResponses, BulkEditDesktopsData, BulkEditDesktopsErrors, BulkEditDesktopsResponses, BulkRestoreRecycleBinData, BulkRestoreRecycleBinErrors, BulkRestoreRecycleBinResponses, CancelTaskData, CancelTaskErrors, CancelTaskResponses, ChangeDeploymentOwnerData, ChangeDeploymentOwnerErrors, ChangeDeploymentOwnerResponses, ChangeDesktopOwnerData, ChangeDesktopOwnerErrors, ChangeDesktopOwnerResponses, ChangeMediaOwnerData, ChangeMediaOwnerErrors, ChangeMediaOwnerResponses, ChangeTemplateOwnerData, ChangeTemplateOwnerErrors, ChangeTemplateOwnerResponses, CheckCategoryStoragePoolAvailabilityData, CheckCategoryStoragePoolAvailabilityErrors, CheckCategoryStoragePoolAvailabilityResponses, CheckDeploymentQuotaGetData, CheckDeploymentQuotaGetErrors, CheckDeploymentQuotaGetResponses, CheckDeploymentQuotaPostData, CheckDeploymentQuotaPostErrors, CheckDeploymentQuotaPostResponses, CheckIntegrityData, CheckIntegrityErrors, CheckIntegrityResponses, CheckLastItemData, CheckLastItemErrors, CheckLastItemResponses, CheckLastSubitemData, CheckLastSubitemErrors, CheckLastSubitemResponses, CheckMediaData, CheckMediaErrors, CheckMediaResponses, CheckQuotaNewDeploymentData, CheckQuotaNewDeploymentErrors, CheckQuotaNewDeploymentResponses, CheckQuotaNewDesktopData, CheckQuotaNewDesktopErrors, CheckQuotaNewDesktopResponses, CheckQuotaNewMediaData, CheckQuotaNewMediaErrors, CheckQuotaNewMediaResponses, CheckQuotaNewTemplateData, CheckQuotaNewTemplateErrors, CheckQuotaNewTemplateResponses, CheckQuotaNewVolatileDesktopData, CheckQuotaNewVolatileDesktopErrors, CheckQuotaNewVolatileDesktopResponses, CheckStorageBackingChainData, CheckStorageBackingChainErrors, CheckStorageBackingChainResponses, CheckStoragePoolAvailabilityCompatData, CheckStoragePoolAvailabilityCompatErrors, CheckStoragePoolAvailabilityCompatResponses, CheckStoragePoolCreationAvailabilityData, CheckStoragePoolCreationAvailabilityErrors, CheckStoragePoolCreationAvailabilityResponses, ConvertStorageData, ConvertStorageErrors, ConvertStorageResponses, ConvertTemplateToDesktopData, ConvertTemplateToDesktopErrors, ConvertTemplateToDesktopResponses, CountRecreateDeploymentDesktopsData, CountRecreateDeploymentDesktopsErrors, CountRecreateDeploymentDesktopsResponses, CreateBookingEventData, CreateBookingEventErrors, CreateBookingEventResponses, CreateDeploymentData, CreateDeploymentErrors, CreateDeploymentResponses, CreateDesktopData, CreateDesktopErrors, CreateDesktopFromMediaData, CreateDesktopFromMediaErrors, CreateDesktopFromMediaResponses, CreateDesktopResponses, CreateMediaData, CreateMediaErrors, CreateMediaResponses, CreateNonpersistentDesktopData, CreateNonpersistentDesktopErrors, CreateNonpersistentDesktopResponses, CreatePlanData, CreatePlanErrors, CreatePlanningData, CreatePlanningErrors, CreatePlanningResponses, CreatePlanResponses, CreateStorageData, CreateStorageErrors, CreateStoragePoolData, CreateStoragePoolErrors, CreateStoragePoolResponses, CreateStorageResponses, CreateTemplateData, CreateTemplateErrors, CreateTemplateResponses, CreateUnusedItemTimeoutRuleData, CreateUnusedItemTimeoutRuleErrors, CreateUnusedItemTimeoutRuleResponses, DeleteBookingEventData, DeleteBookingEventErrors, DeleteBookingEventResponses, DeleteCutoffTimeSurpassedData, DeleteCutoffTimeSurpassedErrors, DeleteCutoffTimeSurpassedResponses, DeleteDeploymentData, DeleteDeploymentErrors, DeleteDeploymentResponses, DeleteDesktopData, DeleteDesktopErrors, DeleteDesktopResponses, DeleteExpiredUserNotificationsDataData, DeleteExpiredUserNotificationsDataErrors, DeleteExpiredUserNotificationsDataResponses, DeleteMediaData, DeleteMediaErrors, DeleteMediaResponses, DeleteMigrationData, DeleteMigrationErrors, DeleteMigrationResponses, DeleteOldEntriesData, DeleteOldEntriesErrors, DeleteOldEntriesResponses, DeletePlanData, DeletePlanErrors, DeletePlanningData, DeletePlanningErrors, DeletePlanningResponses, DeletePlanResponses, DeletePriorityData, DeletePriorityErrors, DeletePriorityResponses, DeleteRecycleBinEntryData, DeleteRecycleBinEntryErrors, DeleteRecycleBinEntryResponses, DeleteReservableItemData, DeleteReservableItemErrors, DeleteReservableItemResponses, DeleteStorageData, DeleteStorageErrors, DeleteStoragePathData, DeleteStoragePathErrors, DeleteStoragePathResponses, DeleteStoragePoolData, DeleteStoragePoolErrors, DeleteStoragePoolResponses, DeleteStorageResponses, DeleteTemplateData, DeleteTemplateErrors, DeleteTemplateResponses, DeleteUnusedItemTimeoutRuleData, DeleteUnusedItemTimeoutRuleErrors, DeleteUnusedItemTimeoutRuleResponses, DeleteUserBastionSshKeyData, DeleteUserBastionSshKeyErrors, DeleteUserBastionSshKeyResponses, DeleteUserData, DeleteUserDeploymentDesktopsData, DeleteUserDeploymentDesktopsErrors, DeleteUserDeploymentDesktopsResponses, DeleteUserErrors, DeleteUserResponses, DisconnectStorageData, DisconnectStorageErrors, DisconnectStorageResponses, DuplicateTemplateData, DuplicateTemplateErrors, DuplicateTemplateResponses, EditDeploymentData, EditDeploymentErrors, EditDeploymentResponses, EditDeploymentUsersData, EditDeploymentUsersErrors, EditDeploymentUsersResponses, EditDesktopData, EditDesktopErrors, EditDesktopResponses, EditProviderConfigRouteData, EditProviderConfigRouteErrors, EditProviderConfigRouteResponses, EmptyBookingPlanData, EmptyBookingPlanErrors, EmptyBookingPlanResponses, EmptyRecycleBinData, EmptyRecycleBinErrors, EmptyRecycleBinResponses, EnableCategoryLoginNotificationData, EnableCategoryLoginNotificationErrors, EnableCategoryLoginNotificationResponses, EnableReservableSubitemData, EnableReservableSubitemErrors, EnableReservableSubitemResponses, ExpireUserApiKeyData, ExpireUserApiKeyErrors, ExpireUserApiKeyResponses, ExtendDesktopTimeoutData, ExtendDesktopTimeoutErrors, ExtendDesktopTimeoutResponses, FindStorageData, FindStorageErrors, FindStorageResponses, ForceStopDesktopData, ForceStopDesktopErrors, ForceStopDesktopResponses, GenerateDefaultCardData, GenerateDefaultCardErrors, GenerateDefaultCardResponses, GetActualPlanData, GetActualPlanErrors, GetActualPlanResponses, GetAdminBastionConfigData, GetAdminBastionConfigErrors, GetAdminBastionConfigResponses, GetAdminTasksData, GetAdminTasksErrors, GetAdminTasksResponses, GetAllBookingsData, GetAllBookingsErrors, GetAllBookingsResponses, GetAllDeploymentsData, GetAllDeploymentsErrors, GetAllDeploymentsResponses, GetAllDesktopsData, GetAllDesktopsErrors, GetAllDesktopsResponses, GetAllGroupsData, GetAllGroupsErrors, GetAllGroupsResponses, GetAllMigrationsData, GetAllMigrationsErrors, GetAllMigrationsResponses, GetAllowedHardwareData, GetAllowedHardwareErrors, GetAllowedHardwareForDomainData, GetAllowedHardwareForDomainErrors, GetAllowedHardwareForDomainResponses, GetAllowedHardwareResponses, GetAllSharedDeploymentsData, GetAllSharedDeploymentsErrors, GetAllSharedDeploymentsResponses, GetAllUnusedItemTimeoutRulesData, GetAllUnusedItemTimeoutRulesErrors, GetAllUnusedItemTimeoutRulesResponses, GetAllUsersData, GetAllUsersErrors, GetAllUsersResponses, GetAvailableGroupsForCategoryData, GetAvailableGroupsForCategoryErrors, GetAvailableGroupsForCategoryResponses, GetBastionAllowedData, GetBastionAllowedErrors, GetBastionAllowedResponses, GetBastionDomainVerificationConfigData, GetBastionDomainVerificationConfigErrors, GetBastionDomainVerificationConfigResponses, GetBastionTargetsData, GetBastionTargetsErrors, GetBastionTargetsResponses, GetBookingDeploymentData, GetBookingDeploymentErrors, GetBookingDeploymentResponses, GetBookingDesktopData, GetBookingDesktopErrors, GetBookingDesktopResponses, GetBookingPlansData, GetBookingPlansErrors, GetBookingPlansResponses, GetBookingPriorityDeploymentData, GetBookingPriorityDeploymentErrors, GetBookingPriorityDeploymentResponses, GetBookingPriorityDesktopData, GetBookingPriorityDesktopErrors, GetBookingPriorityDesktopResponses, GetBookingReservablesAvailableData, GetBookingReservablesAvailableErrors, GetBookingReservablesAvailableResponses, GetCategoryAuthenticationData, GetCategoryAuthenticationErrors, GetCategoryAuthenticationResponses, GetCategoryBrandingData, GetCategoryBrandingErrors, GetCategoryBrandingResponses, GetCategoryLogoCollapsedData, GetCategoryLogoCollapsedErrors, GetCategoryLogoCollapsedResponses, GetCategoryLogoData, GetCategoryLogoErrors, GetCategoryLogoResponses, GetCategoryMaintenanceData, GetCategoryMaintenanceErrors, GetCategoryMaintenanceResponses, GetDefaultStoragePoolData, GetDefaultStoragePoolErrors, GetDefaultStoragePoolResponses, GetDeleteActionData, GetDeleteActionErrors, GetDeleteActionResponses, GetDeploymentAllowedData, GetDeploymentAllowedErrors, GetDeploymentAllowedResponses, GetDeploymentBastionCsvData, GetDeploymentBastionCsvErrors, GetDeploymentBastionCsvResponses, GetDeploymentBastionData, GetDeploymentBastionErrors, GetDeploymentBastionResponses, GetDeploymentCoOwnersData, GetDeploymentCoOwnersErrors, GetDeploymentCoOwnersResponses, GetDeploymentCsvData, GetDeploymentCsvErrors, GetDeploymentCsvResponses, GetDeploymentData, GetDeploymentDesktopBastionData, GetDeploymentDesktopBastionErrors, GetDeploymentDesktopBastionResponses, GetDeploymentErrors, GetDeploymentHardwareData, GetDeploymentHardwareErrors, GetDeploymentHardwareResponses, GetDeploymentInfoData, GetDeploymentInfoErrors, GetDeploymentInfoResponses, GetDeploymentPermissionsData, GetDeploymentPermissionsErrors, GetDeploymentPermissionsResponses, GetDeploymentResponses, GetDeploymentUserDesktopsData, GetDeploymentUserDesktopsDetailData, GetDeploymentUserDesktopsDetailErrors, GetDeploymentUserDesktopsDetailResponses, GetDeploymentUserDesktopsErrors, GetDeploymentUserDesktopsResponses, GetDeploymentVideowallData, GetDeploymentVideowallErrors, GetDeploymentVideowallResponses, GetDesktopBastionActiveData, GetDesktopBastionActiveErrors, GetDesktopBastionActiveResponses, GetDesktopBastionData, GetDesktopBastionErrors, GetDesktopBastionLegacyData, GetDesktopBastionLegacyErrors, GetDesktopBastionLegacyResponses, GetDesktopBastionResponses, GetDesktopCardImagesData, GetDesktopCardImagesErrors, GetDesktopCardImagesResponses, GetDesktopData, GetDesktopDetailsData, GetDesktopDetailsErrors, GetDesktopDetailsFromTokenData, GetDesktopDetailsFromTokenErrors, GetDesktopDetailsFromTokenResponses, GetDesktopDetailsResponses, GetDesktopErrors, GetDesktopImagesByTypeData, GetDesktopImagesByTypeErrors, GetDesktopImagesByTypeResponses, GetDesktopImagesData, GetDesktopImagesErrors, GetDesktopImagesResponses, GetDesktopInfoData, GetDesktopInfoErrors, GetDesktopInfoResponses, GetDesktopNetworksData, GetDesktopNetworksErrors, GetDesktopNetworksResponses, GetDesktopResponses, GetDesktopViewerByTokenData, GetDesktopViewerByTokenErrors, GetDesktopViewerByTokenResponses, GetDesktopViewerByTypeData, GetDesktopViewerByTypeErrors, GetDesktopViewerByTypeResponses, GetDisclaimerData, GetDisclaimerErrors, GetDisclaimerResponses, GetDomainsAllowedReservablesData, GetDomainsAllowedReservablesErrors, GetDomainsAllowedReservablesResponses, GetGpuBookingsForecastData, GetGpuBookingsForecastErrors, GetGpuBookingsForecastResponses, GetHardwareKindAllowedData, GetHardwareKindAllowedErrors, GetHardwareKindAllowedResponses, GetItemAvailabilityData, GetItemAvailabilityErrors, GetItemAvailabilityResponses, GetItemPlanningsData, GetItemPlanningsErrors, GetItemPlanningsResponses, GetItemPlansData, GetItemPlansErrors, GetItemPlansResponses, GetLoginConfigByCategoryData, GetLoginConfigByCategoryErrors, GetLoginConfigByCategoryResponses, GetLogoCollapsedData, GetLogoCollapsedErrors, GetLogoCollapsedResponses, GetLogoData, GetLogoErrors, GetLogoResponses, GetMaintenanceData, GetMaintenanceErrors, GetMaintenanceResponses, GetMaintenanceTextData, GetMaintenanceTextErrors, GetMaintenanceTextFrontendData, GetMaintenanceTextFrontendErrors, GetMaintenanceTextFrontendResponses, GetMaintenanceTextResponses, GetMaxBookingDateData, GetMaxBookingDateErrors, GetMaxBookingDateResponses, GetMediaAllowedTableData, GetMediaAllowedTableErrors, GetMediaAllowedTableResponses, GetMediaData, GetMediaDesktopsData, GetMediaDesktopsErrors, GetMediaDesktopsResponses, GetMediaErrors, GetMediaInstallsData, GetMediaInstallsErrors, GetMediaInstallsResponses, GetMediaResponses, GetMediaTasksData, GetMediaTasksErrors, GetMediaTasksResponses, GetMigrationConfigData, GetMigrationConfigErrors, GetMigrationConfigResponses, GetNetworksFromTokenData, GetNetworksFromTokenErrors, GetNetworksFromTokenResponses, GetOldEntriesConfigData, GetOldEntriesConfigErrors, GetOldEntriesConfigResponses, GetPlanBookingsData, GetPlanBookingsErrors, GetPlanBookingsResponses, GetProviderConfigRouteData, GetProviderConfigRouteErrors, GetProviderConfigRouteResponses, GetProviderExportEnabledData, GetProviderExportEnabledErrors, GetProviderExportEnabledResponses, GetProviderImportEnabledData, GetProviderImportEnabledErrors, GetProviderImportEnabledResponses, GetQcow2GeometryData, GetQcow2GeometryErrors, GetQcow2GeometryResponses, GetQueuesHealthData, GetQueuesHealthErrors, GetQueuesHealthResponses, GetRecycleBinAdminEntriesData, GetRecycleBinAdminEntriesErrors, GetRecycleBinAdminEntriesResponses, GetRecycleBinCountData, GetRecycleBinCountErrors, GetRecycleBinCountResponses, GetRecycleBinCutoffTimeData, GetRecycleBinCutoffTimeErrors, GetRecycleBinCutoffTimeResponses, GetRecycleBinData, GetRecycleBinDefaultDeleteConfigData, GetRecycleBinDefaultDeleteConfigErrors, GetRecycleBinDefaultDeleteConfigResponses, GetRecycleBinErrors, GetRecycleBinItemCountUserData, GetRecycleBinItemCountUserErrors, GetRecycleBinItemCountUserResponses, GetRecycleBinResponses, GetRecycleBinStatusData, GetRecycleBinStatusErrors, GetRecycleBinStatusResponses, GetReservableItemsData, GetReservableItemsErrors, GetReservableItemsResponses, GetReservablesAvailableData, GetReservablesAvailableErrors, GetReservablesAvailableResponses, GetReservablesData, GetReservablesErrors, GetReservablesResponses, GetShareLinkData, GetShareLinkErrors, GetShareLinkResponses, GetStatusBarNotificationsData, GetStatusBarNotificationsErrors, GetStatusBarNotificationsResponses, GetStockDefaultCardData, GetStockDefaultCardErrors, GetStockDefaultCardResponses, GetStorageData, GetStorageErrors, GetStorageHasDerivativesData, GetStorageHasDerivativesErrors, GetStorageHasDerivativesResponses, GetStorageParentsData, GetStorageParentsErrors, GetStorageParentsResponses, GetStoragePoolByPathData, GetStoragePoolByPathErrors, GetStoragePoolByPathResponses, GetStoragePoolData, GetStoragePoolErrors, GetStoragePoolPendingData, GetStoragePoolPendingErrors, GetStoragePoolPendingResponses, GetStoragePoolResponses, GetStorageReadyData, GetStorageReadyErrors, GetStorageReadyResponses, GetStorageResponses, GetStorageStatusesData, GetStorageStatusesErrors, GetStorageStatusesResponses, GetStorageStoragesWithUuidData, GetStorageStoragesWithUuidErrors, GetStorageStoragesWithUuidResponses, GetStorageTaskData, GetStorageTaskErrors, GetStorageTaskResponses, GetStorageTasksData, GetStorageTasksErrors, GetStorageTasksResponses, GetSystemCutoffTimeData, GetSystemCutoffTimeErrors, GetSystemCutoffTimeResponses, GetTaskData, GetTaskErrors, GetTaskResponses, GetTemplateAllowedData, GetTemplateAllowedErrors, GetTemplateAllowedResponses, GetTemplateDetailsData, GetTemplateDetailsErrors, GetTemplateDetailsResponses, GetTemplateInfoData, GetTemplateInfoErrors, GetTemplateInfoResponses, GetTemplateNonpersistentDesktopData, GetTemplateNonpersistentDesktopErrors, GetTemplateNonpersistentDesktopResponses, GetTemplateTreeData, GetTemplateTreeErrors, GetTemplateTreeResponses, GetUnusedItemTimeoutRuleData, GetUnusedItemTimeoutRuleErrors, GetUnusedItemTimeoutRuleResponses, GetUserAllowedMediaData, GetUserAllowedMediaErrors, GetUserAllowedMediaResponses, GetUserAllowedTemplatesData, GetUserAllowedTemplatesErrors, GetUserAllowedTemplatesFlatData, GetUserAllowedTemplatesFlatErrors, GetUserAllowedTemplatesFlatResponses, GetUserAllowedTemplatesResponses, GetUserApiKeyData, GetUserApiKeyErrors, GetUserApiKeyResponses, GetUserAppliedQuotaData, GetUserAppliedQuotaErrors, GetUserAppliedQuotaResponses, GetUserBastionSshKeyData, GetUserBastionSshKeyErrors, GetUserBastionSshKeyResponses, GetUserBookingsData, GetUserBookingsErrors, GetUserBookingsResponses, GetUserConfigData, GetUserConfigErrors, GetUserConfigResponses, GetUserData, GetUserDefaultCardData, GetUserDefaultCardErrors, GetUserDefaultCardResponses, GetUserDesktopData, GetUserDesktopErrors, GetUserDesktopResponses, GetUserDesktopsData, GetUserDesktopsErrors, GetUserDesktopsLegacyData, GetUserDesktopsLegacyErrors, GetUserDesktopsLegacyResponses, GetUserDesktopsPaginatedData, GetUserDesktopsPaginatedErrors, GetUserDesktopsPaginatedResponses, GetUserDesktopsResponses, GetUserDetailsData, GetUserDetailsErrors, GetUserDetailsResponses, GetUserErrors, GetUserMediaData, GetUserMediaErrors, GetUserMediaResponses, GetUserNotificationDisplaysData, GetUserNotificationDisplaysErrors, GetUserNotificationDisplaysResponses, GetUserNotificationTriggerDisplayData, GetUserNotificationTriggerDisplayErrors, GetUserNotificationTriggerDisplayNestedData, GetUserNotificationTriggerDisplayNestedErrors, GetUserNotificationTriggerDisplayNestedResponses, GetUserNotificationTriggerDisplayResponses, GetUserPasswordPolicyData, GetUserPasswordPolicyErrors, GetUserPasswordPolicyResponses, GetUserQuotasData, GetUserQuotasErrors, GetUserQuotasResponses, GetUserReadyStoragesData, GetUserReadyStoragesErrors, GetUserReadyStoragesResponses, GetUserResponses, GetUserSharedMediaData, GetUserSharedMediaErrors, GetUserSharedMediaResponses, GetUserSharedTemplatesData, GetUserSharedTemplatesErrors, GetUserSharedTemplatesResponses, GetUsersInGroupData, GetUsersInGroupErrors, GetUsersInGroupResponses, GetUsersPrioritiesData, GetUsersPrioritiesErrors, GetUsersPrioritiesResponses, GetUserTasksData, GetUserTasksErrors, GetUserTasksResponses, GetUserTemplatesData, GetUserTemplatesErrors, GetUserTemplatesPaginatedData, GetUserTemplatesPaginatedErrors, GetUserTemplatesPaginatedResponses, GetUserTemplatesResponses, GetUserVpnByKindData, GetUserVpnByKindErrors, GetUserVpnByKindResponses, GetUserVpnData, GetUserVpnErrors, GetUserVpnResponses, GetUserVpnWithOsData, GetUserVpnWithOsErrors, GetUserVpnWithOsResponses, GetViewerDocsData, GetViewerDocsErrors, GetViewerDocsResponses, GetWebappDesktopsData, GetWebappDesktopsErrors, GetWebappDesktopsResponses, GetWebappTemplatesData, GetWebappTemplatesErrors, GetWebappTemplatesResponses, GroupsUsersCountData, GroupsUsersCountErrors, GroupsUsersCountResponses, IncreaseStorageSizeData, IncreaseStorageSizeErrors, IncreaseStorageSizeResponses, ListAllPlansData, ListAllPlansErrors, ListAllPlansResponses, ListAllStoragesWithUuidData, ListAllStoragesWithUuidErrors, ListAllStoragesWithUuidFilteredData, ListAllStoragesWithUuidFilteredErrors, ListAllStoragesWithUuidFilteredResponses, ListAllStoragesWithUuidResponses, ListAllStoragesWithUuidStatusData, ListAllStoragesWithUuidStatusErrors, ListAllStoragesWithUuidStatusResponses, ListBookablesData, ListBookablesErrors, ListBookablesResponses, ListDesktopAttachedMediaData, ListDesktopAttachedMediaErrors, ListDesktopAttachedMediaResponses, ListEnabledSubitemsData, ListEnabledSubitemsErrors, ListEnabledSubitemsResponses, ListPriorityRulesData, ListPriorityRulesErrors, ListPriorityRulesResponses, ListProfilesData, ListProfilesErrors, ListProfilesResponses, ListReservableSubitemsData, ListReservableSubitemsErrors, ListReservableSubitemsResponses, ListStoragePoolsData, ListStoragePoolsErrors, ListStoragePoolsResponses, ListStuckRecycleBinEntriesData, ListStuckRecycleBinEntriesErrors, ListStuckRecycleBinEntriesResponses, LogViewerClickData, LogViewerClickErrors, LogViewerClickResponses, MaintenanceStatusData, MaintenanceStatusErrors, MaintenanceStatusResponses, MigrationExportUserData, MigrationExportUserErrors, MigrationExportUserResponses, MigrationImportUserData, MigrationImportUserErrors, MigrationImportUserResponses, MigrationListItemsData, MigrationListItemsErrors, MigrationListItemsResponses, MigrationMigrateUserData, MigrationMigrateUserErrors, MigrationMigrateUserResponses, MoveStorageByPathData, MoveStorageByPathErrors, MoveStorageByPathResponses, RecoverStuckRecycleBinEntriesData, RecoverStuckRecycleBinEntriesErrors, RecoverStuckRecycleBinEntriesResponses, RecreateDeploymentData, RecreateDeploymentErrors, RecreateDeploymentResponses, RecreateDesktopData, RecreateDesktopErrors, RecreateDesktopResponses, RecreateStorageData, RecreateStorageErrors, RecreateStorageResponses, RecycleBinAddUnusedItemsData, RecycleBinAddUnusedItemsErrors, RecycleBinAddUnusedItemsResponses, RegisterUserData, RegisterUserErrors, RegisterUserResponses, RemoveDisallowedBastionTargetsData, RemoveDisallowedBastionTargetsErrors, RemoveDisallowedBastionTargetsResponses, RenewDesktopViewerByTokenData, RenewDesktopViewerByTokenErrors, RenewDesktopViewerByTokenResponses, ReRegisterUserData, ReRegisterUserErrors, ReRegisterUserResponses, ResetDesktopData, ResetDesktopErrors, ResetDesktopResponses, RestoreRecycleBinData, RestoreRecycleBinErrors, RestoreRecycleBinResponses, RetryAllFailedTasksData, RetryAllFailedTasksErrors, RetryAllFailedTasksResponses, RetryFailedDesktopData, RetryFailedDesktopErrors, RetryFailedDesktopResponses, RetryTaskData, RetryTaskErrors, RetryTaskResponses, RevokeMigrationData, RevokeMigrationErrors, RevokeMigrationResponses, RsyncStorageToPathData, RsyncStorageToPathErrors, RsyncStorageToPathResponses, RsyncStorageToStoragePoolData, RsyncStorageToStoragePoolErrors, RsyncStorageToStoragePoolResponses, SearchUsersInCategoryData, SearchUsersInCategoryErrors, SearchUsersInCategoryResponses, SetDefaultDeleteData, SetDefaultDeleteErrors, SetDefaultDeleteResponses, SetDeleteActionData, SetDeleteActionErrors, SetDeleteActionResponses, SetDeploymentBastionData, SetDeploymentBastionErrors, SetDeploymentBastionResponses, SetOldEntriesActionData, SetOldEntriesActionErrors, SetOldEntriesActionResponses, SetOldEntriesMaxTimeData, SetOldEntriesMaxTimeErrors, SetOldEntriesMaxTimeResponses, SetStorageMaintenanceData, SetStorageMaintenanceErrors, SetStorageMaintenanceResponses, SetStoragePathData, SetStoragePathErrors, SetStoragePathResponses, SetStorageReadyData, SetStorageReadyErrors, SetStorageReadyResponses, SetTemplateEnabledData, SetTemplateEnabledErrors, SetTemplateEnabledResponses, SetUserBastionSshKeyData, SetUserBastionSshKeyErrors, SetUserBastionSshKeyResponses, SetUserEmailData, SetUserEmailErrors, SetUserEmailResponses, SetUserLanguageData, SetUserLanguageErrors, SetUserLanguageResponses, SetUserPasswordData, SetUserPasswordErrors, SetUserPasswordResponses, SparsifyStorageData, SparsifyStorageErrors, SparsifyStorageResponses, StartAllDesktopsInDeploymentData, StartAllDesktopsInDeploymentErrors, StartAllDesktopsInDeploymentResponses, StartDesktopData, StartDesktopErrors, StartDesktopFromTokenData, StartDesktopFromTokenErrors, StartDesktopFromTokenResponses, StartDesktopResponses, StartMediaDownloadData, StartMediaDownloadErrors, StartMediaDownloadResponses, StatsCategoriesData, StatsCategoriesDeploymentsData, StatsCategoriesDeploymentsErrors, StatsCategoriesDeploymentsResponses, StatsCategoriesErrors, StatsCategoriesResponses, StatsDesktopsData, StatsDesktopsErrors, StatsDesktopsResponses, StatsDesktopsStatusData, StatsDesktopsStatusErrors, StatsDesktopsStatusResponses, StatsDomainsStatusData, StatsDomainsStatusErrors, StatsDomainsStatusResponses, StatsHypervisorsData, StatsHypervisorsErrors, StatsHypervisorsResponses, StatsTemplatesData, StatsTemplatesErrors, StatsTemplatesResponses, StatsUsersData, StatsUsersErrors, StatsUsersResponses, StopAllDesktopsInDeploymentData, StopAllDesktopsInDeploymentErrors, StopAllDesktopsInDeploymentResponses, StopDesktopData, StopDesktopErrors, StopDesktopResponses, StopDesktopsData, StopDesktopsErrors, StopDesktopsResponses, StopStorageDesktopsData, StopStorageDesktopsErrors, StopStorageDesktopsResponses, StopUserDesktopsInDeploymentData, StopUserDesktopsInDeploymentErrors, StopUserDesktopsInDeploymentResponses, ToggleDeploymentVisibilityData, ToggleDeploymentVisibilityErrors, ToggleDeploymentVisibilityResponses, ToggleDesktopDeploymentVisibilityData, ToggleDesktopDeploymentVisibilityErrors, ToggleDesktopDeploymentVisibilityResponses, ToggleDomainVisibilityData, ToggleDomainVisibilityErrors, ToggleDomainVisibilityResponses, ToggleTemplateEnabledData, ToggleTemplateEnabledErrors, ToggleTemplateEnabledResponses, UpdateBastionAuthorizedKeysData, UpdateBastionAuthorizedKeysErrors, UpdateBastionAuthorizedKeysResponses, UpdateBastionConfigData, UpdateBastionConfigErrors, UpdateBastionConfigResponses, UpdateBastionDomainsData, UpdateBastionDomainsErrors, UpdateBastionDomainsResponses, UpdateBookingEventData, UpdateBookingEventErrors, UpdateBookingEventResponses, UpdateCategoryAuthenticationData, UpdateCategoryAuthenticationErrors, UpdateCategoryAuthenticationResponses, UpdateCategoryBrandingData, UpdateCategoryBrandingErrors, UpdateCategoryBrandingResponses, UpdateCategoryLoginNotificationData, UpdateCategoryLoginNotificationErrors, UpdateCategoryLoginNotificationResponses, UpdateDeploymentCoOwnersData, UpdateDeploymentCoOwnersErrors, UpdateDeploymentCoOwnersResponses, UpdateDesktopBastionAuthorizedKeysData, UpdateDesktopBastionAuthorizedKeysErrors, UpdateDesktopBastionAuthorizedKeysResponses, UpdateDesktopBastionData, UpdateDesktopBastionDomainData, UpdateDesktopBastionDomainErrors, UpdateDesktopBastionDomainResponses, UpdateDesktopBastionDomainsData, UpdateDesktopBastionDomainsErrors, UpdateDesktopBastionDomainsResponses, UpdateDesktopBastionErrors, UpdateDesktopBastionResponses, UpdateMaintenanceData, UpdateMaintenanceErrors, UpdateMaintenanceResponses, UpdateMaintenanceTextData, UpdateMaintenanceTextErrors, UpdateMaintenanceTextResponses, UpdateMediaAllowedData, UpdateMediaAllowedErrors, UpdateMediaAllowedResponses, UpdateMigrationConfigData, UpdateMigrationConfigErrors, UpdateMigrationConfigResponses, UpdatePlanData, UpdatePlanErrors, UpdatePlanResponses, UpdateReservableItemData, UpdateReservableItemErrors, UpdateReservableItemResponses, UpdateShareLinkData, UpdateShareLinkErrors, UpdateShareLinkResponses, UpdateStatusDesktopData, UpdateStatusDesktopErrors, UpdateStatusDesktopResponses, UpdateStoragePoolData, UpdateStoragePoolErrors, UpdateStoragePoolResponses, UpdateSystemCutoffTimeData, UpdateSystemCutoffTimeErrors, UpdateSystemCutoffTimeResponses, UpdateTemplateAllowedData, UpdateTemplateAllowedErrors, UpdateTemplateAllowedResponses, UpdateTemplateData, UpdateTemplateErrors, UpdateTemplateResponses, UpdateUnusedItemTimeoutRuleData, UpdateUnusedItemTimeoutRuleErrors, UpdateUnusedItemTimeoutRuleResponses, UserOwnsDesktopData, UserOwnsDesktopErrors, UserOwnsDesktopResponses, UserResetVpnData, UserResetVpnErrors, UserResetVpnResponses, VerifyBastionDomainData, VerifyBastionDomainErrors, VerifyBastionDomainResponses, VerifyDesktopBastionDomainData, VerifyDesktopBastionDomainErrors, VerifyDesktopBastionDomainResponses, VirtWinRegStorageData, VirtWinRegStorageErrors, VirtWinRegStorageResponses, VpnConnectionConnectData, VpnConnectionConnectErrors, VpnConnectionConnectResponses, VpnConnectionDisconnectData, VpnConnectionDisconnectErrors, VpnConnectionDisconnectResponses, VpnConnectionResetData, VpnConnectionResetErrors, VpnConnectionResetResponses, VpnConnectionRoamData, VpnConnectionRoamErrors, VpnConnectionRoamResponses, VpnConnectionsDisconnectData, VpnConnectionsDisconnectErrors, VpnConnectionsDisconnectResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Get all categories
 *
 * Returns a list of all available categories.
 */
export const apiV4Categories = <ThrowOnError extends boolean = false>(options?: Options<ApiV4CategoriesData, ThrowOnError>) => (options?.client ?? client).get<ApiV4CategoriesResponses, ApiV4CategoriesErrors, ThrowOnError>({ url: '/api/v4/items/categories', ...options });

/**
 * Get category details
 *
 * Returns detailed information about a specific category.
 */
export const apiV4Category = <ThrowOnError extends boolean = false>(options: Options<ApiV4CategoryData, ThrowOnError>) => (options.client ?? client).get<ApiV4CategoryResponses, ApiV4CategoryErrors, ThrowOnError>({ url: '/api/v4/item/category/{custom_url}', ...options });

/**
 * Get login configuration
 *
 * Returns login page configuration including notifications.
 */
export const apiV4LoginConfig = <ThrowOnError extends boolean = false>(options?: Options<ApiV4LoginConfigData, ThrowOnError>) => (options?.client ?? client).get<ApiV4LoginConfigResponses, ApiV4LoginConfigErrors, ThrowOnError>({ url: '/api/v4/item/login-config', ...options });

/**
 * Get login config for category
 *
 * Returns login configuration for a specific category, falling back to global.
 */
export const getLoginConfigByCategory = <ThrowOnError extends boolean = false>(options: Options<GetLoginConfigByCategoryData, ThrowOnError>) => (options.client ?? client).get<GetLoginConfigByCategoryResponses, GetLoginConfigByCategoryErrors, ThrowOnError>({ url: '/api/v4/item/login-config/{category_id}', ...options });

/**
 * Get Maintenance Status
 *
 * Returns the current global maintenance status of the API.
 */
export const maintenanceStatus = <ThrowOnError extends boolean = false>(options?: Options<MaintenanceStatusData, ThrowOnError>) => (options?.client ?? client).get<MaintenanceStatusResponses, MaintenanceStatusErrors, ThrowOnError>({ url: '/api/v4/maintenance/status', ...options });

/**
 * Get maintenance text for frontend
 *
 * Returns the current maintenance text for frontend display.
 */
export const getMaintenanceTextFrontend = <ThrowOnError extends boolean = false>(options?: Options<GetMaintenanceTextFrontendData, ThrowOnError>) => (options?.client ?? client).get<GetMaintenanceTextFrontendResponses, GetMaintenanceTextFrontendErrors, ThrowOnError>({ url: '/api/v4/maintenance/text/frontend', ...options });

/**
 * Get API Version
 *
 * Returns the current version of the API and IsardVDI.
 */
export const apiVersion = <ThrowOnError extends boolean = false>(options?: Options<ApiVersionData, ThrowOnError>) => (options?.client ?? client).get<ApiVersionResponses, unknown, ThrowOnError>({ url: '/api/v4/', ...options });

/**
 * Get category custom login URL
 *
 * Returns the custom login URL for a specific category.
 */
export const apiV4CategoryCustomUrl = <ThrowOnError extends boolean = false>(options: Options<ApiV4CategoryCustomUrlData, ThrowOnError>) => (options.client ?? client).get<ApiV4CategoryCustomUrlResponses, ApiV4CategoryCustomUrlErrors, ThrowOnError>({ url: '/api/v4/item/category/{category_id}/custom_url', ...options });

/**
 * Get logo
 *
 * Returns the logo for the requesting domain. Falls back to the default logo.
 */
export const getLogo = <ThrowOnError extends boolean = false>(options?: Options<GetLogoData, ThrowOnError>) => (options?.client ?? client).get<GetLogoResponses, GetLogoErrors, ThrowOnError>({ url: '/api/v4/logo', ...options });

/**
 * Get category logo
 *
 * Returns the branding logo for a category. Falls back to the default logo.
 */
export const getCategoryLogo = <ThrowOnError extends boolean = false>(options: Options<GetCategoryLogoData, ThrowOnError>) => (options.client ?? client).get<GetCategoryLogoResponses, GetCategoryLogoErrors, ThrowOnError>({ url: '/api/v4/logo/category/{category_id}', ...options });

/**
 * Get collapsed logo
 *
 * Returns the collapsed-sidebar logo for the requesting domain. Falls back through the configured collapsed logo, then the configured full logo, and finally the bundled default collapsed logo.
 */
export const getLogoCollapsed = <ThrowOnError extends boolean = false>(options?: Options<GetLogoCollapsedData, ThrowOnError>) => (options?.client ?? client).get<GetLogoCollapsedResponses, GetLogoCollapsedErrors, ThrowOnError>({ url: '/api/v4/logo-collapsed', ...options });

/**
 * Get category collapsed logo
 *
 * Returns the collapsed-sidebar branding logo for a category. Falls back through the category's collapsed logo, then its full logo, and finally the bundled default collapsed logo.
 */
export const getCategoryLogoCollapsed = <ThrowOnError extends boolean = false>(options: Options<GetCategoryLogoCollapsedData, ThrowOnError>) => (options.client ?? client).get<GetCategoryLogoCollapsedResponses, GetCategoryLogoCollapsedErrors, ThrowOnError>({ url: '/api/v4/logo-collapsed/category/{category_id}', ...options });

/**
 * Get Desktop Viewer
 */
export const getDesktopViewerByToken = <ThrowOnError extends boolean = false>(options: Options<GetDesktopViewerByTokenData, ThrowOnError>) => (options.client ?? client).get<GetDesktopViewerByTokenResponses, GetDesktopViewerByTokenErrors, ThrowOnError>({ url: '/api/v4/item/desktop/token/{token}/get-viewer', ...options });

/**
 * Renew the viewer JWT of a direct viewer share token
 *
 * Returns the same payload as get-viewer with a freshly minted viewer JWT, so a long-lived direct viewer page can keep working past the token lifetime without a reload. Unlike get-viewer it never starts a stopped desktop and does not log a viewer access.
 */
export const renewDesktopViewerByToken = <ThrowOnError extends boolean = false>(options: Options<RenewDesktopViewerByTokenData, ThrowOnError>) => (options.client ?? client).get<RenewDesktopViewerByTokenResponses, RenewDesktopViewerByTokenErrors, ThrowOnError>({ url: '/api/v4/item/desktop/token/{token}/renew-viewer', ...options });

/**
 * Get viewer documentation URL
 *
 * Returns the URL for the viewer documentation
 */
export const getViewerDocs = <ThrowOnError extends boolean = false>(options?: Options<GetViewerDocsData, ThrowOnError>) => (options?.client ?? client).get<GetViewerDocsResponses, GetViewerDocsErrors, ThrowOnError>({ url: '/api/v4/item/desktop/get-viewers-docs', ...options });

/**
 * Log Viewer Click
 *
 * Log a direct viewer click event with the protocol used.
 */
export const logViewerClick = <ThrowOnError extends boolean = false>(options: Options<LogViewerClickData, ThrowOnError>) => (options.client ?? client).post<LogViewerClickResponses, LogViewerClickErrors, ThrowOnError>({ url: '/api/v4/item/desktop/token/{token}/viewer/{protocol}', ...options });

/**
 * Get user's bastion targets
 *
 * Returns a list of bastion target configurations for the user.
 *
 * @deprecated
 */
export const getBastionTargets = <ThrowOnError extends boolean = false>(options?: Options<GetBastionTargetsData, ThrowOnError>) => (options?.client ?? client).get<GetBastionTargetsResponses, GetBastionTargetsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/bastions',
    ...options
});

/**
 * Get bastion target for desktop
 *
 * Returns the bastion target configuration for a desktop. Creates an empty target if none exists.
 *
 * @deprecated
 */
export const getDesktopBastion = <ThrowOnError extends boolean = false>(options: Options<GetDesktopBastionData, ThrowOnError>) => (options.client ?? client).get<GetDesktopBastionResponses, GetDesktopBastionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/bastion',
    ...options
});

/**
 * Update bastion target for desktop
 *
 * Updates the bastion target configuration for a desktop. If the user cannot use individual domains, the domain field is cleared.
 *
 * @deprecated
 */
export const updateDesktopBastion = <ThrowOnError extends boolean = false>(options: Options<UpdateDesktopBastionData, ThrowOnError>) => (options.client ?? client).put<UpdateDesktopBastionResponses, UpdateDesktopBastionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/bastion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get read-only bastion status for a desktop
 *
 * Returns whether bastion SSH/HTTP access is enabled for the desktop, plus the data needed to render the read-only access links. Never creates a target, so it can be called lazily on demand for any desktop in any status.
 */
export const getDesktopBastionActive = <ThrowOnError extends boolean = false>(options: Options<GetDesktopBastionActiveData, ThrowOnError>) => (options.client ?? client).get<GetDesktopBastionActiveResponses, GetDesktopBastionActiveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/bastion/active',
    ...options
});

/**
 * Update bastion SSH authorized keys
 *
 * Updates the SSH authorized keys for a desktop's bastion target.
 */
export const updateBastionAuthorizedKeys = <ThrowOnError extends boolean = false>(options: Options<UpdateBastionAuthorizedKeysData, ThrowOnError>) => (options.client ?? client).put<UpdateBastionAuthorizedKeysResponses, UpdateBastionAuthorizedKeysErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/bastion/authorized-keys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update bastion custom domains
 *
 * Updates the custom domain names for a desktop's bastion target. New domains are verified via DNS if domain verification is required.
 */
export const updateBastionDomains = <ThrowOnError extends boolean = false>(options: Options<UpdateBastionDomainsData, ThrowOnError>) => (options.client ?? client).put<UpdateBastionDomainsResponses, UpdateBastionDomainsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/bastion/domains',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify bastion domain DNS
 *
 * Verifies a single domain's DNS configuration without saving. Returns success if the CNAME record is valid.
 *
 * @deprecated
 */
export const verifyBastionDomain = <ThrowOnError extends boolean = false>(options: Options<VerifyBastionDomainData, ThrowOnError>) => (options.client ?? client).post<VerifyBastionDomainResponses, VerifyBastionDomainErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/bastion/domain/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get desktop images
 *
 * Returns all available desktop images (stock + user).
 */
export const getDesktopCardImages = <ThrowOnError extends boolean = false>(options?: Options<GetDesktopCardImagesData, ThrowOnError>) => (options?.client ?? client).get<GetDesktopCardImagesResponses, GetDesktopCardImagesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/images/desktops',
    ...options
});

/**
 * Get desktop images by type
 *
 * Returns desktop images filtered by type (stock or user).
 *
 * @deprecated
 */
export const getDesktopImagesByType = <ThrowOnError extends boolean = false>(options: Options<GetDesktopImagesByTypeData, ThrowOnError>) => (options.client ?? client).get<GetDesktopImagesByTypeResponses, GetDesktopImagesByTypeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/images/desktops/{kind}',
    ...options
});

/**
 * Get default stock card for a domain
 *
 * Returns the default stock card image for a specific domain.
 *
 * @deprecated
 */
export const getStockDefaultCard = <ThrowOnError extends boolean = false>(options: Options<GetStockDefaultCardData, ThrowOnError>) => (options.client ?? client).get<GetStockDefaultCardResponses, GetStockDefaultCardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/images/desktops/stock/default/{domain_id}',
    ...options
});

/**
 * Get default user card for a domain
 *
 * Returns the default user card image for a specific domain.
 *
 * @deprecated
 */
export const getUserDefaultCard = <ThrowOnError extends boolean = false>(options: Options<GetUserDefaultCardData, ThrowOnError>) => (options.client ?? client).get<GetUserDefaultCardResponses, GetUserDefaultCardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/images/desktops/user/default/{domain_id}',
    ...options
});

/**
 * Stop all desktops from a user in a deployment
 *
 * Stop all started desktops from a user in a deployment.
 */
export const stopUserDesktopsInDeployment = <ThrowOnError extends boolean = false>(options: Options<StopUserDesktopsInDeploymentData, ThrowOnError>) => (options.client ?? client).put<StopUserDesktopsInDeploymentResponses, StopUserDesktopsInDeploymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/user/{user_id}/stop',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all shared deployments
 *
 * Returns all the deployments shared to the user in payload.
 */
export const getAllSharedDeployments = <ThrowOnError extends boolean = false>(options?: Options<GetAllSharedDeploymentsData, ThrowOnError>) => (options?.client ?? client).get<GetAllSharedDeploymentsResponses, GetAllSharedDeploymentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/deployments/get-shared',
    ...options
});

/**
 * Get all desktops in a deployment for a user
 *
 * Returns all desktops in a deployment for a specific user.
 */
export const getDeploymentUserDesktops = <ThrowOnError extends boolean = false>(options: Options<GetDeploymentUserDesktopsData, ThrowOnError>) => (options.client ?? client).get<GetDeploymentUserDesktopsResponses, GetDeploymentUserDesktopsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/desktops/user/{user_id}',
    ...options
});

/**
 * Get desktop details in a deployment for a user
 *
 * Returns the hardware, access, and configuration details of each desktop in a deployment for a specific user.
 */
export const getDeploymentUserDesktopsDetail = <ThrowOnError extends boolean = false>(options: Options<GetDeploymentUserDesktopsDetailData, ThrowOnError>) => (options.client ?? client).get<GetDeploymentUserDesktopsDetailResponses, GetDeploymentUserDesktopsDetailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/desktops/user/{user_id}/detail',
    ...options
});

/**
 * Delete a media item
 *
 * Deletes a media item and returns the task ID. ``@is_not_user`` — ownership is enforced by ``owns_media_id``.
 */
export const deleteMedia = <ThrowOnError extends boolean = false>(options: Options<DeleteMediaData, ThrowOnError>) => (options.client ?? client).delete<DeleteMediaResponses, DeleteMediaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/media/{media_id}',
    ...options
});

/**
 * Get details of a media
 *
 * Returns a media in IsardVDI based on an ID.
 */
export const getMedia = <ThrowOnError extends boolean = false>(options: Options<GetMediaData, ThrowOnError>) => (options.client ?? client).get<GetMediaResponses, GetMediaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/media/{media_id}',
    ...options
});

/**
 * Get the tasks a media has had
 *
 * Returns the tasks this media has had, newest first, read from the per-owner task index. Bounded: the index keeps the newest entries per row, and an entry whose job has expired is dropped on read rather than returned. Access is the media ownership dependency this route family already uses.
 */
export const getMediaTasks = <ThrowOnError extends boolean = false>(options: Options<GetMediaTasksData, ThrowOnError>) => (options.client ?? client).get<GetMediaTasksResponses, GetMediaTasksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/media/{media_id}/tasks',
    ...options
});

/**
 * Get user's media files
 *
 * Returns a list of media files belonging to the calling user. ``@has_token`` — the service filters by ``user_id`` so any logged-in user can call it.
 */
export const getUserMedia = <ThrowOnError extends boolean = false>(options?: Options<GetUserMediaData, ThrowOnError>) => (options?.client ?? client).get<GetUserMediaResponses, GetUserMediaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/media',
    ...options
});

/**
 * Get shared media for user
 *
 * Returns a list of all media that are shared with them.
 */
export const getUserSharedMedia = <ThrowOnError extends boolean = false>(options?: Options<GetUserSharedMediaData, ThrowOnError>) => (options?.client ?? client).get<GetUserSharedMediaResponses, GetUserSharedMediaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/media/get-shared',
    ...options
});

/**
 * Get allowed media for user
 *
 * Returns a list of all media that the user can see, considering its role permissions.
 */
export const getUserAllowedMedia = <ThrowOnError extends boolean = false>(options?: Options<GetUserAllowedMediaData, ThrowOnError>) => (options?.client ?? client).get<GetUserAllowedMediaResponses, GetUserAllowedMediaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/media/get-allowed',
    ...options
});

/**
 * Get desktops using a media item
 *
 * Returns a list of desktops using the given media item.
 */
export const getMediaDesktops = <ThrowOnError extends boolean = false>(options: Options<GetMediaDesktopsData, ThrowOnError>) => (options.client ?? client).get<GetMediaDesktopsResponses, GetMediaDesktopsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/media/{media_id}/get-desktops',
    ...options
});

/**
 * Import user data from a JWT token for migration purposes.
 *
 * Imports user data from a JWT token generated for migration to another IsardVDI user.
 */
export const migrationImportUser = <ThrowOnError extends boolean = false>(options: Options<MigrationImportUserData, ThrowOnError>) => (options.client ?? client).put<MigrationImportUserResponses, MigrationImportUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user-migration/import-user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List items available for user migration.
 *
 * Lists the items available for migration for the authenticated user.
 */
export const migrationListItems = <ThrowOnError extends boolean = false>(options?: Options<MigrationListItemsData, ThrowOnError>) => (options?.client ?? client).get<MigrationListItemsResponses, MigrationListItemsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user-migration/list-items',
    ...options
});

/**
 * Migrate user data from one user to another.
 *
 * Migrates user data from the source user to the user calling the endpoint.
 */
export const migrationMigrateUser = <ThrowOnError extends boolean = false>(options?: Options<MigrationMigrateUserData, ThrowOnError>) => (options?.client ?? client).post<MigrationMigrateUserResponses, MigrationMigrateUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user-migration/migrate-user',
    ...options
});

/**
 * Get status bar notification
 *
 * Returns the status-bar notification configured for the caller's provider (e.g. a migration banner). ``@has_token``.
 */
export const getStatusBarNotifications = <ThrowOnError extends boolean = false>(options?: Options<GetStatusBarNotificationsData, ThrowOnError>) => (options?.client ?? client).get<GetStatusBarNotificationsResponses, GetStatusBarNotificationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/notifications/status-bar',
    ...options
});

/**
 * Get user notification displays for a trigger
 *
 * Returns the user's notification displays for the specified trigger.
 */
export const getUserNotificationDisplays = <ThrowOnError extends boolean = false>(options: Options<GetUserNotificationDisplaysData, ThrowOnError>) => (options.client ?? client).get<GetUserNotificationDisplaysResponses, GetUserNotificationDisplaysErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/notifications/user/displays/{trigger}',
    ...options
});

/**
 * Get user notifications for a trigger and display
 *
 * Returns the user's notifications for the specified trigger and display as a flat, ordered list with the user's language template already resolved. Legacy consumers needing the nested grouping (by order and item_type) should use GET /api/v4/notification/user/{trigger}/{display}.
 */
export const getUserNotificationTriggerDisplay = <ThrowOnError extends boolean = false>(options: Options<GetUserNotificationTriggerDisplayData, ThrowOnError>) => (options.client ?? client).get<GetUserNotificationTriggerDisplayResponses, GetUserNotificationTriggerDisplayErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/notifications/user/{trigger}/{display}',
    ...options
});

/**
 * Get user notifications for a trigger and display (nested)
 *
 * Returns the user's notifications for the specified trigger and display as a nested dict grouped by order and item_type, with each group carrying its template. Matches the legacy apiv3 ``GET /api/v3/notification/user/<trigger>/<display>`` shape so Vue 2 and webapp consumers keep working after the v3 retirement. For new clients, prefer the flat variant at ``/items/notifications/user/{trigger}/{display}``. ``@has_token``.
 *
 * @deprecated
 */
export const getUserNotificationTriggerDisplayNested = <ThrowOnError extends boolean = false>(options: Options<GetUserNotificationTriggerDisplayNestedData, ThrowOnError>) => (options.client ?? client).get<GetUserNotificationTriggerDisplayNestedResponses, GetUserNotificationTriggerDisplayNestedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/notification/user/{trigger}/{display}',
    ...options
});

/**
 * Check desktops quota
 *
 * Checks if creating a new desktop would exceed the user's quota.
 */
export const checkQuotaNewDesktop = <ThrowOnError extends boolean = false>(options?: Options<CheckQuotaNewDesktopData, ThrowOnError>) => (options?.client ?? client).get<CheckQuotaNewDesktopResponses, CheckQuotaNewDesktopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/quota/desktop/new',
    ...options
});

/**
 * Check temporal desktops quota
 *
 * Checks if creating a new temporal desktop would exceed the user's quota.
 */
export const checkQuotaNewVolatileDesktop = <ThrowOnError extends boolean = false>(options?: Options<CheckQuotaNewVolatileDesktopData, ThrowOnError>) => (options?.client ?? client).get<CheckQuotaNewVolatileDesktopResponses, CheckQuotaNewVolatileDesktopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/quota/desktop/new-volatile',
    ...options
});

/**
 * Get recycle bin default delete configuration
 *
 * Returns the default delete configuration for recycle bin items.
 */
export const getRecycleBinDefaultDeleteConfig = <ThrowOnError extends boolean = false>(options?: Options<GetRecycleBinDefaultDeleteConfigData, ThrowOnError>) => (options?.client ?? client).get<GetRecycleBinDefaultDeleteConfigResponses, GetRecycleBinDefaultDeleteConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/recycle-bin/get-default-delete-config',
    ...options
});

/**
 * Get recycle bin cutoff time
 *
 * Returns the cutoff time for recycle bin items.
 */
export const getRecycleBinCutoffTime = <ThrowOnError extends boolean = false>(options?: Options<GetRecycleBinCutoffTimeData, ThrowOnError>) => (options?.client ?? client).get<GetRecycleBinCutoffTimeResponses, GetRecycleBinCutoffTimeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/recycle-bin/get-user-cutoff-time',
    ...options
});

/**
 * Get user recycle bin count
 *
 * Returns the total number of items in the user's recycle bin.
 */
export const getRecycleBinCount = <ThrowOnError extends boolean = false>(options?: Options<GetRecycleBinCountData, ThrowOnError>) => (options?.client ?? client).get<GetRecycleBinCountResponses, GetRecycleBinCountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/recycle-bin/count',
    ...options
});

/**
 * Empty recycle bin
 *
 * Empties the entire recycle bin.
 */
export const emptyRecycleBin = <ThrowOnError extends boolean = false>(options?: Options<EmptyRecycleBinData, ThrowOnError>) => (options?.client ?? client).delete<EmptyRecycleBinResponses, EmptyRecycleBinErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/recycle-bin/empty',
    ...options
});

/**
 * Get the user recycle bin entries
 *
 * Returns the list of recycle bin entries for a user.
 */
export const getRecycleBinItemCountUser = <ThrowOnError extends boolean = false>(options?: Options<GetRecycleBinItemCountUserData, ThrowOnError>) => (options?.client ?? client).get<GetRecycleBinItemCountUserResponses, GetRecycleBinItemCountUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/recycle-bin',
    ...options
});

/**
 * Delete recycle bin item
 *
 * Deletes a recycle bin item by ID.
 */
export const deleteRecycleBinEntry = <ThrowOnError extends boolean = false>(options: Options<DeleteRecycleBinEntryData, ThrowOnError>) => (options.client ?? client).delete<DeleteRecycleBinEntryResponses, DeleteRecycleBinEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/recycle-bin/{recycle_bin_id}',
    ...options
});

/**
 * Get recycle bin item details
 *
 * Returns detailed information about a specific recycle bin item.
 */
export const getRecycleBin = <ThrowOnError extends boolean = false>(options: Options<GetRecycleBinData, ThrowOnError>) => (options.client ?? client).get<GetRecycleBinResponses, GetRecycleBinErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/recycle-bin/{recycle_bin_id}',
    ...options
});

/**
 * Restore recycle bin item
 *
 * Restores a recycle bin item by ID.
 */
export const restoreRecycleBin = <ThrowOnError extends boolean = false>(options: Options<RestoreRecycleBinData, ThrowOnError>) => (options.client ?? client).put<RestoreRecycleBinResponses, RestoreRecycleBinErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/recycle-bin/{recycle_bin_id}/restore',
    ...options
});

/**
 * Bulk restore recycle bin items
 *
 * Restores multiple recycle bin items. Processing happens in the background.
 */
export const bulkRestoreRecycleBin = <ThrowOnError extends boolean = false>(options: Options<BulkRestoreRecycleBinData, ThrowOnError>) => (options.client ?? client).put<BulkRestoreRecycleBinResponses, BulkRestoreRecycleBinErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/recycle-bin/restore',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk delete recycle bin items
 *
 * Permanently deletes multiple recycle bin items. Processing happens in the background.
 */
export const bulkDeleteRecycleBin = <ThrowOnError extends boolean = false>(options: Options<BulkDeleteRecycleBinData, ThrowOnError>) => (options.client ?? client).put<BulkDeleteRecycleBinResponses, BulkDeleteRecycleBinErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/recycle-bin/delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a storage
 *
 * Deletes a storage item and returns the task ID.
 */
export const deleteStorage = <ThrowOnError extends boolean = false>(options: Options<DeleteStorageData, ThrowOnError>) => (options.client ?? client).delete<DeleteStorageResponses, DeleteStorageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}',
    ...options
});

/**
 * Get storage details
 *
 * Returns details of a storage item.
 */
export const getStorage = <ThrowOnError extends boolean = false>(options: Options<GetStorageData, ThrowOnError>) => (options.client ?? client).get<GetStorageResponses, GetStorageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}',
    ...options
});

/**
 * Get the tasks a storage has had
 *
 * Returns the tasks this storage item has had, newest first, read from the per-owner task index. Bounded: the index keeps the newest entries per row, and an entry whose job has expired is dropped on read rather than returned. Same ownership rules as every other per-item storage route.
 */
export const getStorageTasks = <ThrowOnError extends boolean = false>(options: Options<GetStorageTasksData, ThrowOnError>) => (options.client ?? client).get<GetStorageTasksResponses, GetStorageTasksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}/tasks',
    ...options
});

/**
 * Get user's ready disks
 *
 * Returns a list of ready storage items for the authenticated user.
 */
export const getUserReadyStorages = <ThrowOnError extends boolean = false>(options?: Options<GetUserReadyStoragesData, ThrowOnError>) => (options?.client ?? client).get<GetUserReadyStoragesResponses, GetUserReadyStoragesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/storage/ready',
    ...options
});

/**
 * Abort storage operations
 *
 * Aborts ongoing operations for a storage item.
 */
export const abortStorageOperations = <ThrowOnError extends boolean = false>(options: Options<AbortStorageOperationsData, ThrowOnError>) => (options.client ?? client).put<AbortStorageOperationsResponses, AbortStorageOperationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}/abort-operations',
    ...options
});

/**
 * Get ready storage items
 *
 * Returns the list of storage items in the ``ready`` state that belong to the calling user. ``@has_token``.
 */
export const getStorageReady = <ThrowOnError extends boolean = false>(options?: Options<GetStorageReadyData, ThrowOnError>) => (options?.client ?? client).get<GetStorageReadyResponses, GetStorageReadyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/storage/get-ready',
    ...options
});

/**
 * Check storage pool creation availability
 *
 * Checks if there's any storage pool category available for creating a new domain
 */
export const checkStoragePoolCreationAvailability = <ThrowOnError extends boolean = false>(options?: Options<CheckStoragePoolCreationAvailabilityData, ThrowOnError>) => (options?.client ?? client).get<CheckStoragePoolCreationAvailabilityResponses, CheckStoragePoolCreationAvailabilityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/storage-pools/check-create-availability',
    ...options
});

/**
 * Check storage pool availability
 *
 * Check if storage pools are available for the user's category.
 */
export const checkStoragePoolAvailabilityCompat = <ThrowOnError extends boolean = false>(options?: Options<CheckStoragePoolAvailabilityCompatData, ThrowOnError>) => (options?.client ?? client).get<CheckStoragePoolAvailabilityCompatResponses, CheckStoragePoolAvailabilityCompatErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/storage-pool/availability',
    ...options
});

/**
 * Storage-queue health for the current user
 *
 * A compact, user-safe view of storage-queue health: whether the system is degraded or has a consumer-less (stranded) lane, plus per-tier queued totals. No per-worker or admin detail. Used to drive a user banner.
 */
export const getQueuesHealth = <ThrowOnError extends boolean = false>(options?: Options<GetQueuesHealthData, ThrowOnError>) => (options?.client ?? client).get<GetQueuesHealthResponses, GetQueuesHealthErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/queues/health',
    ...options
});

/**
 * Cancel a task
 *
 * Cancels a task, and with it every job linked to it through dependencies. Only the task owner can cancel it, and only while the chain is still queued (428 otherwise). Best effort: a queued job drops immediately, a running body stops only if it cooperates by watching its cancel signal, and a body that does not watch runs to completion. Re-read the task rather than trust the 204.
 */
export const cancelTask = <ThrowOnError extends boolean = false>(options: Options<CancelTaskData, ThrowOnError>) => (options.client ?? client).delete<CancelTaskResponses, CancelTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/task/{task_id}',
    ...options
});

/**
 * Get a task
 *
 * Returns a task by its ID. Users can only see their own tasks.
 */
export const getTask = <ThrowOnError extends boolean = false>(options: Options<GetTaskData, ThrowOnError>) => (options.client ?? client).get<GetTaskResponses, GetTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/task/{task_id}',
    ...options
});

/**
 * Get user tasks
 *
 * Returns all tasks for the authenticated user.
 */
export const getUserTasks = <ThrowOnError extends boolean = false>(options?: Options<GetUserTasksData, ThrowOnError>) => (options?.client ?? client).get<GetUserTasksResponses, GetUserTasksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/tasks',
    ...options
});

/**
 * Get the user vpn
 *
 * Returns the VPN for the user.
 */
export const getUserVpn = <ThrowOnError extends boolean = false>(options?: Options<GetUserVpnData, ThrowOnError>) => (options?.client ?? client).get<GetUserVpnResponses, GetUserVpnErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/get-vpn',
    ...options
});

/**
 * Reset the user vpn
 *
 * Resets the VPN keys for the user.
 */
export const userResetVpn = <ThrowOnError extends boolean = false>(options?: Options<UserResetVpnData, ThrowOnError>) => (options?.client ?? client).put<UserResetVpnResponses, UserResetVpnErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/reset-vpn',
    ...options
});

/**
 * Get allowed hardware for the user
 *
 * Returns the hardware configurations allowed for the user.
 */
export const getAllowedHardware = <ThrowOnError extends boolean = false>(options?: Options<GetAllowedHardwareData, ThrowOnError>) => (options?.client ?? client).get<GetAllowedHardwareResponses, GetAllowedHardwareErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/get-allowed-hardware',
    ...options
});

/**
 * Get allowed hardware for the user considering a domain
 *
 * Returns the hardware configurations allowed for the user, taking into account the resources already used by the specified domain (so the caller can render an edit dialog with the domain's current resources available again).
 */
export const getAllowedHardwareForDomain = <ThrowOnError extends boolean = false>(options: Options<GetAllowedHardwareForDomainData, ThrowOnError>) => (options.client ?? client).get<GetAllowedHardwareForDomainResponses, GetAllowedHardwareForDomainErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/get-allowed-hardware/{domain_id}',
    ...options
});

/**
 * Delete current user
 *
 * Deletes the current user (self-deletion).
 */
export const deleteUser = <ThrowOnError extends boolean = false>(options?: Options<DeleteUserData, ThrowOnError>) => (options?.client ?? client).delete<DeleteUserResponses, DeleteUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user',
    ...options
});

/**
 * Get current user information
 *
 * Returns basic information about the current user.
 */
export const getUser = <ThrowOnError extends boolean = false>(options?: Options<GetUserData, ThrowOnError>) => (options?.client ?? client).get<GetUserResponses, GetUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user',
    ...options
});

/**
 * Get current user details
 *
 * Returns detailed information about the current user.
 */
export const getUserDetails = <ThrowOnError extends boolean = false>(options?: Options<GetUserDetailsData, ThrowOnError>) => (options?.client ?? client).get<GetUserDetailsResponses, GetUserDetailsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/get-details',
    ...options
});

/**
 * Get user quotas information
 *
 * Returns quotas information for the current user.
 */
export const getUserQuotas = <ThrowOnError extends boolean = false>(options?: Options<GetUserQuotasData, ThrowOnError>) => (options?.client ?? client).get<GetUserQuotasResponses, GetUserQuotasErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/get-quotas',
    ...options
});

/**
 * Get current user configuration
 *
 * Returns configuration settings for the current user.
 */
export const getUserConfig = <ThrowOnError extends boolean = false>(options?: Options<GetUserConfigData, ThrowOnError>) => (options?.client ?? client).get<GetUserConfigResponses, GetUserConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/get-config',
    ...options
});

/**
 * Set user language
 *
 * Sets the language for the specified user.
 */
export const setUserLanguage = <ThrowOnError extends boolean = false>(options: Options<SetUserLanguageData, ThrowOnError>) => (options.client ?? client).put<SetUserLanguageResponses, SetUserLanguageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/set-lang',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete the user's bastion SSH public key
 *
 * Removes the SSH public key stored on the user's profile, revoking the bastion access it granted. Copies of the key written into a desktop's authorized keys by earlier releases are left untouched and must be removed there.
 */
export const deleteUserBastionSshKey = <ThrowOnError extends boolean = false>(options?: Options<DeleteUserBastionSshKeyData, ThrowOnError>) => (options?.client ?? client).delete<DeleteUserBastionSshKeyResponses, DeleteUserBastionSshKeyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/bastion-ssh-key',
    ...options
});

/**
 * Get the user's bastion SSH public key
 *
 * Returns the single SSH public key stored on the user's profile. The bastion accepts it for any bastion-SSH desktop the user owns, and for the desktops of any deployment they own or co-own.
 */
export const getUserBastionSshKey = <ThrowOnError extends boolean = false>(options?: Options<GetUserBastionSshKeyData, ThrowOnError>) => (options?.client ?? client).get<GetUserBastionSshKeyResponses, GetUserBastionSshKeyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/bastion-ssh-key',
    ...options
});

/**
 * Set the user's bastion SSH public key
 *
 * Stores a single SSH public key on the user's profile. Replaces any existing key. The key is validated, and the bastion accepts it from then on for any bastion-SSH desktop the user owns, and for the desktops of any deployment they own or co-own.
 */
export const setUserBastionSshKey = <ThrowOnError extends boolean = false>(options: Options<SetUserBastionSshKeyData, ThrowOnError>) => (options.client ?? client).put<SetUserBastionSshKeyResponses, SetUserBastionSshKeyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/bastion-ssh-key',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set user password
 *
 * Sets the password for the user calling the endpoint.
 */
export const setUserPassword = <ThrowOnError extends boolean = false>(options: Options<SetUserPasswordData, ThrowOnError>) => (options.client ?? client).put<SetUserPasswordResponses, SetUserPasswordErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/set-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get user desktops
 *
 * Returns a list of desktops for the current user.
 */
export const getUserDesktopsLegacy = <ThrowOnError extends boolean = false>(options?: Options<GetUserDesktopsLegacyData, ThrowOnError>) => (options?.client ?? client).get<GetUserDesktopsLegacyResponses, GetUserDesktopsLegacyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/desktops',
    ...options
});

/**
 * Get specific desktop details
 *
 * Returns details of a specific desktop for the current user.
 */
export const getUserDesktop = <ThrowOnError extends boolean = false>(options: Options<GetUserDesktopData, ThrowOnError>) => (options.client ?? client).get<GetUserDesktopResponses, GetUserDesktopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/desktop/{desktop_id}',
    ...options
});

/**
 * Get VPN config with OS
 *
 * Returns VPN configuration for the user with the specified kind and OS.
 */
export const getUserVpnWithOs = <ThrowOnError extends boolean = false>(options: Options<GetUserVpnWithOsData, ThrowOnError>) => (options.client ?? client).get<GetUserVpnWithOsResponses, GetUserVpnWithOsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/vpn/{kind}/{os}',
    ...options
});

/**
 * Get VPN config
 *
 * Returns VPN configuration for the user with the specified kind.
 */
export const getUserVpnByKind = <ThrowOnError extends boolean = false>(options: Options<GetUserVpnByKindData, ThrowOnError>) => (options.client ?? client).get<GetUserVpnByKindResponses, GetUserVpnByKindErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/vpn/{kind}',
    ...options
});

/**
 * Get webapp desktops
 *
 * Returns webapp desktops for the current user.
 */
export const getWebappDesktops = <ThrowOnError extends boolean = false>(options?: Options<GetWebappDesktopsData, ThrowOnError>) => (options?.client ?? client).get<GetWebappDesktopsResponses, GetWebappDesktopsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/webapp-desktops',
    ...options
});

/**
 * Get webapp templates
 *
 * Returns webapp templates for the current user.
 */
export const getWebappTemplates = <ThrowOnError extends boolean = false>(options?: Options<GetWebappTemplatesData, ThrowOnError>) => (options?.client ?? client).get<GetWebappTemplatesResponses, GetWebappTemplatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/webapp-templates',
    ...options
});

/**
 * Get allowed hardware by kind
 *
 * Returns the allowed hardware configurations for a specific hardware kind.
 */
export const getHardwareKindAllowed = <ThrowOnError extends boolean = false>(options: Options<GetHardwareKindAllowedData, ThrowOnError>) => (options.client ?? client).get<GetHardwareKindAllowedResponses, GetHardwareKindAllowedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/hardware/{kind}/allowed',
    ...options
});

/**
 * Get applied quota
 *
 * Returns the applied quota for the current user.
 */
export const getUserAppliedQuota = <ThrowOnError extends boolean = false>(options?: Options<GetUserAppliedQuotaData, ThrowOnError>) => (options?.client ?? client).get<GetUserAppliedQuotaResponses, GetUserAppliedQuotaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/applied-quota',
    ...options
});

/**
 * Check bastion access
 *
 * Returns whether the current user is allowed to use bastion.
 */
export const getBastionAllowed = <ThrowOnError extends boolean = false>(options?: Options<GetBastionAllowedData, ThrowOnError>) => (options?.client ?? client).get<GetBastionAllowedResponses, GetBastionAllowedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/bastion-allowed',
    ...options
});

/**
 * Search table items by term
 *
 * Search for items in a table matching a term. Returns matching rows pluck'd to ``{id, name, ...}`` for typeahead autocompletes (the webapp's select2 ajax adapters at ``static/admin/js/{storage,desktops,authentication,...}.js`` iterate the response with ``$.map``, expecting a list).
 */
export const allowedsTableTerm = <ThrowOnError extends boolean = false>(options: Options<AllowedsTableTermData, ThrowOnError>) => (options.client ?? client).post<AllowedsTableTermResponses, AllowedsTableTermErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/alloweds/term/{table}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update allowed access for a table item
 *
 * Update the allowed access permissions (roles, categories, groups, users) for an item in the specified table. Handles special bastion table cases.
 */
export const adminAllowedUpdate = <ThrowOnError extends boolean = false>(options: Options<AdminAllowedUpdateData, ThrowOnError>) => (options.client ?? client).post<AdminAllowedUpdateResponses, AdminAllowedUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/allowed/update/{table}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get allowed access list for a table item
 *
 * Get the allowed access configuration for an item, enriched with names for roles, categories, groups, and users.
 */
export const allowedTable = <ThrowOnError extends boolean = false>(options: Options<AllowedTableData, ThrowOnError>) => (options.client ?? client).post<AllowedTableResponses, AllowedTableErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/allowed/table/{table}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get user bookings
 *
 * Returns a list of user bookings.
 */
export const getUserBookings = <ThrowOnError extends boolean = false>(options?: Options<GetUserBookingsData, ThrowOnError>) => (options?.client ?? client).get<GetUserBookingsResponses, GetUserBookingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/bookings',
    ...options
});

/**
 * Get desktop's bookings
 *
 * Returns the bookings for a specific desktop.
 */
export const getBookingDesktop = <ThrowOnError extends boolean = false>(options: Options<GetBookingDesktopData, ThrowOnError>) => (options.client ?? client).get<GetBookingDesktopResponses, GetBookingDesktopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/booking/get-desktop/{item_id}',
    ...options
});

/**
 * Get booking priority for a desktop
 *
 * Returns the calling user's booking priority profile and the desktop name. ``@has_token`` + ``ownsDomainId``.
 */
export const getBookingPriorityDesktop = <ThrowOnError extends boolean = false>(options: Options<GetBookingPriorityDesktopData, ThrowOnError>) => (options.client ?? client).get<GetBookingPriorityDesktopResponses, GetBookingPriorityDesktopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/bookings/get-priority-desktop/{item_id}',
    ...options
});

/**
 * Get booking priority for a deployment
 *
 * Returns the calling user's booking priority profile and the deployment name. ``@has_token`` + ``ownsDeploymentId``.
 */
export const getBookingPriorityDeployment = <ThrowOnError extends boolean = false>(options: Options<GetBookingPriorityDeploymentData, ThrowOnError>) => (options.client ?? client).get<GetBookingPriorityDeploymentResponses, GetBookingPriorityDeploymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/bookings/get-priority-deployment/{item_id}',
    ...options
});

/**
 * Delete booking event
 *
 * Deletes a booking event. ``@has_token`` + ``ownsBookingId``. Refuses to delete an in-progress booking while its desktop/deployment is still running.
 */
export const deleteBookingEvent = <ThrowOnError extends boolean = false>(options: Options<DeleteBookingEventData, ThrowOnError>) => (options.client ?? client).delete<DeleteBookingEventResponses, DeleteBookingEventErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/booking/event/{booking_id}',
    ...options
});

/**
 * Update booking event
 *
 * Edits an existing booking event's title and time window. ``@has_token`` + ``ownsBookingId``.
 */
export const updateBookingEvent = <ThrowOnError extends boolean = false>(options: Options<UpdateBookingEventData, ThrowOnError>) => (options.client ?? client).put<UpdateBookingEventResponses, UpdateBookingEventErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/booking/event/{booking_id}/edit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create booking event
 *
 * Creates a new booking event. ``@has_token`` + ``ownsDomainId``/``ownsDeploymentId`` on the booked item.
 */
export const createBookingEvent = <ThrowOnError extends boolean = false>(options: Options<CreateBookingEventData, ThrowOnError>) => (options.client ?? client).post<CreateBookingEventResponses, CreateBookingEventErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/booking/event',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get max booking date
 *
 * Returns the maximum booking date for a desktop. ``@has_token`` + ``ownsDomainId``.
 */
export const getMaxBookingDate = <ThrowOnError extends boolean = false>(options: Options<GetMaxBookingDateData, ThrowOnError>) => (options.client ?? client).get<GetMaxBookingDateResponses, GetMaxBookingDateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/booking/max-booking-date/{desktop_id}',
    ...options
});

/**
 * Get item availability
 *
 * Returns item availability by crossing info with the resource planner. ``@has_token`` + ``ownsDomainId``/``ownsDeploymentId``.
 */
export const getItemAvailability = <ThrowOnError extends boolean = false>(options: Options<GetItemAvailabilityData, ThrowOnError>) => (options.client ?? client).get<GetItemAvailabilityResponses, GetItemAvailabilityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/booking/availability/{item_type}/{item_id}',
    ...options
});

/**
 * Get available reservables
 *
 * Returns available reservables for the current user.
 */
export const getBookingReservablesAvailable = <ThrowOnError extends boolean = false>(options?: Options<GetBookingReservablesAvailableData, ThrowOnError>) => (options?.client ?? client).get<GetBookingReservablesAvailableResponses, GetBookingReservablesAvailableErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/booking/reservables-available',
    ...options
});

/**
 * Get booking reservables available
 *
 * Returns available reservables for booking.
 */
export const getReservablesAvailable = <ThrowOnError extends boolean = false>(options?: Options<GetReservablesAvailableData, ThrowOnError>) => (options?.client ?? client).get<GetReservablesAvailableResponses, GetReservablesAvailableErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/reservables/get-available',
    ...options
});

/**
 * Booking provisioning
 *
 * Determines where a new booking can be placed based on available resources.
 */
export const bookingProvisioning = <ThrowOnError extends boolean = false>(options: Options<BookingProvisioningData, ThrowOnError>) => (options.client ?? client).post<BookingProvisioningResponses, BookingProvisioningErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/reservables-planner/booking-provisioning',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get an url to share a desktop
 *
 * Returns a link to share an IsardVDI desktop based on an ID.
 */
export const getShareLink = <ThrowOnError extends boolean = false>(options: Options<GetShareLinkData, ThrowOnError>) => (options.client ?? client).get<GetShareLinkResponses, GetShareLinkErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/get-share-link',
    ...options
});

/**
 * Generate an link to share a desktop
 *
 * Generates a link to share an IsardVDI desktop based on an ID
 */
export const updateShareLink = <ThrowOnError extends boolean = false>(options: Options<UpdateShareLinkData, ThrowOnError>) => (options.client ?? client).put<UpdateShareLinkResponses, UpdateShareLinkErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/update-share-link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create (or reuse) a non-persistent desktop
 *
 * Creates and starts a non-persistent desktop from a template. Where the old frontend is still reachable an existing non-persistent desktop derived from the same template is reused (and started if stopped); only installations exposing the new frontend alone (``FRONTEND_MODE=actual``) may hold several, bounded by the ``volatile`` quota. ``@has_token`` — quota and allowlist checks are enforced server-side.
 */
export const createNonpersistentDesktop = <ThrowOnError extends boolean = false>(options: Options<CreateNonpersistentDesktopData, ThrowOnError>) => (options.client ?? client).post<CreateNonpersistentDesktopResponses, CreateNonpersistentDesktopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/new-nonpersistent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a desktop
 *
 * Creates a desktop with the given parameters.
 */
export const createDesktop = <ThrowOnError extends boolean = false>(options: Options<CreateDesktopData, ThrowOnError>) => (options.client ?? client).post<CreateDesktopResponses, CreateDesktopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a desktop
 *
 * Deletes desktop based on the desktop ID
 */
export const deleteDesktop = <ThrowOnError extends boolean = false>(options: Options<DeleteDesktopData, ThrowOnError>) => (options.client ?? client).delete<DeleteDesktopResponses, DeleteDesktopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}',
    ...options
});

/**
 * Get details of a desktop
 *
 * Returns a desktop in IsardVDI based on an ID.
 */
export const getDesktop = <ThrowOnError extends boolean = false>(options: Options<GetDesktopData, ThrowOnError>) => (options.client ?? client).get<GetDesktopResponses, GetDesktopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}',
    ...options
});

/**
 * Get details of a desktop networks
 *
 * Returns the networks information about a IsardVDI desktops based on an ID.
 */
export const getDesktopNetworks = <ThrowOnError extends boolean = false>(options: Options<GetDesktopNetworksData, ThrowOnError>) => (options.client ?? client).get<GetDesktopNetworksResponses, GetDesktopNetworksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/get-networks',
    ...options
});

/**
 * Get the details of a desktop
 *
 * Gets a desktop details based on the desktop ID
 */
export const getDesktopDetails = <ThrowOnError extends boolean = false>(options: Options<GetDesktopDetailsData, ThrowOnError>) => (options.client ?? client).get<GetDesktopDetailsResponses, GetDesktopDetailsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/get-details',
    ...options
});

/**
 * Get desktop bastion configuration
 *
 * Returns the bastion configuration for a desktop based on the desktop ID
 */
export const getDesktopBastionLegacy = <ThrowOnError extends boolean = false>(options: Options<GetDesktopBastionLegacyData, ThrowOnError>) => (options.client ?? client).get<GetDesktopBastionLegacyResponses, GetDesktopBastionLegacyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/get-bastion',
    ...options
});

/**
 * Update desktop bastion authorized keys
 *
 * Updates the authorized keys for the desktop bastion
 */
export const updateDesktopBastionAuthorizedKeys = <ThrowOnError extends boolean = false>(options: Options<UpdateDesktopBastionAuthorizedKeysData, ThrowOnError>) => (options.client ?? client).put<UpdateDesktopBastionAuthorizedKeysResponses, UpdateDesktopBastionAuthorizedKeysErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/update-bastion-authorized-keys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Extend desktop timeout
 *
 * Extend the remaining time before automatic desktop shutdown.
 */
export const extendDesktopTimeout = <ThrowOnError extends boolean = false>(options: Options<ExtendDesktopTimeoutData, ThrowOnError>) => (options.client ?? client).put<ExtendDesktopTimeoutResponses, ExtendDesktopTimeoutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/extend-timeout',
    ...options
});

/**
 * Stop a desktop
 *
 * Stops a desktop based on the desktop ID
 */
export const stopDesktop = <ThrowOnError extends boolean = false>(options: Options<StopDesktopData, ThrowOnError>) => (options.client ?? client).put<StopDesktopResponses, StopDesktopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/stop',
    ...options
});

/**
 * Stop all user desktops
 *
 * Stops all the desktops from the user
 */
export const stopDesktops = <ThrowOnError extends boolean = false>(options: Options<StopDesktopsData, ThrowOnError>) => (options.client ?? client).put<StopDesktopsResponses, StopDesktopsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/desktops/stop',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start a desktop
 *
 * Starts a desktop based on the desktop ID
 */
export const startDesktop = <ThrowOnError extends boolean = false>(options: Options<StartDesktopData, ThrowOnError>) => (options.client ?? client).put<StartDesktopResponses, StartDesktopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/start',
    ...options
});

/**
 * Updates a desktop status
 *
 * Updates the desktop status based on the desktop ID. Mainly used when desktop is Failed
 */
export const updateStatusDesktop = <ThrowOnError extends boolean = false>(options: Options<UpdateStatusDesktopData, ThrowOnError>) => (options.client ?? client).put<UpdateStatusDesktopResponses, UpdateStatusDesktopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/update-status',
    ...options
});

/**
 * Retry a Failed desktop
 *
 * Transitions a ``Failed`` desktop back to ``StartingPaused`` so the engine can validate it can start on a hypervisor again. Ports v3 ``GET /desktop/updating/{desktop_id}``. Ownership is enforced.
 */
export const retryFailedDesktop = <ThrowOnError extends boolean = false>(options: Options<RetryFailedDesktopData, ThrowOnError>) => (options.client ?? client).put<RetryFailedDesktopResponses, RetryFailedDesktopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/retry',
    ...options
});

/**
 * Force stop a desktop
 *
 * Force stops a desktop based on the desktop ID
 */
export const forceStopDesktop = <ThrowOnError extends boolean = false>(options: Options<ForceStopDesktopData, ThrowOnError>) => (options.client ?? client).put<ForceStopDesktopResponses, ForceStopDesktopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/force-stop',
    ...options
});

/**
 * Get available desktop images
 *
 * Returns available desktop images (stock and user cards)
 */
export const getDesktopImages = <ThrowOnError extends boolean = false>(options?: Options<GetDesktopImagesData, ThrowOnError>) => (options?.client ?? client).get<GetDesktopImagesResponses, GetDesktopImagesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/desktops/get-images',
    ...options
});

/**
 * Delete user desktops from a deployment
 *
 * Deletes all desktops belonging to one user inside a deployment
 */
export const deleteUserDeploymentDesktops = <ThrowOnError extends boolean = false>(options: Options<DeleteUserDeploymentDesktopsData, ThrowOnError>) => (options.client ?? client).delete<DeleteUserDeploymentDesktopsResponses, DeleteUserDeploymentDesktopsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{deployment_id}/{user_id}',
    ...options
});

/**
 * Get user desktops
 *
 * Returns a list of all desktops that belong to the user calling the endpoint.
 */
export const getUserDesktops = <ThrowOnError extends boolean = false>(options?: Options<GetUserDesktopsData, ThrowOnError>) => (options?.client ?? client).get<GetUserDesktopsResponses, GetUserDesktopsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/desktops',
    ...options
});

/**
 * Get user desktops
 *
 * Returns a list of all desktops that belong to the user calling the endpoint.
 */
export const getUserDesktopsPaginated = <ThrowOnError extends boolean = false>(options?: Options<GetUserDesktopsPaginatedData, ThrowOnError>) => (options?.client ?? client).get<GetUserDesktopsPaginatedResponses, GetUserDesktopsPaginatedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/paginated/desktops',
    ...options
});

/**
 * Get allowed reservables for the calling user
 *
 * Returns the reservable vGPUs visible to the calling user, filtered by category/group/role/user permissions.
 */
export const getDomainsAllowedReservables = <ThrowOnError extends boolean = false>(options?: Options<GetDomainsAllowedReservablesData, ThrowOnError>) => (options?.client ?? client).get<GetDomainsAllowedReservablesResponses, GetDomainsAllowedReservablesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/domains/get-allowed-reservables',
    ...options
});

/**
 * Create a desktop from media
 *
 * Creates a desktop from media with the given parameters. Available to any logged-in user; quota is enforced server-side.
 */
export const createDesktopFromMedia = <ThrowOnError extends boolean = false>(options: Options<CreateDesktopFromMediaData, ThrowOnError>) => (options.client ?? client).post<CreateDesktopFromMediaResponses, CreateDesktopFromMediaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/from-media',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get desktop information
 *
 * Returns detailed information about a specific desktop.
 */
export const getDesktopInfo = <ThrowOnError extends boolean = false>(options: Options<GetDesktopInfoData, ThrowOnError>) => (options.client ?? client).get<GetDesktopInfoResponses, GetDesktopInfoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/get-info',
    ...options
});

/**
 * Edit a desktop
 *
 * Updates a desktop with the given parameters.
 */
export const editDesktop = <ThrowOnError extends boolean = false>(options: Options<EditDesktopData, ThrowOnError>) => (options.client ?? client).put<EditDesktopResponses, EditDesktopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/edit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get desktop viewer connection string
 *
 * Returns the connection string for a specific viewer type for the given desktop.
 */
export const getDesktopViewerByType = <ThrowOnError extends boolean = false>(options: Options<GetDesktopViewerByTypeData, ThrowOnError>) => (options.client ?? client).get<GetDesktopViewerByTypeResponses, GetDesktopViewerByTypeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/get-viewer/{viewer_type}',
    ...options
});

/**
 * Recreate desktop disk
 *
 * Recreates the desktop disk from its parent template. Will delete the desktop storage and create a new one.
 */
export const recreateDesktop = <ThrowOnError extends boolean = false>(options: Options<RecreateDesktopData, ThrowOnError>) => (options.client ?? client).put<RecreateDesktopResponses, RecreateDesktopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/recreate',
    ...options
});

/**
 * Update desktop bastion domain
 *
 * Updates the domain name for the desktop's bastion target.
 */
export const updateDesktopBastionDomain = <ThrowOnError extends boolean = false>(options: Options<UpdateDesktopBastionDomainData, ThrowOnError>) => (options.client ?? client).put<UpdateDesktopBastionDomainResponses, UpdateDesktopBastionDomainErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/update-bastion-domain',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update desktop bastion domains (bulk)
 *
 * Replaces the list of individual bastion domains for a desktop. Up to 10 domains are allowed; newly added domains are DNS-verified against the category's CNAME before being saved.
 */
export const updateDesktopBastionDomains = <ThrowOnError extends boolean = false>(options: Options<UpdateDesktopBastionDomainsData, ThrowOnError>) => (options.client ?? client).put<UpdateDesktopBastionDomainsResponses, UpdateDesktopBastionDomainsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/update-bastion-domains',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * DNS-verify a single bastion domain without saving
 *
 * Checks that the DNS CNAME for the given candidate domain resolves to the expected target for this desktop's bastion category.
 */
export const verifyDesktopBastionDomain = <ThrowOnError extends boolean = false>(options: Options<VerifyDesktopBastionDomainData, ThrowOnError>) => (options.client ?? client).post<VerifyDesktopBastionDomainResponses, VerifyDesktopBastionDomainErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/verify-bastion-domain',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get template information
 *
 * Returns detailed information about a specific template.
 */
export const getTemplateInfo = <ThrowOnError extends boolean = false>(options: Options<GetTemplateInfoData, ThrowOnError>) => (options.client ?? client).get<GetTemplateInfoResponses, GetTemplateInfoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/template/{template_id}/get-info',
    ...options
});

/**
 * Get the details of a template
 *
 * Gets a template details based on the template ID
 */
export const getTemplateDetails = <ThrowOnError extends boolean = false>(options: Options<GetTemplateDetailsData, ThrowOnError>) => (options.client ?? client).get<GetTemplateDetailsResponses, GetTemplateDetailsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/template/{template_id}/get-details',
    ...options
});

/**
 * Get the non-persistent desktop this template would reuse
 *
 * Returns the user's non-persistent desktop derived from this template when creating another temporal desktop would reuse it instead of creating a new one, and ``null`` otherwise. Only installations still exposing the old frontend reuse, so this endpoint goes away with it.
 */
export const getTemplateNonpersistentDesktop = <ThrowOnError extends boolean = false>(options: Options<GetTemplateNonpersistentDesktopData, ThrowOnError>) => (options.client ?? client).get<GetTemplateNonpersistentDesktopResponses, GetTemplateNonpersistentDesktopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/template/{template_id}/get-nonpersistent-desktop',
    ...options
});

/**
 * Get flat list of templates the user can use
 *
 * Returns a flat list of enabled templates the caller is allowed to use. ``kind`` is one of ``all`` (owned + shared enabled templates) or ``shared`` (only templates shared with the user, not owned). Used by frontends that need a simple dropdown list without pagination. Replaces v3 ``GET /user/templates/allowed/{kind}`` ``@has_token``.
 */
export const getUserAllowedTemplatesFlat = <ThrowOnError extends boolean = false>(options: Options<GetUserAllowedTemplatesFlatData, ThrowOnError>) => (options.client ?? client).get<GetUserAllowedTemplatesFlatResponses, GetUserAllowedTemplatesFlatErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/templates/allowed/{kind}',
    ...options
});

/**
 * Get shared templates for user
 *
 * Returns a list of all templates that are shared with them.
 */
export const getUserSharedTemplates = <ThrowOnError extends boolean = false>(options?: Options<GetUserSharedTemplatesData, ThrowOnError>) => (options?.client ?? client).get<GetUserSharedTemplatesResponses, GetUserSharedTemplatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/templates/get-shared',
    ...options
});

/**
 * Get allowed templates for user
 *
 * Returns a list of all templates that the user can see, considering its role permissions.
 */
export const getUserAllowedTemplates = <ThrowOnError extends boolean = false>(options?: Options<GetUserAllowedTemplatesData, ThrowOnError>) => (options?.client ?? client).get<GetUserAllowedTemplatesResponses, GetUserAllowedTemplatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/templates/get-allowed',
    ...options
});

/**
 * Get users in the user category
 *
 * Returns a list of users in a specific category.
 */
export const searchUsersInCategory = <ThrowOnError extends boolean = false>(options: Options<SearchUsersInCategoryData, ThrowOnError>) => (options.client ?? client).get<SearchUsersInCategoryResponses, SearchUsersInCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/category/users/search',
    ...options
});

/**
 * Get available groups for a category
 *
 * Returns a list of available groups for a specific category.
 */
export const getAvailableGroupsForCategory = <ThrowOnError extends boolean = false>(options?: Options<GetAvailableGroupsForCategoryData, ThrowOnError>) => (options?.client ?? client).get<GetAvailableGroupsForCategoryResponses, GetAvailableGroupsForCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/category/allowed/get-available-groups',
    ...options
});

/**
 * Bulk delete deployments
 *
 * Deletes multiple deployments. Optionally permanently.
 */
export const bulkDeleteDeployments = <ThrowOnError extends boolean = false>(options: Options<BulkDeleteDeploymentsData, ThrowOnError>) => (options.client ?? client).delete<BulkDeleteDeploymentsResponses, BulkDeleteDeploymentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/deployments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all owned deployments
 *
 * Returns all the deployments that the user in the payload is owner or co-owner.
 */
export const getAllDeployments = <ThrowOnError extends boolean = false>(options?: Options<GetAllDeploymentsData, ThrowOnError>) => (options?.client ?? client).get<GetAllDeploymentsResponses, GetAllDeploymentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/deployments',
    ...options
});

/**
 * Check deployment creation quota
 *
 * Checks if the user has enough quota to create a new deployment.
 */
export const checkDeploymentQuotaGet = <ThrowOnError extends boolean = false>(options?: Options<CheckDeploymentQuotaGetData, ThrowOnError>) => (options?.client ?? client).get<CheckDeploymentQuotaGetResponses, CheckDeploymentQuotaGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/check-quota',
    ...options
});

/**
 * Check deployment creation quota with allowed users
 *
 * Checks if the user has enough quota to create a new deployment with the given allowed users.
 */
export const checkDeploymentQuotaPost = <ThrowOnError extends boolean = false>(options: Options<CheckDeploymentQuotaPostData, ThrowOnError>) => (options.client ?? client).post<CheckDeploymentQuotaPostResponses, CheckDeploymentQuotaPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/check-quota',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a deployment
 *
 * Deletes a deployment and all it's desktops permanently.
 */
export const deleteDeployment = <ThrowOnError extends boolean = false>(options: Options<DeleteDeploymentData, ThrowOnError>) => (options.client ?? client).delete<DeleteDeploymentResponses, DeleteDeploymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}',
    ...options
});

/**
 * Get details of a deployment
 *
 * Returns a deployment based on an ID.
 */
export const getDeployment = <ThrowOnError extends boolean = false>(options: Options<GetDeploymentData, ThrowOnError>) => (options.client ?? client).get<GetDeploymentResponses, GetDeploymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}',
    ...options
});

/**
 * Create a new deployment
 *
 * Creates a new deployment with the provided data.
 */
export const createDeployment = <ThrowOnError extends boolean = false>(options: Options<CreateDeploymentData, ThrowOnError>) => (options.client ?? client).post<CreateDeploymentResponses, CreateDeploymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stop all desktops from a deployment
 *
 * Stop all started desktops from a deployment.
 */
export const stopAllDesktopsInDeployment = <ThrowOnError extends boolean = false>(options: Options<StopAllDesktopsInDeploymentData, ThrowOnError>) => (options.client ?? client).put<StopAllDesktopsInDeploymentResponses, StopAllDesktopsInDeploymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/stop',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Toggle deployment visibility
 *
 * Toggles the visibility of the deployment with the given ID.
 */
export const toggleDeploymentVisibility = <ThrowOnError extends boolean = false>(options: Options<ToggleDeploymentVisibilityData, ThrowOnError>) => (options.client ?? client).put<ToggleDeploymentVisibilityResponses, ToggleDeploymentVisibilityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/toggle-visibility',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Edit an existing deployment. Designed to be used via form
 *
 * Edits an existing deployment with the provided data.
 */
export const editDeployment = <ThrowOnError extends boolean = false>(options: Options<EditDeploymentData, ThrowOnError>) => (options.client ?? client).put<EditDeploymentResponses, EditDeploymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/edit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export direct viewer URLs as CSV
 *
 * Generates a CSV file with direct viewer URLs for all desktops in the deployment
 */
export const getDeploymentCsv = <ThrowOnError extends boolean = false>(options: Options<GetDeploymentCsvData, ThrowOnError>) => (options.client ?? client).get<GetDeploymentCsvResponses, GetDeploymentCsvErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/download-csv',
    ...options
});

/**
 * Count the desktops a deployment recreate would create
 *
 * Returns how many desktops a recreate would create, so the confirmation shown to the user matches what will actually be created.
 */
export const countRecreateDeploymentDesktops = <ThrowOnError extends boolean = false>(options: Options<CountRecreateDeploymentDesktopsData, ThrowOnError>) => (options.client ?? client).get<CountRecreateDeploymentDesktopsResponses, CountRecreateDeploymentDesktopsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/recreate/count',
    ...options
});

/**
 * Recreate a deployment
 *
 * Creates the desktops that are missing for the deployment's currently allowed users. Existing desktops are left untouched.
 */
export const recreateDeployment = <ThrowOnError extends boolean = false>(options: Options<RecreateDeploymentData, ThrowOnError>) => (options.client ?? client).put<RecreateDeploymentResponses, RecreateDeploymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/recreate',
    ...options
});

/**
 * Get deployment bastion configuration
 *
 * Returns the deployment-level bastion configuration (ssh/http enable + ports).
 */
export const getDeploymentBastion = <ThrowOnError extends boolean = false>(options: Options<GetDeploymentBastionData, ThrowOnError>) => (options.client ?? client).get<GetDeploymentBastionResponses, GetDeploymentBastionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/bastion',
    ...options
});

/**
 * Set deployment bastion configuration
 *
 * Persists the deployment-level bastion configuration and applies it (ssh/http enable + ports) to every desktop in the deployment. Each user's profile SSH key is added automatically when their desktop starts.
 */
export const setDeploymentBastion = <ThrowOnError extends boolean = false>(options: Options<SetDeploymentBastionData, ThrowOnError>) => (options.client ?? client).put<SetDeploymentBastionResponses, SetDeploymentBastionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/bastion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export deployment bastion data as CSV
 *
 * Generates a CSV with bastion connection info for every desktop in the deployment.
 */
export const getDeploymentBastionCsv = <ThrowOnError extends boolean = false>(options: Options<GetDeploymentBastionCsvData, ThrowOnError>) => (options.client ?? client).get<GetDeploymentBastionCsvResponses, GetDeploymentBastionCsvErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/bastion/csv',
    ...options
});

/**
 * Get a deployment desktop's bastion status
 *
 * Read-only bastion status of a single desktop in the deployment, for the deployment owner and co-owners (who are not the desktop's own owner).
 */
export const getDeploymentDesktopBastion = <ThrowOnError extends boolean = false>(options: Options<GetDeploymentDesktopBastionData, ThrowOnError>) => (options.client ?? client).get<GetDeploymentDesktopBastionResponses, GetDeploymentDesktopBastionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/desktop/{desktop_id}/bastion',
    ...options
});

/**
 * Get deployment with videowall support
 *
 * Returns a deployment with its desktops for videowall (lab) display.
 */
export const getDeploymentVideowall = <ThrowOnError extends boolean = false>(options: Options<GetDeploymentVideowallData, ThrowOnError>) => (options.client ?? client).get<GetDeploymentVideowallResponses, GetDeploymentVideowallErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/videowall',
    ...options
});

/**
 * Start all desktops in a deployment
 *
 * Start all stopped desktops in a deployment.
 */
export const startAllDesktopsInDeployment = <ThrowOnError extends boolean = false>(options: Options<StartAllDesktopsInDeploymentData, ThrowOnError>) => (options.client ?? client).put<StartAllDesktopsInDeploymentResponses, StartAllDesktopsInDeploymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/start',
    ...options
});

/**
 * Toggle individual domain visibility
 *
 * Toggles the visibility of a specific domain within a deployment.
 */
export const toggleDomainVisibility = <ThrowOnError extends boolean = false>(options: Options<ToggleDomainVisibilityData, ThrowOnError>) => (options.client ?? client).put<ToggleDomainVisibilityResponses, ToggleDomainVisibilityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/domain/{domain_id}/toggle-visibility',
    ...options
});

/**
 * Toggle deployment domain visibility (by desktop id)
 *
 * Toggles the ``tag_visible`` flag of a deployment desktop, identified by the desktop id alone. ``@is_not_user`` — doesn't require the deployment id in the path. Use the sibling route with the deployment id when the caller has it at hand.
 */
export const toggleDesktopDeploymentVisibility = <ThrowOnError extends boolean = false>(options: Options<ToggleDesktopDeploymentVisibilityData, ThrowOnError>) => (options.client ?? client).put<ToggleDesktopDeploymentVisibilityResponses, ToggleDesktopDeploymentVisibilityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/toggle-deployment-visibility',
    ...options
});

/**
 * Get deployment hardware details
 *
 * Returns the hardware configuration details of a deployment.
 */
export const getDeploymentHardware = <ThrowOnError extends boolean = false>(options: Options<GetDeploymentHardwareData, ThrowOnError>) => (options.client ?? client).get<GetDeploymentHardwareResponses, GetDeploymentHardwareErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/hardware',
    ...options
});

/**
 * Get deployment info with quota limits
 *
 * Returns deployment info with hardware limited by user quota.
 */
export const getDeploymentInfo = <ThrowOnError extends boolean = false>(options: Options<GetDeploymentInfoData, ThrowOnError>) => (options.client ?? client).get<GetDeploymentInfoResponses, GetDeploymentInfoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/info',
    ...options
});

/**
 * Get deployment co-owners
 *
 * Returns the list of co-owners of a deployment.
 */
export const getDeploymentCoOwners = <ThrowOnError extends boolean = false>(options: Options<GetDeploymentCoOwnersData, ThrowOnError>) => (options.client ?? client).get<GetDeploymentCoOwnersResponses, GetDeploymentCoOwnersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/co-owners',
    ...options
});

/**
 * Update deployment co-owners
 *
 * Updates the list of co-owners of a deployment.
 */
export const updateDeploymentCoOwners = <ThrowOnError extends boolean = false>(options: Options<UpdateDeploymentCoOwnersData, ThrowOnError>) => (options.client ?? client).put<UpdateDeploymentCoOwnersResponses, UpdateDeploymentCoOwnersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/co-owners',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get allowed users and groups for a deployment
 *
 * Returns the users and groups that currently have access to the specified deployment.
 */
export const getDeploymentAllowed = <ThrowOnError extends boolean = false>(options: Options<GetDeploymentAllowedData, ThrowOnError>) => (options.client ?? client).get<GetDeploymentAllowedResponses, GetDeploymentAllowedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/get-allowed',
    ...options
});

/**
 * Edit deployment allowed users
 *
 * Updates the allowed users and groups for a deployment. Removes desktops for users no longer allowed and recreates for new users.
 */
export const editDeploymentUsers = <ThrowOnError extends boolean = false>(options: Options<EditDeploymentUsersData, ThrowOnError>) => (options.client ?? client).put<EditDeploymentUsersResponses, EditDeploymentUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/edit-users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get deployment permissions
 *
 * Returns the permissions list configured for the deployment owner. The shape mirrors the ``user_permissions`` field accepted by ``PUT /item/deployment/{deployment_id}/edit`` so the old-frontend edit form can round-trip the value without reshaping.
 */
export const getDeploymentPermissions = <ThrowOnError extends boolean = false>(options: Options<GetDeploymentPermissionsData, ThrowOnError>) => (options.client ?? client).get<GetDeploymentPermissionsResponses, GetDeploymentPermissionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/permissions',
    ...options
});

/**
 * Get users in a group
 *
 * Returns a list of users in a specific group.
 *
 * @deprecated
 */
export const getUsersInGroup = <ThrowOnError extends boolean = false>(options: Options<GetUsersInGroupData, ThrowOnError>) => (options.client ?? client).get<GetUsersInGroupResponses, GetUsersInGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/group/{group_id}/get-users',
    ...options
});

/**
 * Get available OS templates for media installs
 *
 * Returns the list of available OS templates (virt_install) that can be used when creating a desktop from media.
 */
export const getMediaInstalls = <ThrowOnError extends boolean = false>(options?: Options<GetMediaInstallsData, ThrowOnError>) => (options?.client ?? client).get<GetMediaInstallsResponses, GetMediaInstallsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/media/installs',
    ...options
});

/**
 * Get allowed users, roles, groups, categories for a media item
 *
 * Returns allowed users, roles, groups, categories for a media item.
 */
export const getMediaAllowedTable = <ThrowOnError extends boolean = false>(options: Options<GetMediaAllowedTableData, ThrowOnError>) => (options.client ?? client).get<GetMediaAllowedTableResponses, GetMediaAllowedTableErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/media/{media_id}/get-allowed',
    ...options
});

/**
 * Update allowed users, roles, groups, categories for a media item
 *
 * Update the list of groups, users, roles, and categories that have access to the specified media item. Only provided fields will be updated.
 */
export const updateMediaAllowed = <ThrowOnError extends boolean = false>(options: Options<UpdateMediaAllowedData, ThrowOnError>) => (options.client ?? client).put<UpdateMediaAllowedResponses, UpdateMediaAllowedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/media/{media_id}/update-allowed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a new media item
 *
 * Creates a new media item. Returns the created media ID on success.
 */
export const createMedia = <ThrowOnError extends boolean = false>(options: Options<CreateMediaData, ThrowOnError>) => (options.client ?? client).post<CreateMediaResponses, CreateMediaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/media',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Abort a media download
 *
 * Aborts a media download. ``@is_not_user`` — ownership is enforced by ``owns_media_id``.
 */
export const abortMediaDownload = <ThrowOnError extends boolean = false>(options: Options<AbortMediaDownloadData, ThrowOnError>) => (options.client ?? client).put<AbortMediaDownloadResponses, AbortMediaDownloadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/media/{media_id}/abort',
    ...options
});

/**
 * Start a media download
 *
 * Starts a media download. ``@is_not_user`` — ownership is enforced by ``owns_media_id``.
 */
export const startMediaDownload = <ThrowOnError extends boolean = false>(options: Options<StartMediaDownloadData, ThrowOnError>) => (options.client ?? client).put<StartMediaDownloadResponses, StartMediaDownloadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/media/{media_id}/download',
    ...options
});

/**
 * Check media quota
 *
 * Checks if adding new media would exceed the user's quota. Raises an error if the quota is exceeded.
 */
export const checkQuotaNewMedia = <ThrowOnError extends boolean = false>(options?: Options<CheckQuotaNewMediaData, ThrowOnError>) => (options?.client ?? client).get<CheckQuotaNewMediaResponses, CheckQuotaNewMediaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/quota/media/new',
    ...options
});

/**
 * Check templates quota
 *
 * Checks if creating a new template would exceed the user's quota.
 */
export const checkQuotaNewTemplate = <ThrowOnError extends boolean = false>(options?: Options<CheckQuotaNewTemplateData, ThrowOnError>) => (options?.client ?? client).get<CheckQuotaNewTemplateResponses, CheckQuotaNewTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/quota/template/new',
    ...options
});

/**
 * Check deployments quota
 *
 * Checks if creating a new deployment would exceed the user's quota.
 */
export const checkQuotaNewDeployment = <ThrowOnError extends boolean = false>(options?: Options<CheckQuotaNewDeploymentData, ThrowOnError>) => (options?.client ?? client).get<CheckQuotaNewDeploymentResponses, CheckQuotaNewDeploymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/quota/deployment/new',
    ...options
});

/**
 * Increase storage size
 *
 * Schedules a task to increase a storage's virtual size by ``{increment}`` GB. ``@is_not_user``.
 */
export const increaseStorageSize = <ThrowOnError extends boolean = false>(options: Options<IncreaseStorageSizeData, ThrowOnError>) => (options.client ?? client).put<IncreaseStorageSizeResponses, IncreaseStorageSizeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}/priority/{priority}/increase/{increment}',
    ...options
});

/**
 * Get all users
 *
 * Returns all the users that the user in the payload can see.
 */
export const getAllUsers = <ThrowOnError extends boolean = false>(options?: Options<GetAllUsersData, ThrowOnError>) => (options?.client ?? client).get<GetAllUsersResponses, GetAllUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/users',
    ...options
});

/**
 * Get all groups
 *
 * Returns all the groups that the user in the payload can see.
 */
export const getAllGroups = <ThrowOnError extends boolean = false>(options?: Options<GetAllGroupsData, ThrowOnError>) => (options?.client ?? client).get<GetAllGroupsResponses, GetAllGroupsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/groups',
    ...options
});

/**
 * Get user API key
 *
 * Returns the API key for the specified user.
 */
export const getUserApiKey = <ThrowOnError extends boolean = false>(options?: Options<GetUserApiKeyData, ThrowOnError>) => (options?.client ?? client).get<GetUserApiKeyResponses, GetUserApiKeyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/get-api-key',
    ...options
});

/**
 * Expire user API key
 *
 * Deletes the API key for the specified user, making it invalid.
 */
export const expireUserApiKey = <ThrowOnError extends boolean = false>(options?: Options<ExpireUserApiKeyData, ThrowOnError>) => (options?.client ?? client).delete<ExpireUserApiKeyResponses, ExpireUserApiKeyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/expire-api-key',
    ...options
});

/**
 * Count users in groups
 *
 * Returns the total number of users in the specified groups.
 */
export const groupsUsersCount = <ThrowOnError extends boolean = false>(options: Options<GroupsUsersCountData, ThrowOnError>) => (options.client ?? client).put<GroupsUsersCountResponses, GroupsUsersCountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/groups-users/count',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get deployment's bookings
 *
 * Returns the bookings for a specific deployment.
 */
export const getBookingDeployment = <ThrowOnError extends boolean = false>(options: Options<GetBookingDeploymentData, ThrowOnError>) => (options.client ?? client).get<GetBookingDeploymentResponses, GetBookingDeploymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/booking/get-deployment/{item_id}',
    ...options
});

/**
 * Bulk edit multiple desktops
 *
 * Applies a partial desktop update to every desktop in ``ids``. Ports v3 ``PUT /domain/bulk`` — the request body must contain an ``ids`` list alongside the fields to update. Ownership is checked per id.
 */
export const bulkEditDesktops = <ThrowOnError extends boolean = false>(options: Options<BulkEditDesktopsData, ThrowOnError>) => (options.client ?? client).put<BulkEditDesktopsResponses, BulkEditDesktopsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/desktops/bulk-edit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk create persistent desktops from a template
 *
 * Creates multiple persistent desktops from a template for a set of users/groups/categories/roles. Ports v3 ``POST /persistent_desktop/bulk``. Body requires ``template_id``, ``name``, ``description`` and an ``allowed`` structure describing the target entities.
 */
export const bulkCreatePersistentDesktops = <ThrowOnError extends boolean = false>(options: Options<BulkCreatePersistentDesktopsData, ThrowOnError>) => (options.client ?? client).post<BulkCreatePersistentDesktopsResponses, BulkCreatePersistentDesktopsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/desktops/bulk-create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get user templates
 *
 * Returns a list of all templates that belong to the user calling the endpoint.
 */
export const getUserTemplates = <ThrowOnError extends boolean = false>(options?: Options<GetUserTemplatesData, ThrowOnError>) => (options?.client ?? client).get<GetUserTemplatesResponses, GetUserTemplatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/templates',
    ...options
});

/**
 * Get user templates
 *
 * Returns a list of all templates that belong to the user calling the endpoint.
 */
export const getUserTemplatesPaginated = <ThrowOnError extends boolean = false>(options?: Options<GetUserTemplatesPaginatedData, ThrowOnError>) => (options?.client ?? client).get<GetUserTemplatesPaginatedResponses, GetUserTemplatesPaginatedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/paginated/templates',
    ...options
});

/**
 * Get allowed users, roles, groups, categories for a template
 *
 * Returns the list of groups, users, roles, and categories that currently have access to the specified template.
 */
export const getTemplateAllowed = <ThrowOnError extends boolean = false>(options: Options<GetTemplateAllowedData, ThrowOnError>) => (options.client ?? client).get<GetTemplateAllowedResponses, GetTemplateAllowedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/template/{template_id}/get-allowed',
    ...options
});

/**
 * Update allowed entities for a template
 *
 * Update the list of groups, users, roles, and categories that have access to the specified template. Only provided fields will be updated.
 */
export const updateTemplateAllowed = <ThrowOnError extends boolean = false>(options: Options<UpdateTemplateAllowedData, ThrowOnError>) => (options.client ?? client).put<UpdateTemplateAllowedResponses, UpdateTemplateAllowedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/template/{template_id}/update-allowed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update template information
 *
 * Update the properties of a specific template.
 */
export const updateTemplate = <ThrowOnError extends boolean = false>(options: Options<UpdateTemplateData, ThrowOnError>) => (options.client ?? client).put<UpdateTemplateResponses, UpdateTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/template/{template_id}/edit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enable or disable a template
 *
 * Toggles whether a template is enabled (usable for creating desktops). Replaces v3 ``PUT /template/update`` and preserves its side effects: enable runs the template-create quota check, disable cascade-flags non-persistent desktops as ForceDeleting so the engine cleans them up.
 */
export const setTemplateEnabled = <ThrowOnError extends boolean = false>(options: Options<SetTemplateEnabledData, ThrowOnError>) => (options.client ?? client).put<SetTemplateEnabledResponses, SetTemplateEnabledErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/template/{template_id}/set-enabled',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get template dependency tree
 *
 * Returns a tree structure showing all desktops and templates that depend on the specified template.
 */
export const getTemplateTree = <ThrowOnError extends boolean = false>(options: Options<GetTemplateTreeData, ThrowOnError>) => (options.client ?? client).get<GetTemplateTreeResponses, GetTemplateTreeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/template/{template_id}/get-tree',
    ...options
});

/**
 * Create new template
 *
 * Create a new template from a desktop.
 */
export const createTemplate = <ThrowOnError extends boolean = false>(options: Options<CreateTemplateData, ThrowOnError>) => (options.client ?? client).post<CreateTemplateResponses, CreateTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Duplicate template
 *
 * Create a new template by duplicating an existing one.
 */
export const duplicateTemplate = <ThrowOnError extends boolean = false>(options: Options<DuplicateTemplateData, ThrowOnError>) => (options.client ?? client).post<DuplicateTemplateResponses, DuplicateTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/template/{template_id}/duplicate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete template
 *
 * Delete a specific template.
 */
export const deleteTemplate = <ThrowOnError extends boolean = false>(options: Options<DeleteTemplateData, ThrowOnError>) => (options.client ?? client).delete<DeleteTemplateResponses, DeleteTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/template/{template_id}',
    ...options
});

/**
 * Convert template to desktop
 *
 * Convert a specific template into a desktop. Ownership of the template is enforced by ``owns_domain_id`` (which transitively requires ``is_not_user``).
 */
export const convertTemplateToDesktop = <ThrowOnError extends boolean = false>(options: Options<ConvertTemplateToDesktopData, ThrowOnError>) => (options.client ?? client).post<ConvertTemplateToDesktopResponses, ConvertTemplateToDesktopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/template/{template_id}/convert-to-desktop',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enable or disable template
 *
 * Enable or disable a specific template.
 */
export const toggleTemplateEnabled = <ThrowOnError extends boolean = false>(options: Options<ToggleTemplateEnabledData, ThrowOnError>) => (options.client ?? client).put<ToggleTemplateEnabledResponses, ToggleTemplateEnabledErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/template/{template_id}/toggle-enabled',
    ...options
});

/**
 * Get admin bastion configuration
 *
 * Returns the bastion configuration overview including enabled status, domain, SSH port, and domain verification settings.
 */
export const getAdminBastionConfig = <ThrowOnError extends boolean = false>(options?: Options<GetAdminBastionConfigData, ThrowOnError>) => (options?.client ?? client).get<GetAdminBastionConfigResponses, GetAdminBastionConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/config/bastion',
    ...options
});

/**
 * Update bastion configuration
 *
 * Updates the bastion configuration including enabled status, domain, and domain verification settings.
 */
export const updateBastionConfig = <ThrowOnError extends boolean = false>(options: Options<UpdateBastionConfigData, ThrowOnError>) => (options.client ?? client).put<UpdateBastionConfigResponses, UpdateBastionConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/config/bastion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get bastion domain verification configuration
 *
 * Returns whether domain verification is required for bastion domains.
 *
 * @deprecated
 */
export const getBastionDomainVerificationConfig = <ThrowOnError extends boolean = false>(options?: Options<GetBastionDomainVerificationConfigData, ThrowOnError>) => (options?.client ?? client).get<GetBastionDomainVerificationConfigResponses, GetBastionDomainVerificationConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/bastion/config',
    ...options
});

/**
 * Change deployment owner
 *
 * Changes the owner of a deployment to a different user.
 */
export const changeDeploymentOwner = <ThrowOnError extends boolean = false>(options: Options<ChangeDeploymentOwnerData, ThrowOnError>) => (options.client ?? client).put<ChangeDeploymentOwnerResponses, ChangeDeploymentOwnerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/deployment/{deployment_id}/change-owner/{user_id}',
    ...options
});

/**
 * Get max quota / limits for a user, category or group
 *
 * Returns the current quota and limits dict for the caller's own ``user``, ``category`` or ``group`` entity. Admin/manager only. Use the ``/admin/quota/{kind}/{item_id}`` variant to target a specific entity by id. ``@is_admin_or_manager``.
 */
export const adminGetQuotaByKind = <ThrowOnError extends boolean = false>(options: Options<AdminGetQuotaByKindData, ThrowOnError>) => (options.client ?? client).get<AdminGetQuotaByKindResponses, AdminGetQuotaByKindErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/quota/{kind}',
    ...options
});

/**
 * Get max quota / limits for a specific entity
 *
 * Returns the current quota and limits dict for the given entity id. ``kind`` is one of ``user``, ``category`` or ``group``. Admin/manager only. ``@is_admin_or_manager``.
 */
export const adminGetQuotaByKindItem = <ThrowOnError extends boolean = false>(options: Options<AdminGetQuotaByKindItemData, ThrowOnError>) => (options.client ?? client).get<AdminGetQuotaByKindItemResponses, AdminGetQuotaByKindItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/quota/{kind}/{item_id}',
    ...options
});

/**
 * Get system recycle bin cutoff time
 *
 * Returns the system-level cutoff time. Managers get their category's cutoff time.
 */
export const getSystemCutoffTime = <ThrowOnError extends boolean = false>(options?: Options<GetSystemCutoffTimeData, ThrowOnError>) => (options?.client ?? client).get<GetSystemCutoffTimeResponses, GetSystemCutoffTimeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/recycle-bin/system/cutoff-time',
    ...options
});

/**
 * Update system recycle bin cutoff time
 *
 * Updates the system-level cutoff time. Managers update their category's cutoff time.
 */
export const updateSystemCutoffTime = <ThrowOnError extends boolean = false>(options: Options<UpdateSystemCutoffTimeData, ThrowOnError>) => (options.client ?? client).put<UpdateSystemCutoffTimeResponses, UpdateSystemCutoffTimeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/recycle-bin/system/cutoff-time',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get recycle bin status
 *
 * Returns recycle bin entry counts by status. Managers see only their category.
 */
export const getRecycleBinStatus = <ThrowOnError extends boolean = false>(options?: Options<GetRecycleBinStatusData, ThrowOnError>) => (options?.client ?? client).get<GetRecycleBinStatusResponses, GetRecycleBinStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/recycle-bin/status',
    ...options
});

/**
 * Get recycle bin entries with item counts (admin view)
 *
 * Returns the full list of recycle bin entries with per-item-type counts (desktops, templates, storages, deployments, etc.) for the admin recycle bin table. Managers see only their own category. Optionally filter by a specific entry status.
 */
export const getRecycleBinAdminEntries = <ThrowOnError extends boolean = false>(options?: Options<GetRecycleBinAdminEntriesData, ThrowOnError>) => (options?.client ?? client).get<GetRecycleBinAdminEntriesResponses, GetRecycleBinAdminEntriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/recycle-bin/admin-entries',
    ...options
});

/**
 * Get the installation qcow2 geometry policy
 *
 * Returns the installation-wide qcow2 geometry policy (cluster_size, extended_l2, lazy_refcounts, preallocation) that apiv4 resolves from its environment and carries in every disk task payload. Read-only. Used by the storage admin CLI, whose container no longer holds the QCOW2_* vars, so its own qcow2 writers (recover --fix, --compress) can write disks coherent with the install policy instead of qemu-img defaults.
 */
export const getQcow2Geometry = <ThrowOnError extends boolean = false>(options?: Options<GetQcow2GeometryData, ThrowOnError>) => (options?.client ?? client).get<GetQcow2GeometryResponses, GetQcow2GeometryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/storage/qcow2-geometry',
    ...options
});

/**
 * Get storage parent chain
 *
 * Returns the parent chain of a storage item.
 */
export const getStorageParents = <ThrowOnError extends boolean = false>(options: Options<GetStorageParentsData, ThrowOnError>) => (options.client ?? client).get<GetStorageParentsResponses, GetStorageParentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}/parents',
    ...options
});

/**
 * Get storage task
 *
 * Returns the task associated with a storage item.
 */
export const getStorageTask = <ThrowOnError extends boolean = false>(options: Options<GetStorageTaskData, ThrowOnError>) => (options.client ?? client).get<GetStorageTaskResponses, GetStorageTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}/task',
    ...options
});

/**
 * Check if storage has derivatives
 *
 * Returns how many disks depend on this one as a backing file, counting the whole subtree and not just the direct children.
 */
export const getStorageHasDerivatives = <ThrowOnError extends boolean = false>(options: Options<GetStorageHasDerivativesData, ThrowOnError>) => (options.client ?? client).get<GetStorageHasDerivativesResponses, GetStorageHasDerivativesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}/has-derivatives',
    ...options
});

/**
 * Check storage backing chain
 *
 * Creates a task to check the backing chain of a storage.
 */
export const checkStorageBackingChain = <ThrowOnError extends boolean = false>(options: Options<CheckStorageBackingChainData, ThrowOnError>) => (options.client ?? client).put<CheckStorageBackingChainResponses, CheckStorageBackingChainErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}/check-backing-chain',
    ...options
});

/**
 * Recreate a storage
 *
 * Recreates a storage with the same specifications and parent.
 */
export const recreateStorage = <ThrowOnError extends boolean = false>(options: Options<RecreateStorageData, ThrowOnError>) => (options.client ?? client).post<RecreateStorageResponses, RecreateStorageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}/recreate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stop desktops using storage
 *
 * Stops all desktops that are using the specified storage.
 */
export const stopStorageDesktops = <ThrowOnError extends boolean = false>(options: Options<StopStorageDesktopsData, ThrowOnError>) => (options.client ?? client).put<StopStorageDesktopsResponses, StopStorageDesktopsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}/stop',
    ...options
});

/**
 * Get phantom storages registered against a single storage
 *
 * Returns the ``storages_with_uuid`` field of a single storage. ``@is_admin_or_manager``.
 */
export const getStorageStoragesWithUuid = <ThrowOnError extends boolean = false>(options: Options<GetStorageStoragesWithUuidData, ThrowOnError>) => (options.client ?? client).get<GetStorageStoragesWithUuidResponses, GetStorageStoragesWithUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}/storages_with_uuid',
    ...options
});

/**
 * List all storages_with_uuid entries
 *
 * Returns the union of every ``storages_with_uuid`` row in the storage table. Manager-role callers are scoped to their own category; admins see everything.
 */
export const listAllStoragesWithUuid = <ThrowOnError extends boolean = false>(options?: Options<ListAllStoragesWithUuidData, ThrowOnError>) => (options?.client ?? client).get<ListAllStoragesWithUuidResponses, ListAllStoragesWithUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/storage/storages_with_uuid',
    ...options
});

/**
 * Get per-status counts of storages_with_uuid
 *
 * Returns the per-status counts of phantom ``storages_with_uuid`` rows. Manager-role callers are scoped to their own category.
 */
export const listAllStoragesWithUuidStatus = <ThrowOnError extends boolean = false>(options?: Options<ListAllStoragesWithUuidStatusData, ThrowOnError>) => (options?.client ?? client).get<ListAllStoragesWithUuidStatusResponses, ListAllStoragesWithUuidStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/storage/storages_with_uuid/status',
    ...options
});

/**
 * List storages_with_uuid filtered by status
 *
 * Returns the ``storages_with_uuid`` rows matching the given ``status``.
 */
export const listAllStoragesWithUuidFiltered = <ThrowOnError extends boolean = false>(options: Options<ListAllStoragesWithUuidFilteredData, ThrowOnError>) => (options.client ?? client).get<ListAllStoragesWithUuidFilteredResponses, ListAllStoragesWithUuidFilteredErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/storage/storages_with_uuid/{status}',
    ...options
});

/**
 * Get default storage pool
 *
 * Returns the default storage pool.
 */
export const getDefaultStoragePool = <ThrowOnError extends boolean = false>(options?: Options<GetDefaultStoragePoolData, ThrowOnError>) => (options?.client ?? client).get<GetDefaultStoragePoolResponses, GetDefaultStoragePoolErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/storage-pool/default',
    ...options
});

/**
 * Get storage pool by path
 *
 * Returns the storage pool that matches the given path.
 */
export const getStoragePoolByPath = <ThrowOnError extends boolean = false>(options: Options<GetStoragePoolByPathData, ThrowOnError>) => (options.client ?? client).put<GetStoragePoolByPathResponses, GetStoragePoolByPathErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/storage-pool/by-path',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all tasks (admin/manager)
 *
 * Returns admin tasks. Defaults to the most recent ``limit`` tasks; bump to a higher value to paginate through history. Bug 38 hardening — unbounded responses were ~12 MB / 32 s and timed out k6's HTTP client.
 */
export const getAdminTasks = <ThrowOnError extends boolean = false>(options?: Options<GetAdminTasksData, ThrowOnError>) => (options?.client ?? client).get<GetAdminTasksResponses, GetAdminTasksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/tasks',
    ...options
});

/**
 * Get storage usage analytics
 *
 * Returns storage usage analytics, optionally filtered by categories.
 */
export const analyticsStorage = <ThrowOnError extends boolean = false>(options: Options<AnalyticsStorageData, ThrowOnError>) => (options.client ?? client).post<AnalyticsStorageResponses, AnalyticsStorageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/analytics/storage',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get resource count analytics
 *
 * Returns resource count analytics (desktops, templates, media, etc.), optionally filtered by categories.
 */
export const analyticsResourceCount = <ThrowOnError extends boolean = false>(options: Options<AnalyticsResourceCountData, ThrowOnError>) => (options.client ?? client).post<AnalyticsResourceCountResponses, AnalyticsResourceCountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/analytics/resources/count',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get suggested removals
 *
 * Returns suggested resources for removal based on inactivity.
 */
export const analyticsSuggestedRemovals = <ThrowOnError extends boolean = false>(options: Options<AnalyticsSuggestedRemovalsData, ThrowOnError>) => (options.client ?? client).post<AnalyticsSuggestedRemovalsResponses, AnalyticsSuggestedRemovalsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/analytics/suggested_removals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all analytics graph configurations
 *
 * Returns all analytics graph configurations.
 */
export const analyticsGraphsConfList = <ThrowOnError extends boolean = false>(options?: Options<AnalyticsGraphsConfListData, ThrowOnError>) => (options?.client ?? client).get<AnalyticsGraphsConfListResponses, AnalyticsGraphsConfListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/analytics/graph',
    ...options
});

/**
 * List authentication providers
 *
 * Returns enabled status for all authentication providers.
 */
export const adminAuthenticationProviders = <ThrowOnError extends boolean = false>(options?: Options<AdminAuthenticationProvidersData, ThrowOnError>) => (options?.client ?? client).get<AdminAuthenticationProvidersResponses, AdminAuthenticationProvidersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/authentication/providers',
    ...options
});

/**
 * Get category branding
 *
 * Returns branding configuration (domain + logo) for a category.
 */
export const getCategoryBranding = <ThrowOnError extends boolean = false>(options: Options<GetCategoryBrandingData, ThrowOnError>) => (options.client ?? client).get<GetCategoryBrandingResponses, GetCategoryBrandingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/category/{category_id}/branding',
    ...options
});

/**
 * Update category branding
 *
 * Updates branding configuration (domain + logo) for a category. Logo data should be a base64 data URL.
 */
export const updateCategoryBranding = <ThrowOnError extends boolean = false>(options: Options<UpdateCategoryBrandingData, ThrowOnError>) => (options.client ?? client).put<UpdateCategoryBrandingResponses, UpdateCategoryBrandingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/category/{category_id}/branding',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get category authentication
 *
 * Returns authentication provider configuration for a category with sensitive fields stripped.
 */
export const getCategoryAuthentication = <ThrowOnError extends boolean = false>(options: Options<GetCategoryAuthenticationData, ThrowOnError>) => (options.client ?? client).get<GetCategoryAuthenticationResponses, GetCategoryAuthenticationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/category/{category_id}/authentication',
    ...options
});

/**
 * Update category authentication
 *
 * Updates authentication provider configuration for a category. Sensitive fields (password, client_secret) are preserved if left empty in the payload.
 */
export const updateCategoryAuthentication = <ThrowOnError extends boolean = false>(options: Options<UpdateCategoryAuthenticationData, ThrowOnError>) => (options.client ?? client).put<UpdateCategoryAuthenticationResponses, UpdateCategoryAuthenticationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/category/{category_id}/authentication',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update category login notification
 *
 * Updates login notification configuration for a specific category.
 */
export const updateCategoryLoginNotification = <ThrowOnError extends boolean = false>(options: Options<UpdateCategoryLoginNotificationData, ThrowOnError>) => (options.client ?? client).put<UpdateCategoryLoginNotificationResponses, UpdateCategoryLoginNotificationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/category/{category_id}/login_notification',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enable/disable category login notification
 *
 * Enables or disables a specific login notification type for a category.
 */
export const enableCategoryLoginNotification = <ThrowOnError extends boolean = false>(options: Options<EnableCategoryLoginNotificationData, ThrowOnError>) => (options.client ?? client).put<EnableCategoryLoginNotificationResponses, EnableCategoryLoginNotificationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/category/{category_id}/login_notification/{notification_type}/enable',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List domains
 *
 * List desktops or templates with optional category filter. Managers are scoped to their own category.
 */
export const adminListDomains = <ThrowOnError extends boolean = false>(options: Options<AdminListDomainsData2, ThrowOnError>) => (options.client ?? client).post<AdminListDomainsResponses, AdminListDomainsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/domains',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get domain details
 *
 * Returns detailed data for a specific domain.
 */
export const adminDomainDetails = <ThrowOnError extends boolean = false>(options: Options<AdminDomainDetailsData, ThrowOnError>) => (options.client ?? client).get<AdminDomainDetailsResponses, AdminDomainDetailsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/domain/{domain_id}/details',
    ...options
});

/**
 * Get domain viewer data
 *
 * Returns viewer connection data for a domain.
 */
export const adminDomainViewerData = <ThrowOnError extends boolean = false>(options: Options<AdminDomainViewerDataData, ThrowOnError>) => (options.client ?? client).get<AdminDomainViewerDataResponses, AdminDomainViewerDataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/domain/{domain_id}/viewer_data',
    ...options
});

/**
 * Get domains by status
 *
 * Returns domains matching a given status. Supports 'delete_pending' and other status values.
 */
export const adminDomainsStatus = <ThrowOnError extends boolean = false>(options: Options<AdminDomainsStatusData, ThrowOnError>) => (options.client ?? client).get<AdminDomainsStatusResponses, AdminDomainsStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/domains_status/{status}',
    ...options
});

/**
 * Enqueue find tasks for storages of domains in a given status
 *
 * Scans every ``desktop`` domain with the given status, collects their storage ids and enqueues a ``find`` task for each. ``@is_admin_or_manager`` — managers are scoped to their own category via the ``kind_status_category`` secondary index.
 */
export const adminFindStoragesByDomainStatus = <ThrowOnError extends boolean = false>(options: Options<AdminFindStoragesByDomainStatusData, ThrowOnError>) => (options.client ?? client).put<AdminFindStoragesByDomainStatusResponses, AdminFindStoragesByDomainStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/domains/status/{status}/find_storages',
    ...options
});

/**
 * Get domain storage
 *
 * Returns storage information for a domain.
 */
export const adminDomainStorage = <ThrowOnError extends boolean = false>(options: Options<AdminDomainStorageData, ThrowOnError>) => (options.client ?? client).get<AdminDomainStorageResponses, AdminDomainStorageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/domain/storage/{domain_id}',
    ...options
});

/**
 * Get template tree list
 *
 * Returns the template tree list for a given template.
 */
export const adminDesktopsTreeList = <ThrowOnError extends boolean = false>(options: Options<AdminDesktopsTreeListData, ThrowOnError>) => (options.client ?? client).get<AdminDesktopsTreeListResponses, AdminDesktopsTreeListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/desktops/tree_list/{template_id}',
    ...options
});

/**
 * Get domain template tree
 *
 * Returns the template ancestry tree for a domain.
 */
export const adminDomainTemplateTree = <ThrowOnError extends boolean = false>(options: Options<AdminDomainTemplateTreeData, ThrowOnError>) => (options.client ?? client).get<AdminDomainTemplateTreeResponses, AdminDomainTemplateTreeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/domain/template_tree/{desktop_id}',
    ...options
});

/**
 * Perform multiple domain actions
 *
 * Perform bulk actions (start, stop, delete, etc.) on multiple domains.
 */
export const adminMultipleActions = <ThrowOnError extends boolean = false>(options: Options<AdminMultipleActionsData2, ThrowOnError>) => (options.client ?? client).post<AdminMultipleActionsResponses, AdminMultipleActionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/multiple_actions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a template
 *
 * Deletes a template by ID, moving it to recycle bin.
 */
export const adminTemplateDelete = <ThrowOnError extends boolean = false>(options: Options<AdminTemplateDeleteData, ThrowOnError>) => (options.client ?? client).delete<AdminTemplateDeleteResponses, AdminTemplateDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/templates/delete/{template_id}',
    ...options
});

/**
 * Search domain names
 *
 * Returns up to a few dozen distinct domain names matching the search term, for type-ahead filtering without loading every name.
 */
export const adminDomainsNameSearch = <ThrowOnError extends boolean = false>(options: Options<AdminDomainsNameSearchData, ThrowOnError>) => (options.client ?? client).get<AdminDomainsNameSearchResponses, AdminDomainsNameSearchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/domains/name/{kind}/search',
    ...options
});

/**
 * Get domain field values
 *
 * Returns distinct values for a specific field across domains of a given kind.
 */
export const adminDomainsField = <ThrowOnError extends boolean = false>(options: Options<AdminDomainsFieldData, ThrowOnError>) => (options.client ?? client).get<AdminDomainsFieldResponses, AdminDomainsFieldErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/domains/{field}/{kind}',
    ...options
});

/**
 * Get domain hardware
 *
 * Returns hardware details for a domain.
 */
export const adminDomainHardware = <ThrowOnError extends boolean = false>(options: Options<AdminDomainHardwareData, ThrowOnError>) => (options.client ?? client).get<AdminDomainHardwareResponses, AdminDomainHardwareErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/domain/hardware/{domain_id}',
    ...options
});

/**
 * Get domain search info
 *
 * Returns domain info enriched with owner data for search results.
 */
export const adminDomainSearchInfo = <ThrowOnError extends boolean = false>(options: Options<AdminDomainSearchInfoData, ThrowOnError>) => (options.client ?? client).get<AdminDomainSearchInfoResponses, AdminDomainSearchInfoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/domain/search-info/{domain_id}',
    ...options
});

/**
 * Query desktop logs (raw)
 *
 * Query desktop logs with DataTables-style parameters. Returns raw log data. Managers see their own category only.
 */
export const adminLogsDesktopsRaw = <ThrowOnError extends boolean = false>(options: Options<AdminLogsDesktopsRawData, ThrowOnError>) => (options.client ?? client).post<AdminLogsDesktopsRawResponses, AdminLogsDesktopsRawErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/logs_desktops',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Query desktop logs (grouped)
 *
 * Query desktop logs with DataTables-style parameters. Supports views: 'raw', 'desktop_grouping', 'category_grouping'. Managers see their own category only.
 */
export const adminLogsDesktopsView = <ThrowOnError extends boolean = false>(options: Options<AdminLogsDesktopsViewData, ThrowOnError>) => (options.client ?? client).post<AdminLogsDesktopsViewResponses, AdminLogsDesktopsViewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/logs_desktops/{view}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Query user logs (raw)
 *
 * Query user logs with DataTables-style parameters. Returns raw log data. Managers see their own category only.
 */
export const adminLogsUsersRaw = <ThrowOnError extends boolean = false>(options: Options<AdminLogsUsersRawData, ThrowOnError>) => (options.client ?? client).post<AdminLogsUsersRawResponses, AdminLogsUsersRawErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/logs_users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Query user logs (grouped)
 *
 * Query user logs with DataTables-style parameters. Supports views: 'raw', 'user_grouping', 'category_grouping'. Managers see their own category only.
 */
export const adminLogsUsersView = <ThrowOnError extends boolean = false>(options: Options<AdminLogsUsersViewData, ThrowOnError>) => (options.client ?? client).post<AdminLogsUsersViewResponses, AdminLogsUsersViewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/logs_users/{view}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List desktop logs (JSON)
 *
 * Simple JSON list of desktop logs with optional filters.
 */
export const adminLogsDesktopsList = <ThrowOnError extends boolean = false>(options?: Options<AdminLogsDesktopsListData, ThrowOnError>) => (options?.client ?? client).get<AdminLogsDesktopsListResponses, AdminLogsDesktopsListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/logs_desktops/list',
    ...options
});

/**
 * List user logs (JSON)
 *
 * Simple JSON list of user logs with optional filters.
 */
export const adminLogsUsersList = <ThrowOnError extends boolean = false>(options?: Options<AdminLogsUsersListData, ThrowOnError>) => (options?.client ?? client).get<AdminLogsUsersListResponses, AdminLogsUsersListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/logs_users/list',
    ...options
});

/**
 * Get global login config (raw)
 *
 * Admin-only raw read of the global login configuration. Returns the unmerged ``Configuration.login`` payload so the admin edit-modal can show the current state. The public ``GET /item/login-config`` returns the same content but goes through the same typed response model.
 */
export const adminLoginConfigGet = <ThrowOnError extends boolean = false>(options?: Options<AdminLoginConfigGetData, ThrowOnError>) => (options?.client ?? client).get<AdminLoginConfigGetResponses, AdminLoginConfigGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/login-config',
    ...options
});

/**
 * Get per-category login config (raw)
 *
 * Admin-only raw read of a single category's login notification configuration. Unmerged — used by the webapp admin "Edit category login notification" modal. The public ``GET /item/login-config/{category_id}`` returns the merged global + category arrays for the login page.
 */
export const adminLoginConfigByCategory = <ThrowOnError extends boolean = false>(options: Options<AdminLoginConfigByCategoryData, ThrowOnError>) => (options.client ?? client).get<AdminLoginConfigByCategoryResponses, AdminLoginConfigByCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/login-config/{category_id}',
    ...options
});

/**
 * Get media status counts
 *
 * Get counts of media items grouped by status. Managers are scoped to their category.
 */
export const adminMediaStatus = <ThrowOnError extends boolean = false>(options?: Options<AdminMediaStatusData, ThrowOnError>) => (options?.client ?? client).get<AdminMediaStatusResponses, AdminMediaStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/media/status',
    ...options
});

/**
 * Get all media
 *
 * Get all media items. Admins see all; managers are scoped to their category.
 */
export const adminMediaList = <ThrowOnError extends boolean = false>(options?: Options<AdminMediaListData, ThrowOnError>) => (options?.client ?? client).get<AdminMediaListResponses, AdminMediaListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/media',
    ...options
});

/**
 * Get media by status
 *
 * Get media items filtered by status. Admins see all; managers are scoped to their category.
 */
export const adminMediaByStatus = <ThrowOnError extends boolean = false>(options: Options<AdminMediaByStatusData, ThrowOnError>) => (options.client ?? client).get<AdminMediaByStatusResponses, AdminMediaByStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/media/{status}',
    ...options
});

/**
 * List media attached to a desktop
 *
 * Returns the list of media items (isos + floppies) currently attached to the given desktop's hardware configuration. Used to populate the hotplug modal in the webapp admin. Admin/manager only — matches v3 ``POST /desktops/media_list`` ``@is_admin_or_manager``.
 */
export const listDesktopAttachedMedia = <ThrowOnError extends boolean = false>(options: Options<ListDesktopAttachedMediaData, ThrowOnError>) => (options.client ?? client).get<ListDesktopAttachedMediaResponses, ListDesktopAttachedMediaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/desktop/{desktop_id}/media-list',
    ...options
});

/**
 * Change media owner
 *
 * Reassigns a media item to a different user. ``@is_admin_or_manager``. Both ``ownsUserId(user_id)`` and ``ownsMediaId(media_id)`` are enforced by the service.
 */
export const changeMediaOwner = <ThrowOnError extends boolean = false>(options: Options<ChangeMediaOwnerData, ThrowOnError>) => (options.client ?? client).put<ChangeMediaOwnerResponses, ChangeMediaOwnerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/media/{media_id}/change-owner/{user_id}',
    ...options
});

/**
 * Check media file existence on disk
 *
 * Schedules a background task that verifies the media file on disk. If the media is not currently downloaded its status is forced to ``deleted``. Otherwise an RQ ``check_media_existence`` task is enqueued against the storage pool that owns the file. Admin/manager only — matches v3 ``PUT /media/check/{id}`` ``@is_admin_or_manager``.
 */
export const checkMedia = <ThrowOnError extends boolean = false>(options: Options<CheckMediaData, ThrowOnError>) => (options.client ?? client).put<CheckMediaResponses, CheckMediaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/media/{media_id}/check',
    ...options
});

/**
 * Get storage status counts
 *
 * Get counts of storages grouped by status. Managers are scoped to their category.
 */
export const adminStorageStatus = <ThrowOnError extends boolean = false>(options?: Options<AdminStorageStatusData, ThrowOnError>) => (options?.client ?? client).get<AdminStorageStatusResponses, AdminStorageStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/storage/status',
    ...options
});

/**
 * Get all storages
 *
 * Get all storage items. Admins see all; managers are scoped to their category.
 */
export const adminStorageList = <ThrowOnError extends boolean = false>(options?: Options<AdminStorageListData, ThrowOnError>) => (options?.client ?? client).get<AdminStorageListResponses, AdminStorageListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/storage',
    ...options
});

/**
 * Get all storages with category filter
 *
 * Get all storage items with optional category filter. Admins can filter by categories; managers are scoped to their category.
 */
export const adminStorageListFiltered = <ThrowOnError extends boolean = false>(options: Options<AdminStorageListFilteredData, ThrowOnError>) => (options.client ?? client).post<AdminStorageListFilteredResponses, AdminStorageListFilteredErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/storage',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get storages by status
 *
 * Get storage items filtered by status. Admins see all; managers are scoped to their category.
 */
export const adminStorageByStatus = <ThrowOnError extends boolean = false>(options: Options<AdminStorageByStatusData, ThrowOnError>) => (options.client ?? client).get<AdminStorageByStatusResponses, AdminStorageByStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/storage/by-status/{status}',
    ...options
});

/**
 * Get storages by status with category filter
 *
 * Get storage items filtered by status with optional category filter.
 */
export const adminStorageByStatusFiltered = <ThrowOnError extends boolean = false>(options: Options<AdminStorageByStatusFilteredData, ThrowOnError>) => (options.client ?? client).post<AdminStorageByStatusFilteredResponses, AdminStorageByStatusFilteredErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/storage/by-status/{status}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get domains attached to a storage
 *
 * Get the list of domains that use a specific storage.
 */
export const adminStorageDomains = <ThrowOnError extends boolean = false>(options: Options<AdminStorageDomainsData, ThrowOnError>) => (options.client ?? client).get<AdminStorageDomainsResponses, AdminStorageDomainsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/storage/domains/{storage_id}',
    ...options
});

/**
 * Get domains using a media item
 *
 * Get the list of domains that use a specific media item.
 */
export const adminMediaDomains = <ThrowOnError extends boolean = false>(options: Options<AdminMediaDomainsData, ThrowOnError>) => (options.client ?? client).get<AdminMediaDomainsResponses, AdminMediaDomainsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/media/domains/{storage_id}',
    ...options
});

/**
 * Delete a storage
 *
 * Delete a storage via the canonical task chain — same chain the user-facing ``DELETE /item/storage/{id}`` invokes. Rejects with 428 if the storage still has child storages.
 */
export const adminStorageDelete = <ThrowOnError extends boolean = false>(options: Options<AdminStorageDeleteData, ThrowOnError>) => (options.client ?? client).delete<AdminStorageDeleteResponses, AdminStorageDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/storage/{storage_id}',
    ...options
});

/**
 * Get storage information
 *
 * Get detailed information about a specific storage.
 */
export const adminStorageInfo = <ThrowOnError extends boolean = false>(options: Options<AdminStorageInfoData, ThrowOnError>) => (options.client ?? client).get<AdminStorageInfoResponses, AdminStorageInfoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/storage/info/{storage_id}',
    ...options
});

/**
 * Get storage search information with owner data
 *
 * Get storage information including owner details.
 */
export const adminStorageSearchInfo = <ThrowOnError extends boolean = false>(options: Options<AdminStorageSearchInfoData, ThrowOnError>) => (options.client ?? client).get<AdminStorageSearchInfoResponses, AdminStorageSearchInfoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/storage/search-info/{storage_id}',
    ...options
});

/**
 * Get items from a table
 *
 * Get a single item by ID or list all items from a table. Admins see all items; managers are scoped to their category.
 */
export const adminTableGet = <ThrowOnError extends boolean = false>(options: Options<AdminTableGetData, ThrowOnError>) => (options.client ?? client).get<AdminTableGetResponses, AdminTableGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/table/{table}',
    ...options
});

/**
 * List table items with filters
 *
 * List items from a table with optional filters, pluck, order, and index. Admins see all items; managers are scoped to their category.
 */
export const adminTableList = <ThrowOnError extends boolean = false>(options: Options<AdminTableListData, ThrowOnError>) => (options.client ?? client).post<AdminTableListResponses, AdminTableListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/table/{table}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get usage consumption between dates
 *
 * Returns usage consumption data between the specified dates with optional filtering.
 */
export const adminUsageConsumption = <ThrowOnError extends boolean = false>(options: Options<AdminUsageConsumptionData, ThrowOnError>) => (options.client ?? client).put<AdminUsageConsumptionResponses, AdminUsageConsumptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/usage',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get start/end consumption
 *
 * Returns consumption data at start and end dates for comparison.
 */
export const adminUsageStartEnd = <ThrowOnError extends boolean = false>(options: Options<AdminUsageStartEndData, ThrowOnError>) => (options.client ?? client).put<AdminUsageStartEndResponses, AdminUsageStartEndErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/usage/start_end',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get usage consumers for item type
 *
 * Returns distinct consumer types for the given item type.
 */
export const adminUsageConsumers = <ThrowOnError extends boolean = false>(options: Options<AdminUsageConsumersData, ThrowOnError>) => (options.client ?? client).get<AdminUsageConsumersResponses, AdminUsageConsumersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/usage/consumers/{item_type}',
    ...options
});

/**
 * Get distinct usage items
 *
 * Returns distinct items for a consumer type within a date range.
 */
export const adminUsageDistinctItems = <ThrowOnError extends boolean = false>(options: Options<AdminUsageDistinctItemsData, ThrowOnError>) => (options.client ?? client).get<AdminUsageDistinctItemsResponses, AdminUsageDistinctItemsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/usage/distinct_items/{item_consumer}/{start}/{end}',
    ...options
});

/**
 * Get usage parameters by IDs
 *
 * Returns usage parameters filtered by a list of IDs.
 */
export const adminUsageListParameters = <ThrowOnError extends boolean = false>(options: Options<AdminUsageListParametersData, ThrowOnError>) => (options.client ?? client).put<AdminUsageListParametersResponses, AdminUsageListParametersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/usage/list_parameters',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get usage groupings dropdown
 *
 * Returns usage groupings structured for dropdown menus. Shape: ``{system: {desktop:[...], media:[...], storage:[...], user:[...]}, custom: {...}}``.
 */
export const adminUsageGroupingsDropdown = <ThrowOnError extends boolean = false>(options?: Options<AdminUsageGroupingsDropdownData, ThrowOnError>) => (options?.client ?? client).get<AdminUsageGroupingsDropdownResponses, AdminUsageGroupingsDropdownErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/usage/groupings_dropdown',
    ...options
});

/**
 * Get usage grouping by ID
 *
 * Returns a specific usage grouping.
 */
export const adminUsageGroupingGet = <ThrowOnError extends boolean = false>(options: Options<AdminUsageGroupingGetData, ThrowOnError>) => (options.client ?? client).get<AdminUsageGroupingGetResponses, AdminUsageGroupingGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/usage/grouping/{grouping_id}',
    ...options
});

/**
 * Get usage credits for item
 *
 * Returns usage credits for a specific item, type, grouping, and date range.
 */
export const adminUsageCredits = <ThrowOnError extends boolean = false>(options: Options<AdminUsageCreditsData, ThrowOnError>) => (options.client ?? client).get<AdminUsageCreditsResponses, AdminUsageCreditsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/usage/credits/{consumer}/{item_type}/{item_id}/{grouping_id}/{start_date}/{end_date}',
    ...options
});

/**
 * Get all reset dates
 *
 * Returns all usage reset dates.
 */
export const adminUsageResetDatesAll = <ThrowOnError extends boolean = false>(options?: Options<AdminUsageResetDatesAllData, ThrowOnError>) => (options?.client ?? client).get<AdminUsageResetDatesAllResponses, AdminUsageResetDatesAllErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/usage/reset_date',
    ...options
});

/**
 * Get reset dates in range
 *
 * Returns usage reset dates within the specified date range.
 */
export const adminUsageResetDatesRange = <ThrowOnError extends boolean = false>(options: Options<AdminUsageResetDatesRangeData, ThrowOnError>) => (options.client ?? client).get<AdminUsageResetDatesRangeResponses, AdminUsageResetDatesRangeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/usage/reset_date/{start_date}/{end_date}',
    ...options
});

/**
 * Get impersonation JWT for user
 *
 * Generates a JWT token to impersonate the specified user. Requires ownership check.
 */
export const adminGetJwt = <ThrowOnError extends boolean = false>(options: Options<AdminGetJwtData, ThrowOnError>) => (options.client ?? client).get<AdminGetJwtResponses, AdminGetJwtErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/jwt/{user_id}',
    ...options
});

/**
 * Check if user exists
 *
 * Returns whether a user with the given ID exists.
 */
export const adminUserExists = <ThrowOnError extends boolean = false>(options: Options<AdminUserExistsData, ThrowOnError>) => (options.client ?? client).get<AdminUserExistsResponses, AdminUserExistsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/{user_id}/exists',
    ...options
});

/**
 * Get user full data
 *
 * Returns full data for a user.
 */
export const adminGetUser = <ThrowOnError extends boolean = false>(options: Options<AdminGetUserData, ThrowOnError>) => (options.client ?? client).get<AdminGetUserResponses, AdminGetUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/{user_id}',
    ...options
});

/**
 * Update user
 *
 * Updates a single user.
 */
export const adminUpdateUser = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateUserData, ThrowOnError>) => (options.client ?? client).put<AdminUpdateUserResponses, AdminUpdateUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get user raw data
 *
 * Returns raw user data from database.
 */
export const adminGetUserRaw = <ThrowOnError extends boolean = false>(options: Options<AdminGetUserRawData, ThrowOnError>) => (options.client ?? client).get<AdminGetUserRawResponses, AdminGetUserRawErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/{user_id}/raw',
    ...options
});

/**
 * Delete users
 *
 * Deletes one or more users.
 */
export const adminDeleteUsers = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteUsersData, ThrowOnError>) => (options.client ?? client).delete<AdminDeleteUsersResponses, AdminDeleteUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List users
 *
 * Returns list of users. Admins see all, managers see their category.
 */
export const adminListUsers = <ThrowOnError extends boolean = false>(options?: Options<AdminListUsersData, ThrowOnError>) => (options?.client ?? client).get<AdminListUsersResponses, AdminListUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/users',
    ...options
});

/**
 * List users by navigation context
 *
 * Returns list of users for management or quotas_limits navigation.
 */
export const adminListUsersNav = <ThrowOnError extends boolean = false>(options: Options<AdminListUsersNavData, ThrowOnError>) => (options.client ?? client).get<AdminListUsersNavResponses, AdminListUsersNavErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/users/{nav}/users',
    ...options
});

/**
 * Create user
 *
 * Creates a new user.
 */
export const adminCreateUser = <ThrowOnError extends boolean = false>(options: Options<AdminCreateUserData, ThrowOnError>) => (options.client ?? client).post<AdminCreateUserResponses, AdminCreateUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk update users
 *
 * Updates multiple users at once.
 */
export const adminUpdateUsersBulk = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateUsersBulkData, ThrowOnError>) => (options.client ?? client).put<AdminUpdateUsersBulkResponses, AdminUpdateUsersBulkErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/users/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Force logout user
 *
 * Revokes all sessions for a user.
 */
export const adminUserLogout = <ThrowOnError extends boolean = false>(options: Options<AdminUserLogoutData, ThrowOnError>) => (options.client ?? client).put<AdminUserLogoutResponses, AdminUserLogoutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/{user_id}/logout',
    ...options
});

/**
 * Search users
 *
 * Search users by name term.
 */
export const adminSearchUsers = <ThrowOnError extends boolean = false>(options: Options<AdminSearchUsersData, ThrowOnError>) => (options.client ?? client).post<AdminSearchUsersResponses, AdminSearchUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/users/search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validate CSV for user creation
 *
 * Validates a list of users from CSV data.
 */
export const adminValidateCsvUsers = <ThrowOnError extends boolean = false>(options: Options<AdminValidateCsvUsersData, ThrowOnError>) => (options.client ?? client).post<AdminValidateCsvUsersResponses, AdminValidateCsvUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/users/csv/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validate CSV for user editing
 *
 * Validates a list of users from CSV for editing.
 */
export const adminValidateCsvUsersEdit = <ThrowOnError extends boolean = false>(options: Options<AdminValidateCsvUsersEditData, ThrowOnError>) => (options.client ?? client).put<AdminValidateCsvUsersEditResponses, AdminValidateCsvUsersEditErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/users/csv/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Import users from CSV
 *
 * Creates users from validated CSV data.
 */
export const adminImportCsvUsers = <ThrowOnError extends boolean = false>(options: Options<AdminImportCsvUsersData, ThrowOnError>) => (options.client ?? client).post<AdminImportCsvUsersResponses, AdminImportCsvUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/users/csv',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Edit users from CSV
 *
 * Updates users from validated CSV data.
 */
export const adminEditCsvUsers = <ThrowOnError extends boolean = false>(options: Options<AdminEditCsvUsersData, ThrowOnError>) => (options.client ?? client).put<AdminEditCsvUsersResponses, AdminEditCsvUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/users/csv',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk create users
 *
 * Creates multiple users in bulk.
 */
export const adminBulkCreateUsers = <ThrowOnError extends boolean = false>(options: Options<AdminBulkCreateUsersData, ThrowOnError>) => (options.client ?? client).post<AdminBulkCreateUsersResponses, AdminBulkCreateUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/bulk/user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add secondary groups
 *
 * Adds secondary groups to specified users.
 */
export const adminSecondaryGroupsAdd = <ThrowOnError extends boolean = false>(options: Options<AdminSecondaryGroupsAddData, ThrowOnError>) => (options.client ?? client).put<AdminSecondaryGroupsAddResponses, AdminSecondaryGroupsAddErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/secondary-groups/add',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Overwrite secondary groups
 *
 * Overwrites secondary groups for specified users.
 */
export const adminSecondaryGroupsOverwrite = <ThrowOnError extends boolean = false>(options: Options<AdminSecondaryGroupsOverwriteData, ThrowOnError>) => (options.client ?? client).put<AdminSecondaryGroupsOverwriteResponses, AdminSecondaryGroupsOverwriteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/secondary-groups/overwrite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove secondary groups
 *
 * Removes secondary groups from specified users.
 */
export const adminSecondaryGroupsDelete = <ThrowOnError extends boolean = false>(options: Options<AdminSecondaryGroupsDeleteData, ThrowOnError>) => (options.client ?? client).put<AdminSecondaryGroupsDeleteResponses, AdminSecondaryGroupsDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/secondary-groups/delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get user password policy
 *
 * Returns the password policy for a user.
 */
export const adminGetPasswordPolicy = <ThrowOnError extends boolean = false>(options: Options<AdminGetPasswordPolicyData, ThrowOnError>) => (options.client ?? client).get<AdminGetPasswordPolicyResponses, AdminGetPasswordPolicyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/password-policy/{user_id}',
    ...options
});

/**
 * Reset user VPN
 *
 * Resets VPN credentials for a user.
 */
export const adminResetVpn = <ThrowOnError extends boolean = false>(options: Options<AdminResetVpnData, ThrowOnError>) => (options.client ?? client).put<AdminResetVpnResponses, AdminResetVpnErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/reset-vpn/{user_id}',
    ...options
});

/**
 * List groups
 *
 * Returns all groups. Managers see only their category groups.
 */
export const adminListGroups = <ThrowOnError extends boolean = false>(options?: Options<AdminListGroupsData, ThrowOnError>) => (options?.client ?? client).get<AdminListGroupsResponses, AdminListGroupsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/groups',
    ...options
});

/**
 * List groups by navigation context
 *
 * Returns groups for management or quotas_limits navigation.
 */
export const adminListGroupsNav = <ThrowOnError extends boolean = false>(options: Options<AdminListGroupsNavData, ThrowOnError>) => (options.client ?? client).get<AdminListGroupsNavResponses, AdminListGroupsNavErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/users/{nav}/groups',
    ...options
});

/**
 * Delete group
 *
 * Deletes a group.
 */
export const adminDeleteGroup = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteGroupData, ThrowOnError>) => (options.client ?? client).delete<AdminDeleteGroupResponses, AdminDeleteGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/group/{group_id}',
    ...options
});

/**
 * Get group
 *
 * Returns full data for a group.
 */
export const adminGetGroup = <ThrowOnError extends boolean = false>(options: Options<AdminGetGroupData, ThrowOnError>) => (options.client ?? client).get<AdminGetGroupResponses, AdminGetGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/group/{group_id}',
    ...options
});

/**
 * Update group
 *
 * Updates a group.
 */
export const adminUpdateGroup = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateGroupData, ThrowOnError>) => (options.client ?? client).put<AdminUpdateGroupResponses, AdminUpdateGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/group/{group_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create group
 *
 * Creates a new group.
 */
export const adminCreateGroup = <ThrowOnError extends boolean = false>(options: Options<AdminCreateGroupData, ThrowOnError>) => (options.client ?? client).post<AdminCreateGroupResponses, AdminCreateGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/group',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get users in group
 *
 * Returns all users in a specific group.
 */
export const adminGetGroupUsers = <ThrowOnError extends boolean = false>(options: Options<AdminGetGroupUsersData, ThrowOnError>) => (options.client ?? client).get<AdminGetGroupUsersResponses, AdminGetGroupUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/group/{group_id}/users',
    ...options
});

/**
 * Update group enrollment
 *
 * Updates enrollment settings for a group.
 */
export const adminGroupEnrollment = <ThrowOnError extends boolean = false>(options: Options<AdminGroupEnrollmentData2, ThrowOnError>) => (options.client ?? client).post<AdminGroupEnrollmentResponses, AdminGroupEnrollmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/group/enrollment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List categories by navigation context
 *
 * Returns categories for management or quotas_limits navigation.
 */
export const adminListCategoriesNav = <ThrowOnError extends boolean = false>(options: Options<AdminListCategoriesNavData, ThrowOnError>) => (options.client ?? client).get<AdminListCategoriesNavResponses, AdminListCategoriesNavErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/users/{nav}/categories',
    ...options
});

/**
 * Get users in category
 *
 * Returns all users in a specific category.
 */
export const adminGetCategoryUsers = <ThrowOnError extends boolean = false>(options: Options<AdminGetCategoryUsersData, ThrowOnError>) => (options.client ?? client).get<AdminGetCategoryUsersResponses, AdminGetCategoryUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/category/{category_id}/users',
    ...options
});

/**
 * Get category by name
 *
 * Returns a category ID by its name.
 */
export const adminGetCategoryByName = <ThrowOnError extends boolean = false>(options: Options<AdminGetCategoryByNameData, ThrowOnError>) => (options.client ?? client).get<AdminGetCategoryByNameResponses, AdminGetCategoryByNameErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/category/get/{category_name}',
    ...options
});

/**
 * Get group by category and name
 *
 * Returns a group ID by category name and group name.
 */
export const adminGetGroupByNameCategory = <ThrowOnError extends boolean = false>(options: Options<AdminGetGroupByNameCategoryData, ThrowOnError>) => (options.client ?? client).get<AdminGetGroupByNameCategoryResponses, AdminGetGroupByNameCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/group/get/{category_name}/{group_name}',
    ...options
});

/**
 * Update group quota
 *
 * Updates quota for a group.
 */
export const adminUpdateGroupQuota = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateGroupQuotaData, ThrowOnError>) => (options.client ?? client).put<AdminUpdateGroupQuotaResponses, AdminUpdateGroupQuotaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/quota/group/{group_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update group limits
 *
 * Updates limits for a group.
 */
export const adminUpdateGroupLimits = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateGroupLimitsData, ThrowOnError>) => (options.client ?? client).put<AdminUpdateGroupLimitsResponses, AdminUpdateGroupLimitsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/limits/group/{group_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check user deletion dependencies
 *
 * Checks dependencies before deleting users.
 */
export const adminUserDeleteCheck = <ThrowOnError extends boolean = false>(options: Options<AdminUserDeleteCheckData, ThrowOnError>) => (options.client ?? client).post<AdminUserDeleteCheckResponses, AdminUserDeleteCheckErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/delete/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check group deletion dependencies
 *
 * Checks dependencies before deleting groups.
 */
export const adminGroupDeleteCheck = <ThrowOnError extends boolean = false>(options: Options<AdminGroupDeleteCheckData, ThrowOnError>) => (options.client ?? client).post<AdminGroupDeleteCheckResponses, AdminGroupDeleteCheckErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/group/delete/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check category deletion dependencies
 *
 * Checks dependencies before deleting categories.
 */
export const adminCategoryDeleteCheck = <ThrowOnError extends boolean = false>(options: Options<AdminCategoryDeleteCheckData, ThrowOnError>) => (options.client ?? client).post<AdminCategoryDeleteCheckResponses, AdminCategoryDeleteCheckErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/category/delete/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check group/category association
 *
 * Validates a group/category association.
 */
export const adminCheckGroupCategory = <ThrowOnError extends boolean = false>(options: Options<AdminCheckGroupCategoryData2, ThrowOnError>) => (options.client ?? client).post<AdminCheckGroupCategoryResponses, AdminCheckGroupCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/check/group/category',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get admin templates
 *
 * Returns templates allowed for the admin/manager.
 */
export const adminGetTemplates = <ThrowOnError extends boolean = false>(options?: Options<AdminGetTemplatesData, ThrowOnError>) => (options?.client ?? client).get<AdminGetTemplatesResponses, AdminGetTemplatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/templates',
    ...options
});

/**
 * Get user templates
 *
 * Returns templates allowed for a specific user.
 */
export const adminGetUserTemplates = <ThrowOnError extends boolean = false>(options: Options<AdminGetUserTemplatesData, ThrowOnError>) => (options.client ?? client).get<AdminGetUserTemplatesResponses, AdminGetUserTemplatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/user/{user_id}/templates',
    ...options
});

/**
 * Get user desktops
 *
 * Returns desktops for a specific user.
 */
export const adminGetUserDesktops = <ThrowOnError extends boolean = false>(options: Options<AdminGetUserDesktopsData, ThrowOnError>) => (options.client ?? client).get<AdminGetUserDesktopsResponses, AdminGetUserDesktopsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/user/{user_id}/desktops',
    ...options
});

/**
 * List available roles
 *
 * Returns roles available to the current user.
 */
export const adminGetRoles = <ThrowOnError extends boolean = false>(options?: Options<AdminGetRolesData, ThrowOnError>) => (options?.client ?? client).get<AdminGetRolesResponses, AdminGetRolesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/roles',
    ...options
});

/**
 * Get user VPN config with OS
 *
 * Returns VPN configuration for a user with kind and OS.
 */
export const adminGetUserVpnWithOs = <ThrowOnError extends boolean = false>(options: Options<AdminGetUserVpnWithOsData, ThrowOnError>) => (options.client ?? client).get<AdminGetUserVpnWithOsResponses, AdminGetUserVpnWithOsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/{user_id}/vpn/{kind}/{os}',
    ...options
});

/**
 * Get user VPN config
 *
 * Returns VPN configuration for a user.
 */
export const adminGetUserVpn = <ThrowOnError extends boolean = false>(options: Options<AdminGetUserVpnData, ThrowOnError>) => (options.client ?? client).get<AdminGetUserVpnResponses, AdminGetUserVpnErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/{user_id}/vpn/{kind}',
    ...options
});

/**
 * Get user schema
 *
 * Returns roles, categories, and groups for admin forms.
 */
export const adminGetUserSchema = <ThrowOnError extends boolean = false>(options?: Options<AdminGetUserSchemaData, ThrowOnError>) => (options?.client ?? client).get<AdminGetUserSchemaResponses, AdminGetUserSchemaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/userschema',
    ...options
});

/**
 * Get admin quotas
 *
 * Returns quotas for the admin view.
 */
export const adminGetQuotas = <ThrowOnError extends boolean = false>(options?: Options<AdminGetQuotasData, ThrowOnError>) => (options?.client ?? client).get<AdminGetQuotasResponses, AdminGetQuotasErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/quotas',
    ...options
});

/**
 * Get user applied quota
 *
 * Returns the applied quota for a specific user.
 */
export const adminGetUserAppliedQuota = <ThrowOnError extends boolean = false>(options: Options<AdminGetUserAppliedQuotaData, ThrowOnError>) => (options.client ?? client).get<AdminGetUserAppliedQuotaResponses, AdminGetUserAppliedQuotaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/appliedquota/{user_id}',
    ...options
});

/**
 * Migrate user
 *
 * Migrates a user's resources to another user.
 */
export const adminMigrateUser = <ThrowOnError extends boolean = false>(options: Options<AdminMigrateUserData, ThrowOnError>) => (options.client ?? client).put<AdminMigrateUserResponses, AdminMigrateUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/migrate/{user_id}/{target_user_id}',
    ...options
});

/**
 * Check user migration
 *
 * Checks if migration between two users is valid.
 */
export const adminCheckMigration = <ThrowOnError extends boolean = false>(options: Options<AdminCheckMigrationData, ThrowOnError>) => (options.client ?? client).get<AdminCheckMigrationResponses, AdminCheckMigrationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/migrate/check/{user_id}/{target_user_id}',
    ...options
});

/**
 * Migrate user desktops
 *
 * Migrates desktops from one user to another.
 */
export const adminMigrateUserDesktops = <ThrowOnError extends boolean = false>(options: Options<AdminMigrateUserDesktopsData, ThrowOnError>) => (options.client ?? client).put<AdminMigrateUserDesktopsResponses, AdminMigrateUserDesktopsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/migrate/resource/desktop/{user_id}/{target_user_id}',
    ...options
});

/**
 * Migrate user templates
 *
 * Migrates templates from one user to another.
 */
export const adminMigrateUserTemplates = <ThrowOnError extends boolean = false>(options: Options<AdminMigrateUserTemplatesData, ThrowOnError>) => (options.client ?? client).put<AdminMigrateUserTemplatesResponses, AdminMigrateUserTemplatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/migrate/resource/template/{user_id}/{target_user_id}',
    ...options
});

/**
 * Migrate user media
 *
 * Migrates media from one user to another.
 */
export const adminMigrateUserMedia = <ThrowOnError extends boolean = false>(options: Options<AdminMigrateUserMediaData, ThrowOnError>) => (options.client ?? client).put<AdminMigrateUserMediaResponses, AdminMigrateUserMediaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/migrate/resource/media/{user_id}/{target_user_id}',
    ...options
});

/**
 * Migrate user deployments
 *
 * Migrates deployments from one user to another.
 */
export const adminMigrateUserDeployments = <ThrowOnError extends boolean = false>(options: Options<AdminMigrateUserDeploymentsData, ThrowOnError>) => (options.client ?? client).put<AdminMigrateUserDeploymentsResponses, AdminMigrateUserDeploymentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/migrate/resource/deployments/{user_id}/{target_user_id}',
    ...options
});

/**
 * Check migrated users
 *
 * Checks if any users in the list are migrated.
 */
export const adminCheckMigrated = <ThrowOnError extends boolean = false>(options: Options<AdminCheckMigratedData2, ThrowOnError>) => (options.client ?? client).post<AdminCheckMigratedResponses, AdminCheckMigratedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/check/migrated',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get category bastion domain
 *
 * Returns the bastion domain for a category.
 */
export const adminGetBastionDomain = <ThrowOnError extends boolean = false>(options: Options<AdminGetBastionDomainData, ThrowOnError>) => (options.client ?? client).get<AdminGetBastionDomainResponses, AdminGetBastionDomainErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/category/{category_id}/bastion_domain',
    ...options
});

/**
 * Update category bastion domain
 *
 * Updates the bastion domain for a category.
 */
export const adminUpdateBastionDomain = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateBastionDomainData, ThrowOnError>) => (options.client ?? client).put<AdminUpdateBastionDomainResponses, AdminUpdateBastionDomainErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/category/{category_id}/bastion_domain',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get plannings for a specific reservable item
 *
 * Returns all plannings for a specific reservable item, optionally filtered by date range.
 * If no date range is provided, returns ongoing plannings.
 */
export const getItemPlannings = <ThrowOnError extends boolean = false>(options: Options<GetItemPlanningsData, ThrowOnError>) => (options.client ?? client).get<GetItemPlanningsResponses, GetItemPlanningsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/planning/{reservable_item_id}',
    ...options
});

/**
 * Delete a specific planning
 *
 * Deletes a specific planning by its ID.
 */
export const deletePlanning = <ThrowOnError extends boolean = false>(options: Options<DeletePlanningData, ThrowOnError>) => (options.client ?? client).delete<DeletePlanningResponses, DeletePlanningErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/planning/{plan_id}',
    ...options
});

/**
 * Create a new planning
 *
 * Creates a new planning for a reservable resource.
 */
export const createPlanning = <ThrowOnError extends boolean = false>(options: Options<CreatePlanningData, ThrowOnError>) => (options.client ?? client).post<CreatePlanningResponses, CreatePlanningErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/planning',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get list of reservable types
 *
 * Returns a list of all available reservable types (e.g., gpus, usbs).
 */
export const getReservables = <ThrowOnError extends boolean = false>(options?: Options<GetReservablesData, ThrowOnError>) => (options?.client ?? client).get<GetReservablesResponses, GetReservablesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/reservables',
    ...options
});

/**
 * Get items of a specific reservable type
 *
 * Returns all items for a specific reservable type (e.g., all GPUs).
 */
export const getReservableItems = <ThrowOnError extends boolean = false>(options: Options<GetReservableItemsData, ThrowOnError>) => (options.client ?? client).get<GetReservableItemsResponses, GetReservableItemsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/reservables/{reservable_type}',
    ...options
});

/**
 * List enabled subitems
 *
 * Returns the list of enabled subitems for a specific reservable item.
 */
export const listEnabledSubitems = <ThrowOnError extends boolean = false>(options: Options<ListEnabledSubitemsData, ThrowOnError>) => (options.client ?? client).get<ListEnabledSubitemsResponses, ListEnabledSubitemsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/reservable/enabled/{reservable_type}/{item_id}',
    ...options
});

/**
 * List all plans
 *
 * Returns all resource planner plans.
 */
export const listAllPlans = <ThrowOnError extends boolean = false>(options?: Options<ListAllPlansData, ThrowOnError>) => (options?.client ?? client).get<ListAllPlansResponses, ListAllPlansErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/reservables-planner',
    ...options
});

/**
 * Get plans for item
 *
 * Returns plans for a specific item that overlap with ``[start, end]``. If both are omitted, defaults to plans active right now (v3 parity).
 */
export const getItemPlans = <ThrowOnError extends boolean = false>(options: Options<GetItemPlansData, ThrowOnError>) => (options.client ?? client).get<GetItemPlansResponses, GetItemPlansErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/reservables-planner/by-item/{item_id}',
    ...options
});

/**
 * Create plan
 *
 * Creates a new resource planner plan.
 */
export const createPlan = <ThrowOnError extends boolean = false>(options: Options<CreatePlanData, ThrowOnError>) => (options.client ?? client).post<CreatePlanResponses, CreatePlanErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/reservables-planner',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete plan
 *
 * Deletes a resource planner plan and its associated bookings.
 */
export const deletePlan = <ThrowOnError extends boolean = false>(options: Options<DeletePlanData, ThrowOnError>) => (options.client ?? client).delete<DeletePlanResponses, DeletePlanErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/reservables-planner/{plan_id}',
    ...options
});

/**
 * Update plan
 *
 * Updates a resource planner plan's start and end dates.
 */
export const updatePlan = <ThrowOnError extends boolean = false>(options: Options<UpdatePlanData, ThrowOnError>) => (options.client ?? client).put<UpdatePlanResponses, UpdatePlanErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/reservables-planner/{plan_id}/{start}/{end}',
    ...options
});

/**
 * Change desktop owner
 *
 * Reassigns a persistent desktop to a different user. ``@is_admin_or_manager``. Both ``ownsUserId(user_id)`` and ``ownsDomainId(desktop_id)`` are enforced by the service.
 */
export const changeDesktopOwner = <ThrowOnError extends boolean = false>(options: Options<ChangeDesktopOwnerData, ThrowOnError>) => (options.client ?? client).put<ChangeDesktopOwnerResponses, ChangeDesktopOwnerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/{desktop_id}/change-owner/{user_id}',
    ...options
});

/**
 * Change template owner
 *
 * Reassigns a template to a different user. ``@is_admin_or_manager``. Both ``ownsUserId(user_id)`` and ``ownsDomainId(template_id)`` are enforced by the service.
 */
export const changeTemplateOwner = <ThrowOnError extends boolean = false>(options: Options<ChangeTemplateOwnerData, ThrowOnError>) => (options.client ?? client).put<ChangeTemplateOwnerResponses, ChangeTemplateOwnerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/template/{template_id}/change-owner/{user_id}',
    ...options
});

/**
 * Remove disallowed bastion targets
 *
 * Removes bastion targets that are no longer allowed based on current permissions.
 */
export const removeDisallowedBastionTargets = <ThrowOnError extends boolean = false>(options?: Options<RemoveDisallowedBastionTargetsData, ThrowOnError>) => (options?.client ?? client).delete<RemoveDisallowedBastionTargetsResponses, RemoveDisallowedBastionTargetsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/bastion/disallowed',
    ...options
});

/**
 * Generate a default card
 *
 * Generates a default card image for a domain. Admin only.
 *
 * @deprecated
 */
export const generateDefaultCard = <ThrowOnError extends boolean = false>(options: Options<GenerateDefaultCardData, ThrowOnError>) => (options.client ?? client).post<GenerateDefaultCardResponses, GenerateDefaultCardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/images/desktops/generate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get maintenance text
 *
 * Returns the current maintenance text.
 */
export const getMaintenanceText = <ThrowOnError extends boolean = false>(options?: Options<GetMaintenanceTextData, ThrowOnError>) => (options?.client ?? client).get<GetMaintenanceTextResponses, GetMaintenanceTextErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/maintenance/text',
    ...options
});

/**
 * Update maintenance text
 *
 * Updates the maintenance text displayed to users.
 */
export const updateMaintenanceText = <ThrowOnError extends boolean = false>(options: Options<UpdateMaintenanceTextData, ThrowOnError>) => (options.client ?? client).put<UpdateMaintenanceTextResponses, UpdateMaintenanceTextErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/maintenance/text',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get category maintenance status
 *
 * Returns the maintenance status for a specific category. Admin only.
 */
export const getCategoryMaintenance = <ThrowOnError extends boolean = false>(options: Options<GetCategoryMaintenanceData, ThrowOnError>) => (options.client ?? client).get<GetCategoryMaintenanceResponses, GetCategoryMaintenanceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/maintenance/{category_id}',
    ...options
});

/**
 * Get maintenance
 *
 * Returns the current maintenance status of the API considering the user role and category.
 */
export const getMaintenance = <ThrowOnError extends boolean = false>(options?: Options<GetMaintenanceData, ThrowOnError>) => (options?.client ?? client).get<GetMaintenanceResponses, GetMaintenanceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/maintenance',
    ...options
});

/**
 * Update maintenance status
 *
 * Updates the maintenance status of the API.
 */
export const updateMaintenance = <ThrowOnError extends boolean = false>(options: Options<UpdateMaintenanceData, ThrowOnError>) => (options.client ?? client).put<UpdateMaintenanceResponses, UpdateMaintenanceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/maintenance',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get user migration configuration
 *
 * Returns the user migration configuration settings.
 */
export const getMigrationConfig = <ThrowOnError extends boolean = false>(options?: Options<GetMigrationConfigData, ThrowOnError>) => (options?.client ?? client).get<GetMigrationConfigResponses, GetMigrationConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/config/user-migration',
    ...options
});

/**
 * Update user migration configuration
 *
 * Updates the user migration configuration settings.
 */
export const updateMigrationConfig = <ThrowOnError extends boolean = false>(options: Options<UpdateMigrationConfigData, ThrowOnError>) => (options.client ?? client).put<UpdateMigrationConfigResponses, UpdateMigrationConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/config/user-migration',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all user migrations
 *
 * Returns the list of all user migration records.
 */
export const getAllMigrations = <ThrowOnError extends boolean = false>(options?: Options<GetAllMigrationsData, ThrowOnError>) => (options?.client ?? client).get<GetAllMigrationsResponses, GetAllMigrationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user-migrations',
    ...options
});

/**
 * Revoke a user migration
 *
 * Changes the status of a user migration to revoked.
 */
export const revokeMigration = <ThrowOnError extends boolean = false>(options: Options<RevokeMigrationData, ThrowOnError>) => (options.client ?? client).put<RevokeMigrationResponses, RevokeMigrationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user-migration/{migration_id}/revoke',
    ...options
});

/**
 * Delete a user migration
 *
 * Permanently deletes a user migration record.
 */
export const deleteMigration = <ThrowOnError extends boolean = false>(options: Options<DeleteMigrationData, ThrowOnError>) => (options.client ?? client).delete<DeleteMigrationResponses, DeleteMigrationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user-migration/{migration_id}',
    ...options
});

/**
 * Delete entries past cutoff time
 *
 * Permanently deletes all recycle bin entries that have surpassed the cutoff time.
 */
export const deleteCutoffTimeSurpassed = <ThrowOnError extends boolean = false>(options?: Options<DeleteCutoffTimeSurpassedData, ThrowOnError>) => (options?.client ?? client).delete<DeleteCutoffTimeSurpassedResponses, DeleteCutoffTimeSurpassedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/recycle-bin/cutoff-time-surpassed',
    ...options
});

/**
 * List entries stuck mid-delete
 *
 * Lists recycle bin entries stranded in 'deleting' or 'queued' (e.g. orphaned by an isard-api restart while the delete queue was draining). Read-only; optional 'older_than_minutes' filters out entries that may still be actively draining.
 */
export const listStuckRecycleBinEntries = <ThrowOnError extends boolean = false>(options?: Options<ListStuckRecycleBinEntriesData, ThrowOnError>) => (options?.client ?? client).get<ListStuckRecycleBinEntriesResponses, ListStuckRecycleBinEntriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/recycle-bin/stuck',
    ...options
});

/**
 * Recover entries stuck mid-delete
 *
 * Re-enqueues recycle bin entries stranded in 'deleting' or 'queued' so the bulk-delete worker retries them. Manual admin recovery for entries orphaned by an isard-api restart (the startup reconcile only recovers 'queued'). Idempotent for disks already deleted.
 */
export const recoverStuckRecycleBinEntries = <ThrowOnError extends boolean = false>(options: Options<RecoverStuckRecycleBinEntriesData, ThrowOnError>) => (options.client ?? client).post<RecoverStuckRecycleBinEntriesResponses, RecoverStuckRecycleBinEntriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/recycle-bin/recover-stuck',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set old entries max time
 *
 * Sets the maximum time (in hours) before old entries are processed.
 */
export const setOldEntriesMaxTime = <ThrowOnError extends boolean = false>(options: Options<SetOldEntriesMaxTimeData, ThrowOnError>) => (options.client ?? client).put<SetOldEntriesMaxTimeResponses, SetOldEntriesMaxTimeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/recycle-bin/old-entries/max-time/{max_time}',
    ...options
});

/**
 * Set old entries action
 *
 * Sets the action to perform on old entries (delete or none).
 */
export const setOldEntriesAction = <ThrowOnError extends boolean = false>(options: Options<SetOldEntriesActionData, ThrowOnError>) => (options.client ?? client).put<SetOldEntriesActionResponses, SetOldEntriesActionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/recycle-bin/old-entries/action/{action}',
    ...options
});

/**
 * Get old entries configuration
 *
 * Returns the configuration for old recycle bin entries.
 */
export const getOldEntriesConfig = <ThrowOnError extends boolean = false>(options?: Options<GetOldEntriesConfigData, ThrowOnError>) => (options?.client ?? client).get<GetOldEntriesConfigResponses, GetOldEntriesConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/recycle-bin/old-entries/config',
    ...options
});

/**
 * Delete old entries
 *
 * Permanently deletes recycle bin entries older than the configured max time.
 */
export const deleteOldEntries = <ThrowOnError extends boolean = false>(options?: Options<DeleteOldEntriesData, ThrowOnError>) => (options?.client ?? client).put<DeleteOldEntriesResponses, DeleteOldEntriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/recycle-bin/old-entries/delete',
    ...options
});

/**
 * Set default delete behavior
 *
 * Sets whether items are sent to recycle bin or deleted permanently by default.
 */
export const setDefaultDelete = <ThrowOnError extends boolean = false>(options: Options<SetDefaultDeleteData, ThrowOnError>) => (options.client ?? client).put<SetDefaultDeleteResponses, SetDefaultDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/recycle-bin/config/default-delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get delete action
 *
 * Returns the configured delete action (move or delete).
 */
export const getDeleteAction = <ThrowOnError extends boolean = false>(options?: Options<GetDeleteActionData, ThrowOnError>) => (options?.client ?? client).get<GetDeleteActionResponses, GetDeleteActionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/recycle-bin/config/delete-action',
    ...options
});

/**
 * Set delete action
 *
 * Sets the delete action (move to recycle bin or delete permanently).
 */
export const setDeleteAction = <ThrowOnError extends boolean = false>(options: Options<SetDeleteActionData, ThrowOnError>) => (options.client ?? client).put<SetDeleteActionResponses, SetDeleteActionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/recycle-bin/config/delete-action/{action}',
    ...options
});

/**
 * Get all unused item timeout rules
 *
 * Returns all configured unused item timeout rules.
 */
export const getAllUnusedItemTimeoutRules = <ThrowOnError extends boolean = false>(options?: Options<GetAllUnusedItemTimeoutRulesData, ThrowOnError>) => (options?.client ?? client).get<GetAllUnusedItemTimeoutRulesResponses, GetAllUnusedItemTimeoutRulesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/recycle-bin/unused-item-timeout-rules',
    ...options
});

/**
 * Create unused item timeout rule
 *
 * Creates a new unused item timeout rule.
 */
export const createUnusedItemTimeoutRule = <ThrowOnError extends boolean = false>(options: Options<CreateUnusedItemTimeoutRuleData, ThrowOnError>) => (options.client ?? client).post<CreateUnusedItemTimeoutRuleResponses, CreateUnusedItemTimeoutRuleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/recycle-bin/unused-item-timeout-rules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete unused item timeout rule
 *
 * Deletes an unused item timeout rule.
 */
export const deleteUnusedItemTimeoutRule = <ThrowOnError extends boolean = false>(options: Options<DeleteUnusedItemTimeoutRuleData, ThrowOnError>) => (options.client ?? client).delete<DeleteUnusedItemTimeoutRuleResponses, DeleteUnusedItemTimeoutRuleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/recycle-bin/unused-item-timeout-rule/{rule_id}',
    ...options
});

/**
 * Get unused item timeout rule
 *
 * Returns a specific unused item timeout rule.
 */
export const getUnusedItemTimeoutRule = <ThrowOnError extends boolean = false>(options: Options<GetUnusedItemTimeoutRuleData, ThrowOnError>) => (options.client ?? client).get<GetUnusedItemTimeoutRuleResponses, GetUnusedItemTimeoutRuleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/recycle-bin/unused-item-timeout-rule/{rule_id}',
    ...options
});

/**
 * Update unused item timeout rule
 *
 * Updates an existing unused item timeout rule.
 */
export const updateUnusedItemTimeoutRule = <ThrowOnError extends boolean = false>(options: Options<UpdateUnusedItemTimeoutRuleData, ThrowOnError>) => (options.client ?? client).put<UpdateUnusedItemTimeoutRuleResponses, UpdateUnusedItemTimeoutRuleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/recycle-bin/unused-item-timeout-rule/{rule_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send unused items to recycle bin
 *
 * Finds unused desktops and sends them to the recycle bin. Called by the scheduler for automatic cleanup.
 *
 * @deprecated
 */
export const recycleBinAddUnusedItems = <ThrowOnError extends boolean = false>(options?: Options<RecycleBinAddUnusedItemsData, ThrowOnError>) => (options?.client ?? client).post<RecycleBinAddUnusedItemsResponses, RecycleBinAddUnusedItemsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/recycle-bin/unused-items',
    ...options
});

/**
 * Set storage to maintenance status
 *
 * Sets a storage item to maintenance status.
 */
export const setStorageMaintenance = <ThrowOnError extends boolean = false>(options: Options<SetStorageMaintenanceData, ThrowOnError>) => (options.client ?? client).put<SetStorageMaintenanceResponses, SetStorageMaintenanceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}/status/maintenance',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set storage to ready status
 *
 * Sets a storage item to ready status.
 */
export const setStorageReady = <ThrowOnError extends boolean = false>(options: Options<SetStorageReadyData, ThrowOnError>) => (options.client ?? client).put<SetStorageReadyResponses, SetStorageReadyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}/status/ready',
    ...options
});

/**
 * Batch check backing chain
 *
 * Check backing chain for a batch of storages by their IDs.
 */
export const batchCheckBackingChain = <ThrowOnError extends boolean = false>(options: Options<BatchCheckBackingChainData, ThrowOnError>) => (options.client ?? client).put<BatchCheckBackingChainResponses, BatchCheckBackingChainErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/storage/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Batch check backing chain by status
 *
 * Check backing chain for all storages with the given status.
 */
export const batchCheckBackingChainByStatus = <ThrowOnError extends boolean = false>(options: Options<BatchCheckBackingChainByStatusData, ThrowOnError>) => (options.client ?? client).put<BatchCheckBackingChainByStatusResponses, BatchCheckBackingChainByStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/storage/status/{status}',
    ...options
});

/**
 * Create a new storage
 *
 * Creates a new storage with the given specifications.
 */
export const createStorage = <ThrowOnError extends boolean = false>(options: Options<CreateStorageData, ThrowOnError>) => (options.client ?? client).post<CreateStorageResponses, CreateStorageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/priority/{priority}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get storage and domain statuses
 *
 * Returns the status of a storage and its associated domains.
 */
export const getStorageStatuses = <ThrowOnError extends boolean = false>(options: Options<GetStorageStatusesData, ThrowOnError>) => (options.client ?? client).get<GetStorageStatusesResponses, GetStorageStatusesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}/statuses',
    ...options
});

/**
 * Sparsify a storage
 *
 * Creates a task to sparsify a storage qcow2 image.
 */
export const sparsifyStorage = <ThrowOnError extends boolean = false>(options: Options<SparsifyStorageData, ThrowOnError>) => (options.client ?? client).put<SparsifyStorageResponses, SparsifyStorageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}/sparsify/priority/{priority}',
    ...options
});

/**
 * Batch sparsify storages
 *
 * Sparsify multiple storages by their IDs.
 */
export const batchSparsifyStorages = <ThrowOnError extends boolean = false>(options: Options<BatchSparsifyStoragesData, ThrowOnError>) => (options.client ?? client).put<BatchSparsifyStoragesResponses, BatchSparsifyStoragesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/storage/sparsify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Batch sparsify storages by status
 *
 * Sparsify all storages with the given status.
 */
export const batchSparsifyStoragesByStatus = <ThrowOnError extends boolean = false>(options: Options<BatchSparsifyStoragesByStatusData, ThrowOnError>) => (options.client ?? client).put<BatchSparsifyStoragesByStatusResponses, BatchSparsifyStoragesByStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/storage/sparsify/{status}',
    ...options
});

/**
 * Disconnect storage from backing chain
 *
 * Creates a task to disconnect a storage from its backing chain.
 */
export const disconnectStorage = <ThrowOnError extends boolean = false>(options: Options<DisconnectStorageData, ThrowOnError>) => (options.client ?? client).put<DisconnectStorageResponses, DisconnectStorageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}/disconnect/priority/{priority}',
    ...options
});

/**
 * Convert a storage
 *
 * Creates a task to convert a storage to a new format.
 */
export const convertStorage = <ThrowOnError extends boolean = false>(options: Options<ConvertStorageData, ThrowOnError>) => (options.client ?? client).post<ConvertStorageResponses, ConvertStorageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}/convert',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Apply Windows registry patch
 *
 * Applies a registry patch to a storage qcow2 image.
 */
export const virtWinRegStorage = <ThrowOnError extends boolean = false>(options: Options<VirtWinRegStorageData, ThrowOnError>) => (options.client ?? client).put<VirtWinRegStorageResponses, VirtWinRegStorageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}/virt-win-reg/priority/{priority}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Move storage by path
 *
 * Creates a task to move a storage to a new path.
 */
export const moveStorageByPath = <ThrowOnError extends boolean = false>(options: Options<MoveStorageByPathData, ThrowOnError>) => (options.client ?? client).put<MoveStorageByPathResponses, MoveStorageByPathErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}/move/by-path',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rsync storage to path
 *
 * Creates a task to rsync a storage to a destination path.
 */
export const rsyncStorageToPath = <ThrowOnError extends boolean = false>(options: Options<RsyncStorageToPathData, ThrowOnError>) => (options.client ?? client).put<RsyncStorageToPathResponses, RsyncStorageToPathErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}/rsync/to-path',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rsync storage to storage pool
 *
 * Creates a task to rsync a storage to a storage pool.
 */
export const rsyncStorageToStoragePool = <ThrowOnError extends boolean = false>(options: Options<RsyncStorageToStoragePoolData, ThrowOnError>) => (options.client ?? client).put<RsyncStorageToStoragePoolResponses, RsyncStorageToStoragePoolErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}/rsync/to-storage-pool',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete storage path
 *
 * Deletes the path for a storage item.
 */
export const deleteStoragePath = <ThrowOnError extends boolean = false>(options: Options<DeleteStoragePathData, ThrowOnError>) => (options.client ?? client).delete<DeleteStoragePathResponses, DeleteStoragePathErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}/path',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set storage path
 *
 * Sets the path for a storage item.
 */
export const setStoragePath = <ThrowOnError extends boolean = false>(options: Options<SetStoragePathData, ThrowOnError>) => (options.client ?? client).put<SetStoragePathResponses, SetStoragePathErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}/path',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Find a storage on disk
 *
 * Schedules a ``find`` task to locate a storage item on disk and returns the task ID.
 */
export const findStorage = <ThrowOnError extends boolean = false>(options: Options<FindStorageData, ThrowOnError>) => (options.client ?? client).get<FindStorageResponses, FindStorageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/storage/{storage_id}/find',
    ...options
});

/**
 * Batch find storages
 *
 * Finds multiple storages on disk by their IDs.
 */
export const batchFindStorages = <ThrowOnError extends boolean = false>(options: Options<BatchFindStoragesData, ThrowOnError>) => (options.client ?? client).put<BatchFindStoragesResponses, BatchFindStoragesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/storage/find',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Batch find storages by status
 *
 * Finds all storages on disk with the given status.
 */
export const batchFindStoragesByStatus = <ThrowOnError extends boolean = false>(options: Options<BatchFindStoragesByStatusData, ThrowOnError>) => (options.client ?? client).put<BatchFindStoragesByStatusResponses, BatchFindStoragesByStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/storage/find/{status}',
    ...options
});

/**
 * Create storage pool
 *
 * Creates a new storage pool. May return non-blocking warnings (e.g. no storage/hypervisor node serves the new pool yet).
 */
export const createStoragePool = <ThrowOnError extends boolean = false>(options: Options<CreateStoragePoolData, ThrowOnError>) => (options.client ?? client).post<CreateStoragePoolResponses, CreateStoragePoolErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/storage-pool',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all storage pools
 *
 * Returns all storage pools with enriched data.
 */
export const listStoragePools = <ThrowOnError extends boolean = false>(options?: Options<ListStoragePoolsData, ThrowOnError>) => (options?.client ?? client).get<ListStoragePoolsResponses, ListStoragePoolsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/storage-pools',
    ...options
});

/**
 * Delete storage pool
 *
 * Deletes a storage pool by ID.
 */
export const deleteStoragePool = <ThrowOnError extends boolean = false>(options: Options<DeleteStoragePoolData, ThrowOnError>) => (options.client ?? client).delete<DeleteStoragePoolResponses, DeleteStoragePoolErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/storage-pool/{storage_pool_id}',
    ...options
});

/**
 * Get storage pool
 *
 * Returns a specific storage pool by ID.
 */
export const getStoragePool = <ThrowOnError extends boolean = false>(options: Options<GetStoragePoolData, ThrowOnError>) => (options.client ?? client).get<GetStoragePoolResponses, GetStoragePoolErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/storage-pool/{storage_pool_id}',
    ...options
});

/**
 * Update storage pool
 *
 * Updates an existing storage pool. On disable, returns a warning listing pending work (residing disks + queued tasks) that keeps draining.
 */
export const updateStoragePool = <ThrowOnError extends boolean = false>(options: Options<UpdateStoragePoolData, ThrowOnError>) => (options.client ?? client).put<UpdateStoragePoolResponses, UpdateStoragePoolErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/storage-pool/{storage_pool_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Storage pool drain-status
 *
 * Whether a pool is quiescent: enabled flag, categories, residing disks, queued lane jobs, consumer coverage, and a 'drained' flag (true when it can be deleted). Use after disabling a pool to watch it drain.
 */
export const getStoragePoolPending = <ThrowOnError extends boolean = false>(options: Options<GetStoragePoolPendingData, ThrowOnError>) => (options.client ?? client).get<GetStoragePoolPendingResponses, GetStoragePoolPendingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/storage-pool/{storage_pool_id}/pending',
    ...options
});

/**
 * Check category availability
 *
 * Checks if the given categories are available for assignment to a storage pool.
 */
export const checkCategoryStoragePoolAvailability = <ThrowOnError extends boolean = false>(options: Options<CheckCategoryStoragePoolAvailabilityData, ThrowOnError>) => (options.client ?? client).post<CheckCategoryStoragePoolAvailabilityResponses, CheckCategoryStoragePoolAvailabilityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/storage-pool/check-category-availability',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin cancel a task
 *
 * Admin-cancels a task and its whole dependency chain, with no ownership or status gate — clears a wedged / deferred / running-if-cooperative task. Best effort: a queued job drops immediately, a running body stops only if it cooperates by watching the ``task:cancel:<id>`` signal, and a body that does not watch runs to completion. Re-read the task rather than trust the 204. 404 if the task is gone.
 */
export const adminCancelTask = <ThrowOnError extends boolean = false>(options: Options<AdminCancelTaskData, ThrowOnError>) => (options.client ?? client).delete<AdminCancelTaskResponses, AdminCancelTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/task/{task_id}',
    ...options
});

/**
 * Retry a failed task
 *
 * Re-enqueues a failed task on the lane it came from. Admin only. Refused with 428 when the addressed job is not itself the one that failed, when it is a chain finalize step no worker fleet serves, or when a direct dependent was cancelled and rq would therefore never re-run it; 429 when the lane has no live consumer.
 */
export const retryTask = <ThrowOnError extends boolean = false>(options: Options<RetryTaskData, ThrowOnError>) => (options.client ?? client).put<RetryTaskResponses, RetryTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/task/{task_id}/retry',
    ...options
});

/**
 * Retry all failed storage tasks
 *
 * Retries all failed storage tasks. Returns how many were retried, skipped as not retryable, and errored. Admin only.
 */
export const retryAllFailedTasks = <ThrowOnError extends boolean = false>(options?: Options<RetryAllFailedTasksData, ThrowOnError>) => (options?.client ?? client).put<RetryAllFailedTasksResponses, RetryAllFailedTasksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/tasks/retry',
    ...options
});

/**
 * Disconnect a VPN client
 *
 * Disconnects a specific VPN client.
 */
export const vpnConnectionDisconnect = <ThrowOnError extends boolean = false>(options: Options<VpnConnectionDisconnectData, ThrowOnError>) => (options.client ?? client).delete<VpnConnectionDisconnectResponses, VpnConnectionDisconnectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/vpn_connection/{kind}/{client_ip}',
    ...options
});

/**
 * Register VPN client connection
 *
 * Registers a new VPN client connection (connected).
 */
export const vpnConnectionConnect = <ThrowOnError extends boolean = false>(options: Options<VpnConnectionConnectData, ThrowOnError>) => (options.client ?? client).post<VpnConnectionConnectResponses, VpnConnectionConnectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/vpn_connection/{kind}/{client_ip}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update VPN client connection (roamed)
 *
 * Updates a VPN client connection after roaming.
 */
export const vpnConnectionRoam = <ThrowOnError extends boolean = false>(options: Options<VpnConnectionRoamData, ThrowOnError>) => (options.client ?? client).put<VpnConnectionRoamResponses, VpnConnectionRoamErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/vpn_connection/{kind}/{client_ip}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset all VPN connections for a kind
 *
 * Resets all VPN connections for the specified kind (all/users/hypers).
 */
export const vpnConnectionReset = <ThrowOnError extends boolean = false>(options: Options<VpnConnectionResetData, ThrowOnError>) => (options.client ?? client).delete<VpnConnectionResetResponses, VpnConnectionResetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/vpn_connection/{kind}',
    ...options
});

/**
 * Disconnect multiple VPN connections
 *
 * Disconnects multiple VPN connections from a list.
 */
export const vpnConnectionsDisconnect = <ThrowOnError extends boolean = false>(options: Options<VpnConnectionsDisconnectData, ThrowOnError>) => (options.client ?? client).delete<VpnConnectionsDisconnectResponses, VpnConnectionsDisconnectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/vpn_connections',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete analytics graph configuration
 *
 * Deletes an analytics graph configuration by ID.
 */
export const analyticsGraphConfDelete = <ThrowOnError extends boolean = false>(options: Options<AnalyticsGraphConfDeleteData, ThrowOnError>) => (options.client ?? client).delete<AnalyticsGraphConfDeleteResponses, AnalyticsGraphConfDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/analytics/graph/{conf_id}',
    ...options
});

/**
 * Get analytics graph configuration
 *
 * Returns a specific analytics graph configuration by ID.
 */
export const analyticsGraphConfGet = <ThrowOnError extends boolean = false>(options: Options<AnalyticsGraphConfGetData, ThrowOnError>) => (options.client ?? client).get<AnalyticsGraphConfGetResponses, AnalyticsGraphConfGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/analytics/graph/{conf_id}',
    ...options
});

/**
 * Update analytics graph configuration
 *
 * Updates an existing analytics graph configuration.
 */
export const analyticsGraphConfUpdate = <ThrowOnError extends boolean = false>(options: Options<AnalyticsGraphConfUpdateData, ThrowOnError>) => (options.client ?? client).put<AnalyticsGraphConfUpdateResponses, AnalyticsGraphConfUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/analytics/graph/{conf_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create analytics graph configuration
 *
 * Creates a new analytics graph configuration.
 */
export const analyticsGraphConfAdd = <ThrowOnError extends boolean = false>(options: Options<AnalyticsGraphConfAddData, ThrowOnError>) => (options.client ?? client).post<AnalyticsGraphConfAddResponses, AnalyticsGraphConfAddErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/analytics/graph',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get least used desktops
 *
 * Returns desktops that have been least used within the specified period.
 */
export const analyticsDesktopsLessUsed = <ThrowOnError extends boolean = false>(options: Options<AnalyticsDesktopsLessUsedData, ThrowOnError>) => (options.client ?? client).post<AnalyticsDesktopsLessUsedResponses, AnalyticsDesktopsLessUsedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/analytics/desktops/less_used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get recently used desktops
 *
 * Returns desktops that have been recently used within the specified period.
 */
export const analyticsDesktopsRecentlyUsed = <ThrowOnError extends boolean = false>(options: Options<AnalyticsDesktopsRecentlyUsedData, ThrowOnError>) => (options.client ?? client).post<AnalyticsDesktopsRecentlyUsedResponses, AnalyticsDesktopsRecentlyUsedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/analytics/desktops/recently_used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get most used desktops
 *
 * Returns desktops that have been most frequently started within the specified period.
 */
export const analyticsDesktopsMostUsed = <ThrowOnError extends boolean = false>(options: Options<AnalyticsDesktopsMostUsedData, ThrowOnError>) => (options.client ?? client).post<AnalyticsDesktopsMostUsedResponses, AnalyticsDesktopsMostUsedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/analytics/desktops/most_used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get echart daily-items data
 *
 * Returns ``{x, series}`` bucketed by ``(year, month, day)`` of ``table[date_field]``. Distinct from the other echart views which return ``list[{value, name}]``.
 */
export const adminEchartDailyItems = <ThrowOnError extends boolean = false>(options: Options<AdminEchartDailyItemsData, ThrowOnError>) => (options.client ?? client).post<AdminEchartDailyItemsResponses, AdminEchartDailyItemsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/echart/daily_items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get echart data
 *
 * Returns chart data for the specified view type. For ``daily_items`` see ``/admin/item/echart/daily_items``.
 */
export const adminEchart = <ThrowOnError extends boolean = false>(options: Options<AdminEchartData, ThrowOnError>) => (options.client ?? client).post<AdminEchartResponses, AdminEchartErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/echart/{view}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create authentication policy
 *
 * Creates a new authentication policy.
 */
export const adminAuthenticationPolicyAdd = <ThrowOnError extends boolean = false>(options: Options<AdminAuthenticationPolicyAddData, ThrowOnError>) => (options.client ?? client).post<AdminAuthenticationPolicyAddResponses, AdminAuthenticationPolicyAddErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/authentication/policy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List authentication policies
 *
 * Returns all authentication policies.
 */
export const adminAuthenticationPolicies = <ThrowOnError extends boolean = false>(options?: Options<AdminAuthenticationPoliciesData, ThrowOnError>) => (options?.client ?? client).get<AdminAuthenticationPoliciesResponses, AdminAuthenticationPoliciesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/authentication/policies',
    ...options
});

/**
 * Delete authentication policy
 *
 * Deletes an authentication policy by its ID.
 */
export const adminAuthenticationPolicyDelete = <ThrowOnError extends boolean = false>(options: Options<AdminAuthenticationPolicyDeleteData, ThrowOnError>) => (options.client ?? client).delete<AdminAuthenticationPolicyDeleteResponses, AdminAuthenticationPolicyDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/authentication/policy/{policy_id}',
    ...options
});

/**
 * Get authentication policy
 *
 * Returns an authentication policy by its ID.
 */
export const adminAuthenticationPolicy = <ThrowOnError extends boolean = false>(options: Options<AdminAuthenticationPolicyData, ThrowOnError>) => (options.client ?? client).get<AdminAuthenticationPolicyResponses, AdminAuthenticationPolicyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/authentication/policy/{policy_id}',
    ...options
});

/**
 * Update authentication policy
 *
 * Updates an authentication policy by its ID.
 */
export const adminAuthenticationPolicyEdit = <ThrowOnError extends boolean = false>(options: Options<AdminAuthenticationPolicyEditData, ThrowOnError>) => (options.client ?? client).put<AdminAuthenticationPolicyEditResponses, AdminAuthenticationPolicyEditErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/authentication/policy/{policy_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Force email validation at login
 *
 * Forces email validation at login for users matching the policy.
 */
export const adminForceEmail = <ThrowOnError extends boolean = false>(options: Options<AdminForceEmailData, ThrowOnError>) => (options.client ?? client).put<AdminForceEmailResponses, AdminForceEmailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/authentication/force_validate/email/{policy_id}',
    ...options
});

/**
 * Force disclaimer acknowledgement at login
 *
 * Forces disclaimer acknowledgement at login for users matching the policy.
 */
export const adminForceDisclaimer = <ThrowOnError extends boolean = false>(options: Options<AdminForceDisclaimerData, ThrowOnError>) => (options.client ?? client).put<AdminForceDisclaimerResponses, AdminForceDisclaimerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/authentication/force_validate/disclaimer/{policy_id}',
    ...options
});

/**
 * Force password update at login
 *
 * Forces password update at login for users matching the policy.
 */
export const adminForcePassword = <ThrowOnError extends boolean = false>(options: Options<AdminForcePasswordData, ThrowOnError>) => (options.client ?? client).put<AdminForcePasswordResponses, AdminForcePasswordErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/authentication/force_validate/password/{policy_id}',
    ...options
});

/**
 * Get provider configuration
 *
 * Returns the configuration for a specific authentication provider.
 */
export const getProviderConfigRoute = <ThrowOnError extends boolean = false>(options: Options<GetProviderConfigRouteData, ThrowOnError>) => (options.client ?? client).get<GetProviderConfigRouteResponses, GetProviderConfigRouteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/authentication/provider/{provider}',
    ...options
});

/**
 * Update provider configuration
 *
 * Updates the configuration for a specific authentication provider.
 */
export const editProviderConfigRoute = <ThrowOnError extends boolean = false>(options: Options<EditProviderConfigRouteData, ThrowOnError>) => (options.client ?? client).put<EditProviderConfigRouteResponses, EditProviderConfigRouteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/authentication/provider/{provider}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List migration exceptions
 *
 * Returns all migration exceptions.
 */
export const adminGetMigrationExceptions = <ThrowOnError extends boolean = false>(options?: Options<AdminGetMigrationExceptionsData, ThrowOnError>) => (options?.client ?? client).get<AdminGetMigrationExceptionsResponses, AdminGetMigrationExceptionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/authentication/migrations/exceptions',
    ...options
});

/**
 * Add migration exception
 *
 * Adds a migration exception for specific items.
 */
export const adminAddMigrationException = <ThrowOnError extends boolean = false>(options: Options<AdminAddMigrationExceptionData, ThrowOnError>) => (options.client ?? client).post<AdminAddMigrationExceptionResponses, AdminAddMigrationExceptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/authentication/migrations/exceptions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete migration exception
 *
 * Deletes a migration exception by its ID.
 */
export const adminDeleteMigrationException = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteMigrationExceptionData, ThrowOnError>) => (options.client ?? client).delete<AdminDeleteMigrationExceptionResponses, AdminDeleteMigrationExceptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/authentication/migrations/exceptions/{exception_id}',
    ...options
});

/**
 * List backups
 *
 * Get a list of backups. Optionally get a specific backup by ID via query parameter, or limit the result via the limit query parameter.
 */
export const adminBackupsList = <ThrowOnError extends boolean = false>(options?: Options<AdminBackupsListData, ThrowOnError>) => (options?.client ?? client).get<AdminBackupsListResponses, AdminBackupsListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/backups',
    ...options
});

/**
 * Get weekly borg integrity check toggle
 *
 * Return the saved weekly-borg-integrity toggle. Off by default; backupninja containers poll this live before each saturday run.
 */
export const adminBackupIntegrityGet = <ThrowOnError extends boolean = false>(options?: Options<AdminBackupIntegrityGetData, ThrowOnError>) => (options?.client ?? client).get<AdminBackupIntegrityGetResponses, AdminBackupIntegrityGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/backups/integrity',
    ...options
});

/**
 * Enable or disable weekly borg integrity check
 *
 * Persist the weekly-borg-integrity toggle. Takes effect on the next scheduled run; no container restart required.
 */
export const adminBackupIntegritySet = <ThrowOnError extends boolean = false>(options: Options<AdminBackupIntegritySetData, ThrowOnError>) => (options.client ?? client).put<AdminBackupIntegritySetResponses, AdminBackupIntegritySetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/backups/integrity',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get backup configuration
 *
 * Get backup configuration from environment variables.
 */
export const adminBackupConfig = <ThrowOnError extends boolean = false>(options?: Options<AdminBackupConfigData, ThrowOnError>) => (options?.client ?? client).get<AdminBackupConfigResponses, AdminBackupConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/backups/config',
    ...options
});

/**
 * Get a specific backup
 *
 * Get a specific backup by its ID.
 */
export const adminBackupGet = <ThrowOnError extends boolean = false>(options: Options<AdminBackupGetData, ThrowOnError>) => (options.client ?? client).get<AdminBackupGetResponses, AdminBackupGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/backups/{backup_id}',
    ...options
});

/**
 * Submit backup report
 *
 * Ingestion endpoint for backupninja. Rejects non-service callers so regular admin users cannot forge or pollute backup history.
 */
export const adminBackupReport = <ThrowOnError extends boolean = false>(options: Options<AdminBackupReportData, ThrowOnError>) => (options.client ?? client).post<AdminBackupReportResponses, AdminBackupReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/backups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get domain XML
 *
 * Returns the XML configuration for a domain.
 */
export const adminDomainXmlGet = <ThrowOnError extends boolean = false>(options: Options<AdminDomainXmlGetData, ThrowOnError>) => (options.client ?? client).get<AdminDomainXmlGetResponses, AdminDomainXmlGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/domain/{domain_id}/xml',
    ...options
});

/**
 * Update domain XML
 *
 * Updates the XML configuration for a domain and returns the updated XML.
 */
export const adminDomainXmlUpdate = <ThrowOnError extends boolean = false>(options: Options<AdminDomainXmlUpdateData, ThrowOnError>) => (options.client ?? client).post<AdminDomainXmlUpdateResponses, AdminDomainXmlUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/domain/{domain_id}/xml',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a started desktop's live libvirt XML
 *
 * Live libvirt XML (incl. secrets) of a started desktop, from engine RAM. Proxies to the engine's internal API; the XML is never stored in the DB. 409 when the desktop is not running; 404 when the live XML was not captured (restart the desktop to capture).
 */
export const adminDomainLiveXml = <ThrowOnError extends boolean = false>(options: Options<AdminDomainLiveXmlData, ThrowOnError>) => (options.client ?? client).get<AdminDomainLiveXmlResponses, AdminDomainLiveXmlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/domain/{domain_id}/live_xml',
    ...options
});

/**
 * Change desktop status in bulk
 *
 * Changes the status of all desktops matching the current status to the target status.
 */
export const adminDesktopsStatus = <ThrowOnError extends boolean = false>(options: Options<AdminDesktopsStatusData, ThrowOnError>) => (options.client ?? client).put<AdminDesktopsStatusResponses, AdminDesktopsStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/desktops/{current_status}/{target_status}',
    ...options
});

/**
 * Change desktop status by category
 *
 * Changes the status of desktops in a specific category matching the current status to the target status.
 */
export const adminDesktopsStatusCategory = <ThrowOnError extends boolean = false>(options: Options<AdminDesktopsStatusCategoryData, ThrowOnError>) => (options.client ?? client).put<AdminDesktopsStatusCategoryResponses, AdminDesktopsStatusCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/desktops/category/{category}/status/{current_status}/{target_status}',
    ...options
});

/**
 * Update domain storage path
 *
 * Updates the storage path of a domain, replacing all occurrences of the old path with the new path.
 */
export const adminDomainStoragePath = <ThrowOnError extends boolean = false>(options: Options<AdminDomainStoragePathData2, ThrowOnError>) => (options.client ?? client).put<AdminDomainStoragePathResponses, AdminDomainStoragePathErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/domain/{domain_id}/storage_path',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get desktop logs old entries config
 *
 * Returns the configuration for desktop logs old entries management.
 */
export const adminLogsDesktopsConfig = <ThrowOnError extends boolean = false>(options?: Options<AdminLogsDesktopsConfigData, ThrowOnError>) => (options?.client ?? client).get<AdminLogsDesktopsConfigResponses, AdminLogsDesktopsConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/logs_desktops/config/old_entries',
    ...options
});

/**
 * Set desktop logs max time
 *
 * Sets the maximum time (in hours) for desktop logs old entries. Minimum value is 24 hours.
 */
export const adminLogsDesktopsMaxTime = <ThrowOnError extends boolean = false>(options: Options<AdminLogsDesktopsMaxTimeData, ThrowOnError>) => (options.client ?? client).put<AdminLogsDesktopsMaxTimeResponses, AdminLogsDesktopsMaxTimeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/logs_desktops/config/old_entries/max_time/{max_time}',
    ...options
});

/**
 * Set desktop logs old entries action
 *
 * Sets the action for desktop logs old entries. Valid values: "delete", "none".
 */
export const adminLogsDesktopsAction = <ThrowOnError extends boolean = false>(options: Options<AdminLogsDesktopsActionData, ThrowOnError>) => (options.client ?? client).put<AdminLogsDesktopsActionResponses, AdminLogsDesktopsActionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/logs_desktops/config/old_entries/action/{action}',
    ...options
});

/**
 * Delete old desktop logs
 *
 * Deletes desktop logs older than the configured max time. Runs asynchronously and returns the count of logs to delete.
 */
export const adminLogsDesktopsDelete = <ThrowOnError extends boolean = false>(options?: Options<AdminLogsDesktopsDeleteData, ThrowOnError>) => (options?.client ?? client).put<AdminLogsDesktopsDeleteResponses, AdminLogsDesktopsDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/logs_desktops/old_entries/delete',
    ...options
});

/**
 * Delete all desktop logs
 *
 * Deletes all desktop logs regardless of age. Runs asynchronously and returns the count of logs to delete.
 */
export const adminLogsDesktopsDeleteAll = <ThrowOnError extends boolean = false>(options?: Options<AdminLogsDesktopsDeleteAllData, ThrowOnError>) => (options?.client ?? client).delete<AdminLogsDesktopsDeleteAllResponses, AdminLogsDesktopsDeleteAllErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/logs_desktops/old_entries/delete/all',
    ...options
});

/**
 * Get user logs old entries config
 *
 * Returns the configuration for user logs old entries management.
 */
export const adminLogsUsersConfig = <ThrowOnError extends boolean = false>(options?: Options<AdminLogsUsersConfigData, ThrowOnError>) => (options?.client ?? client).get<AdminLogsUsersConfigResponses, AdminLogsUsersConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/logs_users/config/old_entries',
    ...options
});

/**
 * Set user logs max time
 *
 * Sets the maximum time (in hours) for user logs old entries. Minimum value is 24 hours.
 */
export const adminLogsUsersMaxTime = <ThrowOnError extends boolean = false>(options: Options<AdminLogsUsersMaxTimeData, ThrowOnError>) => (options.client ?? client).put<AdminLogsUsersMaxTimeResponses, AdminLogsUsersMaxTimeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/logs_users/config/old_entries/max_time/{max_time}',
    ...options
});

/**
 * Set user logs old entries action
 *
 * Sets the action for user logs old entries. Valid values: "delete", "none".
 */
export const adminLogsUsersAction = <ThrowOnError extends boolean = false>(options: Options<AdminLogsUsersActionData, ThrowOnError>) => (options.client ?? client).put<AdminLogsUsersActionResponses, AdminLogsUsersActionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/logs_users/config/old_entries/action/{action}',
    ...options
});

/**
 * Delete old user logs
 *
 * Deletes user logs older than the configured max time. Runs asynchronously and returns the count of logs to delete.
 */
export const adminLogsUsersDelete = <ThrowOnError extends boolean = false>(options?: Options<AdminLogsUsersDeleteData, ThrowOnError>) => (options?.client ?? client).put<AdminLogsUsersDeleteResponses, AdminLogsUsersDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/logs_users/old_entries/delete',
    ...options
});

/**
 * Delete all user logs
 *
 * Deletes all user logs regardless of age. Runs asynchronously and returns the count of logs to delete.
 */
export const adminLogsUsersDeleteAll = <ThrowOnError extends boolean = false>(options?: Options<AdminLogsUsersDeleteAllData, ThrowOnError>) => (options?.client ?? client).delete<AdminLogsUsersDeleteAllResponses, AdminLogsUsersDeleteAllErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/logs_users/old_entries/delete/all',
    ...options
});

/**
 * Get XML capabilities
 *
 * Returns libvirt domain XML capabilities and section definitions.
 */
export const adminDomainXmlCapabilities = <ThrowOnError extends boolean = false>(options?: Options<AdminDomainXmlCapabilitiesData, ThrowOnError>) => (options?.client ?? client).get<AdminDomainXmlCapabilitiesResponses, AdminDomainXmlCapabilitiesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/domains/xml_capabilities',
    ...options
});

/**
 * Parse raw XML into sections
 *
 * Split raw XML into editable sections without a saved domain.
 */
export const adminDomainXmlSectionsParse = <ThrowOnError extends boolean = false>(options?: Options<AdminDomainXmlSectionsParseData, ThrowOnError>) => (options?.client ?? client).post<AdminDomainXmlSectionsParseResponses, AdminDomainXmlSectionsParseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/domains/xml_sections/parse',
    ...options
});

/**
 * Get domain XML sections
 *
 * Split a domain's XML into editable sections.
 */
export const adminDomainXmlSectionsGet = <ThrowOnError extends boolean = false>(options: Options<AdminDomainXmlSectionsGetData, ThrowOnError>) => (options.client ?? client).get<AdminDomainXmlSectionsGetResponses, AdminDomainXmlSectionsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/domains/xml_sections/{domain_id}',
    ...options
});

/**
 * Save domain XML sections
 *
 * Merge edited XML sections back into the domain's full XML.
 */
export const adminDomainXmlSectionsSave = <ThrowOnError extends boolean = false>(options: Options<AdminDomainXmlSectionsSaveData2, ThrowOnError>) => (options.client ?? client).post<AdminDomainXmlSectionsSaveResponses, AdminDomainXmlSectionsSaveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/domains/xml_sections/{domain_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Save domain XML sections as a new virt_install template
 *
 * Merges the edited XML sections into the domain's full XML, generalises disk paths / UUIDs / runtime attributes, derives ``www``/``icon``/``vers`` metadata from the libosinfo tag, and inserts a new ``virt_install`` row with a slug-of-name id.
 */
export const adminDomainXmlSectionsSaveAsVirtInstall = <ThrowOnError extends boolean = false>(options: Options<AdminDomainXmlSectionsSaveAsVirtInstallData, ThrowOnError>) => (options.client ?? client).post<AdminDomainXmlSectionsSaveAsVirtInstallResponses, AdminDomainXmlSectionsSaveAsVirtInstallErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/domains/xml_sections/{domain_id}/save_virt_install',
    ...options
});

/**
 * Get virt_install XML sections
 *
 * Split a ``virt_install`` template's XML into editable sections for the admin XML sections editor.
 */
export const adminVirtInstallXmlSectionsGet = <ThrowOnError extends boolean = false>(options: Options<AdminVirtInstallXmlSectionsGetData, ThrowOnError>) => (options.client ?? client).get<AdminVirtInstallXmlSectionsGetResponses, AdminVirtInstallXmlSectionsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/virt_install/xml_sections/{virt_id}',
    ...options
});

/**
 * Save virt_install XML sections
 *
 * Merge edited sections back into a ``virt_install`` template's full XML.
 */
export const adminVirtInstallXmlSectionsSave = <ThrowOnError extends boolean = false>(options: Options<AdminVirtInstallXmlSectionsSaveData, ThrowOnError>) => (options.client ?? client).post<AdminVirtInstallXmlSectionsSaveResponses, AdminVirtInstallXmlSectionsSaveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/virt_install/xml_sections/{virt_id}',
    ...options
});

/**
 * Get downloads overview
 *
 * Get an overview of available downloads. Requires registration.
 */
export const adminDownloads = <ThrowOnError extends boolean = false>(options?: Options<AdminDownloadsData, ThrowOnError>) => (options?.client ?? client).get<AdminDownloadsResponses, AdminDownloadsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/downloads',
    ...options
});

/**
 * Get downloads by kind
 *
 * Get available downloads for a specific kind (domains, media, virt_install, videos, viewers).
 */
export const adminDownloadsKind = <ThrowOnError extends boolean = false>(options: Options<AdminDownloadsKindData, ThrowOnError>) => (options.client ?? client).get<AdminDownloadsKindResponses, AdminDownloadsKindErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/downloads/{kind}',
    ...options
});

/**
 * Register with updates server
 *
 * Register this IsardVDI instance with the updates server.
 */
export const adminDownloadsRegister = <ThrowOnError extends boolean = false>(options?: Options<AdminDownloadsRegisterData, ThrowOnError>) => (options?.client ?? client).post<AdminDownloadsRegisterResponses, AdminDownloadsRegisterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/downloads/register',
    ...options
});

/**
 * Execute download action for all items
 *
 * Execute a download action (download, abort, delete) for all new items of a kind.
 */
export const adminDownloadsAction = <ThrowOnError extends boolean = false>(options: Options<AdminDownloadsActionData, ThrowOnError>) => (options.client ?? client).post<AdminDownloadsActionResponses, AdminDownloadsActionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/downloads/{action}/{kind}',
    ...options
});

/**
 * Execute download action for a specific item
 *
 * Execute a download action (download, abort, delete) for a specific item.
 */
export const adminDownloadsActionId = <ThrowOnError extends boolean = false>(options: Options<AdminDownloadsActionIdData, ThrowOnError>) => (options.client ?? client).post<AdminDownloadsActionIdResponses, AdminDownloadsActionIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/downloads/{action}/{kind}/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all hypervisors
 *
 * List all hypervisors, optionally filtered by status.
 */
export const adminHypervisorsList = <ThrowOnError extends boolean = false>(options?: Options<AdminHypervisorsListData, ThrowOnError>) => (options?.client ?? client).get<AdminHypervisorsListResponses, AdminHypervisorsListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/hypervisors',
    ...options
});

/**
 * List hypervisors by status
 *
 * List hypervisors filtered by status (Online, Offline, Error).
 */
export const adminHypervisorsListByStatus = <ThrowOnError extends boolean = false>(options: Options<AdminHypervisorsListByStatusData, ThrowOnError>) => (options.client ?? client).get<AdminHypervisorsListByStatusResponses, AdminHypervisorsListByStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/hypervisors/{status}',
    ...options
});

/**
 * Get hypervisor status
 *
 * Get the status and only_forced flag for a hypervisor.
 */
export const adminHypervisorStatus = <ThrowOnError extends boolean = false>(options: Options<AdminHypervisorStatusData, ThrowOnError>) => (options.client ?? client).get<AdminHypervisorStatusResponses, AdminHypervisorStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/hypervisor/status/{hyper_id}',
    ...options
});

/**
 * Create or register a hypervisor
 *
 * Register a new hypervisor or update an existing one. Performs SSH key scanning and certificate exchange.
 */
export const adminHypervisorCreate = <ThrowOnError extends boolean = false>(options: Options<AdminHypervisorCreateData2, ThrowOnError>) => (options.client ?? client).post<AdminHypervisorCreateResponses, AdminHypervisorCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/hypervisor',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a hypervisor
 *
 * Remove a hypervisor. Stops its domains and waits for engine removal.
 */
export const adminHypervisorDelete = <ThrowOnError extends boolean = false>(options: Options<AdminHypervisorDeleteData, ThrowOnError>) => (options.client ?? client).delete<AdminHypervisorDeleteResponses, AdminHypervisorDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/hypervisor/{hyper_id}',
    ...options
});

/**
 * Enable or disable a hypervisor
 *
 * Enable or disable an existing hypervisor.
 */
export const adminHypervisorEnable = <ThrowOnError extends boolean = false>(options: Options<AdminHypervisorEnableData2, ThrowOnError>) => (options.client ?? client).put<AdminHypervisorEnableResponses, AdminHypervisorEnableErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/hypervisor/{hyper_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stop all domains on a hypervisor
 *
 * Force stop all running domains on the specified hypervisor.
 */
export const adminHypervisorStopDomains = <ThrowOnError extends boolean = false>(options: Options<AdminHypervisorStopDomainsData, ThrowOnError>) => (options.client ?? client).put<AdminHypervisorStopDomainsResponses, AdminHypervisorStopDomainsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/hypervisor/stop/{hyper_id}',
    ...options
});

/**
 * Get hypervisor VPN config
 *
 * Get the VPN configuration for a hypervisor.
 */
export const adminHypervisorVpn = <ThrowOnError extends boolean = false>(options: Options<AdminHypervisorVpnData, ThrowOnError>) => (options.client ?? client).get<AdminHypervisorVpnResponses, AdminHypervisorVpnErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/hypervisor_vpn/{hyper_id}',
    ...options
});

/**
 * Update wireguard guest address
 *
 * Update the wireguard guest IP address for a domain identified by MAC.
 */
export const adminHypervisorWgAddr = <ThrowOnError extends boolean = false>(options: Options<AdminHypervisorWgAddrData2, ThrowOnError>) => (options.client ?? client).post<AdminHypervisorWgAddrResponses, AdminHypervisorWgAddrErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/hypervisor/vm/wg_addr',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Report media found on hypervisor
 *
 * Register media files discovered on a hypervisor.
 */
export const adminHypervisorMediaFound = <ThrowOnError extends boolean = false>(options: Options<AdminHypervisorMediaFoundData2, ThrowOnError>) => (options.client ?? client).post<AdminHypervisorMediaFoundResponses, AdminHypervisorMediaFoundErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/hypervisor/media_found',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Report disks found on hypervisor
 *
 * Register disk files discovered on a hypervisor.
 */
export const adminHypervisorDisksFound = <ThrowOnError extends boolean = false>(options: Options<AdminHypervisorDisksFoundData2, ThrowOnError>) => (options.client ?? client).post<AdminHypervisorDisksFoundResponses, AdminHypervisorDisksFoundErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/hypervisor/disks_found',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete media by paths
 *
 * Delete media entries matching the specified paths.
 */
export const adminHypervisorMediaDelete = <ThrowOnError extends boolean = false>(options: Options<AdminHypervisorMediaDeleteData2, ThrowOnError>) => (options.client ?? client).post<AdminHypervisorMediaDeleteResponses, AdminHypervisorMediaDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/hypervisor/media_delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List orchestrator hypervisors
 *
 * List all hypervisors with orchestrator-specific fields.
 */
export const adminOrchestratorHypervisorsList = <ThrowOnError extends boolean = false>(options?: Options<AdminOrchestratorHypervisorsListData, ThrowOnError>) => (options?.client ?? client).get<AdminOrchestratorHypervisorsListResponses, AdminOrchestratorHypervisorsListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/orchestrator/hypervisors',
    ...options
});

/**
 * Get orchestrator hypervisor details
 *
 * Get orchestrator-specific details for a single hypervisor.
 */
export const adminOrchestratorHypervisorGet = <ThrowOnError extends boolean = false>(options: Options<AdminOrchestratorHypervisorGetData, ThrowOnError>) => (options.client ?? client).get<AdminOrchestratorHypervisorGetResponses, AdminOrchestratorHypervisorGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/orchestrator/hypervisor/{hypervisor_id}',
    ...options
});

/**
 * List orchestrator-managed hypervisors
 *
 * List only hypervisors that are marked as orchestrator-managed.
 */
export const adminOrchestratorManagedList = <ThrowOnError extends boolean = false>(options?: Options<AdminOrchestratorManagedListData, ThrowOnError>) => (options?.client ?? client).post<AdminOrchestratorManagedListResponses, AdminOrchestratorManagedListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/hypervisors/orchestrator_managed',
    ...options
});

/**
 * Reset hypervisor dead row timeout
 *
 * Reset (remove) the dead row timeout for an orchestrator-managed hypervisor.
 */
export const adminOrchestratorDeadRowReset = <ThrowOnError extends boolean = false>(options: Options<AdminOrchestratorDeadRowResetData, ThrowOnError>) => (options.client ?? client).delete<AdminOrchestratorDeadRowResetResponses, AdminOrchestratorDeadRowResetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/orchestrator/hypervisor/{hypervisor_id}/dead_row',
    ...options
});

/**
 * Set hypervisor dead row timeout
 *
 * Set the dead row timeout for an orchestrator-managed hypervisor.
 */
export const adminOrchestratorDeadRowSet = <ThrowOnError extends boolean = false>(options: Options<AdminOrchestratorDeadRowSetData, ThrowOnError>) => (options.client ?? client).post<AdminOrchestratorDeadRowSetResponses, AdminOrchestratorDeadRowSetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/orchestrator/hypervisor/{hypervisor_id}/dead_row',
    ...options
});

/**
 * Set hypervisor only_forced flag
 *
 * Set or clear the only_forced flag for a hypervisor.
 */
export const adminOrchestratorOnlyForcedSet = <ThrowOnError extends boolean = false>(options: Options<AdminOrchestratorOnlyForcedSetData, ThrowOnError>) => (options.client ?? client).put<AdminOrchestratorOnlyForcedSetResponses, AdminOrchestratorOnlyForcedSetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/orchestrator/hypervisor/{hypervisor_id}/only_forced',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stop hypervisor desktops (orchestrator)
 *
 * Stop all started desktops on an orchestrator-managed hypervisor.
 */
export const adminOrchestratorStopDesktops = <ThrowOnError extends boolean = false>(options: Options<AdminOrchestratorStopDesktopsData, ThrowOnError>) => (options.client ?? client).delete<AdminOrchestratorStopDesktopsResponses, AdminOrchestratorStopDesktopsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/orchestrator/hypervisor/{hypervisor_id}/desktops',
    ...options
});

/**
 * Unmark hypervisor from orchestrator management
 *
 * Remove orchestrator management flag from a hypervisor.
 */
export const adminOrchestratorManageUnset = <ThrowOnError extends boolean = false>(options: Options<AdminOrchestratorManageUnsetData, ThrowOnError>) => (options.client ?? client).delete<AdminOrchestratorManageUnsetResponses, AdminOrchestratorManageUnsetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/orchestrator/hypervisor/{hypervisor_id}/manage',
    ...options
});

/**
 * Mark hypervisor for orchestrator management
 *
 * Mark a hypervisor as managed by the orchestrator.
 */
export const adminOrchestratorManageSet = <ThrowOnError extends boolean = false>(options: Options<AdminOrchestratorManageSetData, ThrowOnError>) => (options.client ?? client).post<AdminOrchestratorManageSetResponses, AdminOrchestratorManageSetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/orchestrator/hypervisor/{hypervisor_id}/manage',
    ...options
});

/**
 * Get hypervisor virt pools
 *
 * Get the virt pool assignments for a hypervisor.
 */
export const adminHypervisorVirtPoolsGet = <ThrowOnError extends boolean = false>(options: Options<AdminHypervisorVirtPoolsGetData, ThrowOnError>) => (options.client ?? client).get<AdminHypervisorVirtPoolsGetResponses, AdminHypervisorVirtPoolsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/hypervisor/{hyper_id}/virt_pools',
    ...options
});

/**
 * Update hypervisor virt pool assignment
 *
 * Enable or disable a virt pool for a hypervisor.
 */
export const adminHypervisorVirtPoolsUpdate = <ThrowOnError extends boolean = false>(options: Options<AdminHypervisorVirtPoolsUpdateData, ThrowOnError>) => (options.client ?? client).put<AdminHypervisorVirtPoolsUpdateResponses, AdminHypervisorVirtPoolsUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/hypervisor/{hyper_id}/virt_pools',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get hypervisor mountpoints
 *
 * Get the filesystem mountpoints reported by a hypervisor.
 */
export const adminHypervisorMountpoints = <ThrowOnError extends boolean = false>(options: Options<AdminHypervisorMountpointsData, ThrowOnError>) => (options.client ?? client).get<AdminHypervisorMountpointsResponses, AdminHypervisorMountpointsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/hypervisor/mountpoints/{hyper_id}',
    ...options
});

/**
 * Get started domains on a hypervisor
 *
 * Get all currently started desktop domains on a hypervisor.
 */
export const adminHypervisorStartedDomains = <ThrowOnError extends boolean = false>(options: Options<AdminHypervisorStartedDomainsData, ThrowOnError>) => (options.client ?? client).get<AdminHypervisorStartedDomainsResponses, AdminHypervisorStartedDomainsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/hypervisor/started_domains/{hyper_id}',
    ...options
});

/**
 * Register VLANs from hypervisor
 *
 * Creates network interface entries for discovered VLANs.
 */
export const adminRegisterVlans = <ThrowOnError extends boolean = false>(options: Options<AdminRegisterVlansData, ThrowOnError>) => (options.client ?? client).post<AdminRegisterVlansResponses, AdminRegisterVlansErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/vlans',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update hypervisor boot progress
 *
 * Updates the boot progress data for a hypervisor.
 */
export const adminHypervisorBootProgress = <ThrowOnError extends boolean = false>(options: Options<AdminHypervisorBootProgressData, ThrowOnError>) => (options.client ?? client).put<AdminHypervisorBootProgressResponses, AdminHypervisorBootProgressErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/hypervisor/{hyper_id}/boot_progress',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Ingest a hypervisor's applied GPU profile report
 *
 * A gpu-apply-capable hypervisor reports back, after registration, the per-card profile it actually applied locally (+ the created mdev pool). Persisted into vgpus so the DB reflects reality and the engine reconcile confirms instead of re-applying. Hypervisor-facing: the hypervisor service JWT (kid isardvdi-hypervisors) maps to the admin role.
 */
export const adminHypervisorGpuApplied = <ThrowOnError extends boolean = false>(options: Options<AdminHypervisorGpuAppliedData, ThrowOnError>) => (options.client ?? client).put<AdminHypervisorGpuAppliedResponses, AdminHypervisorGpuAppliedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/hypervisor/{hyper_id}/gpu_applied',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview the impact of forcing a GPU profile
 *
 * Admin-only read-only pre-flight for the force-profile dialog: which running desktops would be stopped and which reservables would be removed (no other card provides them) if this card is forced to target_profile.
 */
export const adminGpuForceProfilePreview = <ThrowOnError extends boolean = false>(options: Options<AdminGpuForceProfilePreviewData, ThrowOnError>) => (options.client ?? client).post<AdminGpuForceProfilePreviewResponses, AdminGpuForceProfilePreviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/hypervisor/gpus/{card_id}/force_profile_preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update login notification
 *
 * Updates the login notification configuration for cover and form.
 */
export const adminLoginNotificationUpdate = <ThrowOnError extends boolean = false>(options: Options<AdminLoginNotificationUpdateData, ThrowOnError>) => (options.client ?? client).put<AdminLoginNotificationUpdateResponses, AdminLoginNotificationUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/login_config/notification',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enable/disable cover login notification
 *
 * Enables or disables the login notification for the cover.
 */
export const adminLoginNotificationCoverEnable = <ThrowOnError extends boolean = false>(options: Options<AdminLoginNotificationCoverEnableData, ThrowOnError>) => (options.client ?? client).put<AdminLoginNotificationCoverEnableResponses, AdminLoginNotificationCoverEnableErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/login_config/notification/cover/enable',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enable/disable form login notification
 *
 * Enables or disables the login notification for the form.
 */
export const adminLoginNotificationFormEnable = <ThrowOnError extends boolean = false>(options: Options<AdminLoginNotificationFormEnableData, ThrowOnError>) => (options.client ?? client).put<AdminLoginNotificationFormEnableResponses, AdminLoginNotificationFormEnableErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/login_config/notification/form/enable',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create notification template
 *
 * Creates a new notification template.
 */
export const adminCreateNotificationTemplate = <ThrowOnError extends boolean = false>(options: Options<AdminCreateNotificationTemplateData, ThrowOnError>) => (options.client ?? client).post<AdminCreateNotificationTemplateResponses, AdminCreateNotificationTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/notifications/template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all notification templates
 *
 * Returns all notification templates.
 */
export const adminListNotificationTemplates = <ThrowOnError extends boolean = false>(options?: Options<AdminListNotificationTemplatesData, ThrowOnError>) => (options?.client ?? client).get<AdminListNotificationTemplatesResponses, AdminListNotificationTemplatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/notifications/templates',
    ...options
});

/**
 * List custom notification templates
 *
 * Returns custom (non-system) notification templates.
 */
export const adminListCustomNotificationTemplates = <ThrowOnError extends boolean = false>(options?: Options<AdminListCustomNotificationTemplatesData, ThrowOnError>) => (options?.client ?? client).get<AdminListCustomNotificationTemplatesResponses, AdminListCustomNotificationTemplatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/notifications/templates/custom',
    ...options
});

/**
 * List system notification templates
 *
 * Returns system notification templates.
 */
export const adminListSystemNotificationTemplates = <ThrowOnError extends boolean = false>(options?: Options<AdminListSystemNotificationTemplatesData, ThrowOnError>) => (options?.client ?? client).get<AdminListSystemNotificationTemplatesResponses, AdminListSystemNotificationTemplatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/notifications/templates/system',
    ...options
});

/**
 * Delete notification template
 *
 * Deletes a notification template by its ID.
 */
export const adminDeleteNotificationTemplate = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteNotificationTemplateData, ThrowOnError>) => (options.client ?? client).delete<AdminDeleteNotificationTemplateResponses, AdminDeleteNotificationTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/notifications/template/{template_id}',
    ...options
});

/**
 * Get notification template
 *
 * Returns a notification template by its ID.
 */
export const adminGetNotificationTemplate = <ThrowOnError extends boolean = false>(options: Options<AdminGetNotificationTemplateData, ThrowOnError>) => (options.client ?? client).get<AdminGetNotificationTemplateResponses, AdminGetNotificationTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/notifications/template/{template_id}',
    ...options
});

/**
 * Update notification template
 *
 * Updates a notification template by its ID.
 */
export const adminUpdateNotificationTemplate = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateNotificationTemplateData, ThrowOnError>) => (options.client ?? client).put<AdminUpdateNotificationTemplateResponses, AdminUpdateNotificationTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/notifications/template/{template_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview template rendering
 *
 * Renders a notification event template with the provided data.
 */
export const adminPreviewNotificationTemplate = <ThrowOnError extends boolean = false>(options: Options<AdminPreviewNotificationTemplateData, ThrowOnError>) => (options.client ?? client).put<AdminPreviewNotificationTemplateResponses, AdminPreviewNotificationTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/notifications/template/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all notifications
 *
 * Returns all notifications.
 */
export const adminListNotifications = <ThrowOnError extends boolean = false>(options?: Options<AdminListNotificationsData, ThrowOnError>) => (options?.client ?? client).get<AdminListNotificationsResponses, AdminListNotificationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/notifications',
    ...options
});

/**
 * Create notification
 *
 * Creates a new notification.
 */
export const adminCreateNotification = <ThrowOnError extends boolean = false>(options: Options<AdminCreateNotificationData, ThrowOnError>) => (options.client ?? client).post<AdminCreateNotificationResponses, AdminCreateNotificationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/notification',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List notification actions
 *
 * Returns all notification actions.
 */
export const adminListNotificationActions = <ThrowOnError extends boolean = false>(options?: Options<AdminListNotificationActionsData, ThrowOnError>) => (options?.client ?? client).get<AdminListNotificationActionsResponses, AdminListNotificationActionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/notification/actions',
    ...options
});

/**
 * Delete notification
 *
 * Deletes a notification by its ID.
 */
export const adminDeleteNotification = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteNotificationData, ThrowOnError>) => (options.client ?? client).delete<AdminDeleteNotificationResponses, AdminDeleteNotificationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/notification/{notification_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get notification
 *
 * Returns a notification by its ID.
 */
export const adminGetNotification = <ThrowOnError extends boolean = false>(options: Options<AdminGetNotificationData, ThrowOnError>) => (options.client ?? client).get<AdminGetNotificationResponses, AdminGetNotificationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/notification/{notification_id}',
    ...options
});

/**
 * Update notification
 *
 * Updates a notification by its ID.
 */
export const adminUpdateNotification = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateNotificationData, ThrowOnError>) => (options.client ?? client).put<AdminUpdateNotificationResponses, AdminUpdateNotificationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/notification/{notification_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get user notification data by status
 *
 * Returns notification data for a user filtered by status.
 */
export const adminGetNotificationsDataByStatus = <ThrowOnError extends boolean = false>(options: Options<AdminGetNotificationsDataByStatusData, ThrowOnError>) => (options.client ?? client).get<AdminGetNotificationsDataByStatusResponses, AdminGetNotificationsDataByStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/notifications/data/status/{status}/user/{user_id}',
    ...options
});

/**
 * Get available notification statuses
 *
 * Returns all distinct notification statuses.
 */
export const adminGetNotificationStatuses = <ThrowOnError extends boolean = false>(options?: Options<AdminGetNotificationStatusesData, ThrowOnError>) => (options?.client ?? client).get<AdminGetNotificationStatusesResponses, AdminGetNotificationStatusesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/notifications/statuses',
    ...options
});

/**
 * Get notifications grouped by status
 *
 * Returns notification data grouped by user for a given status.
 */
export const adminGetNotificationsGroupedByStatus = <ThrowOnError extends boolean = false>(options: Options<AdminGetNotificationsGroupedByStatusData, ThrowOnError>) => (options.client ?? client).get<AdminGetNotificationsGroupedByStatusResponses, AdminGetNotificationsGroupedByStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/notifications/data/by_status/{status}',
    ...options
});

/**
 * Delete user notification data
 *
 * Deletes all notification data for a specific user.
 */
export const adminDeleteUserNotificationData = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteUserNotificationDataData, ThrowOnError>) => (options.client ?? client).delete<AdminDeleteUserNotificationDataResponses, AdminDeleteUserNotificationDataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/notifications/data/user/{user_id}',
    ...options
});

/**
 * Delete specific notification data
 *
 * Deletes a specific notification data entry by its ID.
 */
export const adminDeleteNotificationData = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteNotificationDataData, ThrowOnError>) => (options.client ?? client).delete<AdminDeleteNotificationDataResponses, AdminDeleteNotificationDataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/notifications/data/{notification_data_id}',
    ...options
});

/**
 * Delete all notification data
 *
 * Deletes all notification data entries.
 */
export const adminDeleteAllNotificationData = <ThrowOnError extends boolean = false>(options?: Options<AdminDeleteAllNotificationDataData, ThrowOnError>) => (options?.client ?? client).delete<AdminDeleteAllNotificationDataResponses, AdminDeleteAllNotificationDataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/notifications/data',
    ...options
});

/**
 * Get user notification displays
 *
 * Returns the notification displays for a specific user and trigger.
 */
export const adminGetUserNotificationDisplays = <ThrowOnError extends boolean = false>(options: Options<AdminGetUserNotificationDisplaysData, ThrowOnError>) => (options.client ?? client).get<AdminGetUserNotificationDisplaysResponses, AdminGetUserNotificationDisplaysErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/notifications/user/displays/{user_id}/{trigger}',
    ...options
});

/**
 * Delete expired user notifications data
 *
 * Deletes expired user notifications data.
 */
export const deleteExpiredUserNotificationsData = <ThrowOnError extends boolean = false>(options?: Options<DeleteExpiredUserNotificationsDataData, ThrowOnError>) => (options?.client ?? client).delete<DeleteExpiredUserNotificationsDataResponses, DeleteExpiredUserNotificationsDataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/notifications/expired',
    ...options
});

/**
 * Notify user about desktop
 *
 * Sends a notification to a user about a desktop event.
 */
export const adminNotifyUserDesktop = <ThrowOnError extends boolean = false>(options: Options<AdminNotifyUserDesktopData, ThrowOnError>) => (options.client ?? client).post<AdminNotifyUserDesktopResponses, AdminNotifyUserDesktopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/notify/user/desktop',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Notify a desktop
 *
 * Sends a notification to a desktop.
 */
export const adminNotifyDesktop = <ThrowOnError extends boolean = false>(options: Options<AdminNotifyDesktopData, ThrowOnError>) => (options.client ?? client).post<AdminNotifyDesktopResponses, AdminNotifyDesktopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/notify/desktop',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Notify desktop queue
 *
 * Parses desktop queues for a hypervisor and notifies affected users.
 */
export const adminNotifyDesktopQueue = <ThrowOnError extends boolean = false>(options: Options<AdminNotifyDesktopQueueData, ThrowOnError>) => (options.client ?? client).put<AdminNotifyDesktopQueueResponses, AdminNotifyDesktopQueueErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/notify/desktops/queue/{hyp_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List operations hypervisors
 *
 * Lists all hypervisors managed by the operations service. Requires operations API to be enabled.
 */
export const adminOperationsHypervisors = <ThrowOnError extends boolean = false>(options?: Options<AdminOperationsHypervisorsData, ThrowOnError>) => (options?.client ?? client).get<AdminOperationsHypervisorsResponses, AdminOperationsHypervisorsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/operations/hypervisors',
    ...options
});

/**
 * Stop a hypervisor
 *
 * Stops a hypervisor via the operations service. Requires operations API to be enabled.
 */
export const adminOperationsHypervisorStop = <ThrowOnError extends boolean = false>(options: Options<AdminOperationsHypervisorStopData, ThrowOnError>) => (options.client ?? client).delete<AdminOperationsHypervisorStopResponses, AdminOperationsHypervisorStopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/operations/hypervisor/{hypervisor_id}',
    ...options
});

/**
 * Start a hypervisor
 *
 * Starts a hypervisor via the operations service. Requires operations API to be enabled.
 */
export const adminOperationsHypervisorStart = <ThrowOnError extends boolean = false>(options: Options<AdminOperationsHypervisorStartData, ThrowOnError>) => (options.client ?? client).put<AdminOperationsHypervisorStartResponses, AdminOperationsHypervisorStartErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/operations/hypervisor/{hypervisor_id}',
    ...options
});

/**
 * Get orchestrator configuration
 *
 * Returns whether the orchestrator is enabled.
 */
export const adminOrchestratorConfig = <ThrowOnError extends boolean = false>(options?: Options<AdminOrchestratorConfigData, ThrowOnError>) => (options?.client ?? client).get<AdminOrchestratorConfigResponses, AdminOrchestratorConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/orchestrator-config',
    ...options
});

/**
 * Update orchestrator configuration
 *
 * Enables or disables the orchestrator.
 */
export const adminOrchestratorConfigUpdate = <ThrowOnError extends boolean = false>(options: Options<AdminOrchestratorConfigUpdateData, ThrowOnError>) => (options.client ?? client).put<AdminOrchestratorConfigUpdateResponses, AdminOrchestratorConfigUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/orchestrator-config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all queues with job counts
 *
 * Returns all queues with their job counts by status.
 */
export const adminQueuesJobs = <ThrowOnError extends boolean = false>(options?: Options<AdminQueuesJobsData, ThrowOnError>) => (options?.client ?? client).get<AdminQueuesJobsResponses, AdminQueuesJobsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/queues',
    ...options
});

/**
 * List queue consumers/workers
 *
 * Returns all queue workers with their subscriber information.
 */
export const adminQueuesConsumers = <ThrowOnError extends boolean = false>(options?: Options<AdminQueuesConsumersData, ThrowOnError>) => (options?.client ?? client).get<AdminQueuesConsumersResponses, AdminQueuesConsumersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/queues/consumers',
    ...options
});

/**
 * Storage lane health (orphan-lane detector)
 *
 * Detects ORPHAN storage lanes: queues holding jobs with no worker consuming them (their tasks stall forever). Lane-centric, so it sees what the worker-centric consumers view cannot.
 */
export const adminQueuesLaneHealth = <ThrowOnError extends boolean = false>(options?: Options<AdminQueuesLaneHealthData, ThrowOnError>) => (options?.client ?? client).get<AdminQueuesLaneHealthResponses, AdminQueuesLaneHealthErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/queues/lane-health',
    ...options
});

/**
 * Storage-governor gauge document
 *
 * Composite storage-governor observability gauges: heavy at-cap + leak, per-pool/per-category inflight-vs-cap, worker heartbeat health, Redis health, mode, warnings, effective config, generated_at and truncation honesty fields. Degrades to a 200 body with honesty fields (redis.up false, multitenancy_active 'unknown', empty pools/workers) on transient Redis/rdb failure rather than 5xx — a polled 500 would eject the operator mid-incident. Also the stats-go scrape source.
 */
export const adminQueuesGovernor = <ThrowOnError extends boolean = false>(options?: Options<AdminQueuesGovernorData, ThrowOnError>) => (options?.client ?? client).get<AdminQueuesGovernorResponses, AdminQueuesGovernorErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/queues/governor',
    ...options
});

/**
 * Per-(pool, category, tier) backlog rollup
 *
 * Per-lane backlog rollup: queued / started / started-over-timeout / failed / deferred counts, head-only oldest-queued-age, and has_consumer / coverage_known / stranded coverage flags. Degrades to an empty list on transient Redis failure rather than 5xx.
 */
export const adminQueuesBacklog = <ThrowOnError extends boolean = false>(options?: Options<AdminQueuesBacklogData, ThrowOnError>) => (options?.client ?? client).get<AdminQueuesBacklogResponses, AdminQueuesBacklogErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/queues/backlog',
    ...options
});

/**
 * Bounded, filterable problem-task listing
 *
 * Lists problem tasks — ``failed`` (with traceback + retries_left), ``stuck_running`` (started jobs past their timeout), ``deferred_orphan`` (finalize-crashed deferred jobs whose chain has settled), or ``all`` — filterable by pool / category_id / tier and paginated. Every enumeration is bounded (one rq:queues snapshot, per-lane registry slice with cleanup=False, overall scan cap) and dangling-safe. Degrades to a 200 body with count 0 / empty tasks on transient Redis failure rather than 5xx.
 */
export const adminQueuesProblemTasks = <ThrowOnError extends boolean = false>(options?: Options<AdminQueuesProblemTasksData, ThrowOnError>) => (options?.client ?? client).get<AdminQueuesProblemTasksResponses, AdminQueuesProblemTasksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/queues/tasks/problems',
    ...options
});

/**
 * Get auto delete config
 *
 * Returns the auto-delete configuration for old tasks.
 */
export const adminGetOldTasksConfig = <ThrowOnError extends boolean = false>(options?: Options<AdminGetOldTasksConfigData, ThrowOnError>) => (options?.client ?? client).get<AdminGetOldTasksConfigResponses, AdminGetOldTasksConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/queues/old_tasks/config',
    ...options
});

/**
 * Get old tasks
 *
 * Returns old tasks that are older than the specified seconds.
 */
export const adminGetOldTasks = <ThrowOnError extends boolean = false>(options: Options<AdminGetOldTasksData, ThrowOnError>) => (options.client ?? client).get<AdminGetOldTasksResponses, AdminGetOldTasksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/queues/old_tasks/{older_than}',
    ...options
});

/**
 * Delete old tasks
 *
 * Deletes old tasks older than the specified seconds.
 */
export const adminDeleteOldTasks = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteOldTasksData, ThrowOnError>) => (options.client ?? client).delete<AdminDeleteOldTasksResponses, AdminDeleteOldTasksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/queues/old_tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set auto delete max time
 *
 * Sets the maximum time (in seconds, min 86400) for auto-deleting old tasks.
 */
export const adminSetOldTasksMaxTime = <ThrowOnError extends boolean = false>(options: Options<AdminSetOldTasksMaxTimeData, ThrowOnError>) => (options.client ?? client).put<AdminSetOldTasksMaxTimeResponses, AdminSetOldTasksMaxTimeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/queues/old_tasks/config/max_time/{max_time}',
    ...options
});

/**
 * Get storage governor config
 *
 * Returns the live storage-governor knobs (enabled kill-switch, PSI limit, heavy cap, poll backoff) and the per-category fairness knobs (weights, per-category and default in-flight caps) the elastic storage workers apply.
 */
export const adminGetStorageSchedulerConfig = <ThrowOnError extends boolean = false>(options?: Options<AdminGetStorageSchedulerConfigData, ThrowOnError>) => (options?.client ?? client).get<AdminGetStorageSchedulerConfigResponses, AdminGetStorageSchedulerConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/queues/storage_scheduler/config',
    ...options
});

/**
 * Set storage governor config
 *
 * Live-updates the storage-governor knobs including the per-category fairness weights/caps (partial; only provided keys are written, a supplied category map replaces the stored one). Elastic workers pick up the change within one poll, no restart.
 */
export const adminSetStorageSchedulerConfig = <ThrowOnError extends boolean = false>(options: Options<AdminSetStorageSchedulerConfigData, ThrowOnError>) => (options.client ?? client).put<AdminSetStorageSchedulerConfigResponses, AdminSetStorageSchedulerConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/queues/storage_scheduler/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set auto delete queue registries
 *
 * Sets which queue registries are included in auto-delete.
 */
export const adminSetOldTasksQueueRegistries = <ThrowOnError extends boolean = false>(options: Options<AdminSetOldTasksQueueRegistriesData, ThrowOnError>) => (options.client ?? client).put<AdminSetOldTasksQueueRegistriesResponses, AdminSetOldTasksQueueRegistriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/queues/old_tasks/config/queue_registries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enable or disable auto delete
 *
 * Enables or disables the auto-delete of old tasks.
 */
export const adminSetOldTasksEnabled = <ThrowOnError extends boolean = false>(options: Options<AdminSetOldTasksEnabledData, ThrowOnError>) => (options.client ?? client).put<AdminSetOldTasksEnabledResponses, AdminSetOldTasksEnabledErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/queues/old_tasks/config/enabled',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Auto delete old tasks
 *
 * Deletes old tasks based on the auto-delete configuration.
 */
export const adminDeleteOldTasksAuto = <ThrowOnError extends boolean = false>(options?: Options<AdminDeleteOldTasksAutoData, ThrowOnError>) => (options?.client ?? client).delete<AdminDeleteOldTasksAutoResponses, AdminDeleteOldTasksAutoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/queues/old_tasks/auto',
    ...options
});

/**
 * Get remote VPN data with OS
 *
 * Get remote VPN configuration or installation data for a specific OS.
 */
export const adminRemoteVpnWithOs = <ThrowOnError extends boolean = false>(options: Options<AdminRemoteVpnWithOsData, ThrowOnError>) => (options.client ?? client).get<AdminRemoteVpnWithOsResponses, AdminRemoteVpnWithOsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/remote_vpn/{vpn_id}/{kind}/{os}',
    ...options
});

/**
 * Get remote VPN data
 *
 * Get remote VPN configuration data.
 */
export const adminRemoteVpn = <ThrowOnError extends boolean = false>(options: Options<AdminRemoteVpnData, ThrowOnError>) => (options.client ?? client).get<AdminRemoteVpnResponses, AdminRemoteVpnErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/remote_vpn/{vpn_id}/{kind}',
    ...options
});

/**
 * Add QoS disk profile
 *
 * Add a new QoS disk profile with IO tune parameters.
 */
export const adminQosDiskAdd = <ThrowOnError extends boolean = false>(options: Options<AdminQosDiskAddData, ThrowOnError>) => (options.client ?? client).post<AdminQosDiskAddResponses, AdminQosDiskAddErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/qos_disk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update QoS disk profile
 *
 * Update an existing QoS disk profile.
 */
export const adminQosDiskUpdate = <ThrowOnError extends boolean = false>(options: Options<AdminQosDiskUpdateData, ThrowOnError>) => (options.client ?? client).put<AdminQosDiskUpdateResponses, AdminQosDiskUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/qos_disk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a role
 *
 * Returns a role by its ID.
 */
export const adminGetRole = <ThrowOnError extends boolean = false>(options: Options<AdminGetRoleData, ThrowOnError>) => (options.client ?? client).get<AdminGetRoleResponses, AdminGetRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/role/{role_id}',
    ...options
});

/**
 * Update role
 *
 * Updates a role.
 */
export const adminUpdateRole = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateRoleData, ThrowOnError>) => (options.client ?? client).put<AdminUpdateRoleResponses, AdminUpdateRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/role/{role_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get system scheduler jobs
 *
 * Get the list of system scheduler jobs ordered by next run time.
 */
export const adminSchedulerJobsSystem = <ThrowOnError extends boolean = false>(options?: Options<AdminSchedulerJobsSystemData, ThrowOnError>) => (options?.client ?? client).get<AdminSchedulerJobsSystemResponses, AdminSchedulerJobsSystemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/scheduler/jobs/system',
    ...options
});

/**
 * Get bookings scheduler jobs
 *
 * Get the list of bookings scheduler jobs ordered by next run time.
 */
export const adminSchedulerJobsBookings = <ThrowOnError extends boolean = false>(options?: Options<AdminSchedulerJobsBookingsData, ThrowOnError>) => (options?.client ?? client).get<AdminSchedulerJobsBookingsResponses, AdminSchedulerJobsBookingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/scheduler/jobs/bookings',
    ...options
});

/**
 * Get SMTP configuration
 *
 * Returns the current SMTP configuration.
 */
export const adminSmtpGet = <ThrowOnError extends boolean = false>(options?: Options<AdminSmtpGetData, ThrowOnError>) => (options?.client ?? client).get<AdminSmtpGetResponses, AdminSmtpGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/smtp',
    ...options
});

/**
 * Update SMTP configuration
 *
 * Updates and saves the SMTP configuration.
 */
export const adminSmtpPut = <ThrowOnError extends boolean = false>(options: Options<AdminSmtpPutData, ThrowOnError>) => (options.client ?? client).put<AdminSmtpPutResponses, AdminSmtpPutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/smtp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get SMTP enabled status
 *
 * Returns whether SMTP is enabled.
 */
export const adminSmtpEnabledGet = <ThrowOnError extends boolean = false>(options?: Options<AdminSmtpEnabledGetData, ThrowOnError>) => (options?.client ?? client).get<AdminSmtpEnabledGetResponses, AdminSmtpEnabledGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/smtp/enabled',
    ...options
});

/**
 * Test SMTP configuration
 *
 * Tests an SMTP configuration by connecting and authenticating.
 */
export const adminSmtpTestPost = <ThrowOnError extends boolean = false>(options: Options<AdminSmtpTestPostData, ThrowOnError>) => (options.client ?? client).post<AdminSmtpTestPostResponses, AdminSmtpTestPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/smtp/test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Emit socketio events
 *
 * Sends one or more socketio events. Expects a JSON array of event objects.
 */
export const adminEmitSocketio = <ThrowOnError extends boolean = false>(options: Options<AdminEmitSocketioData, ThrowOnError>) => (options.client ?? client).post<AdminEmitSocketioResponses, AdminEmitSocketioErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/socketio',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get desktop status statistics
 *
 * Returns desktop statistics grouped by status.
 */
export const statsDesktopsStatus = <ThrowOnError extends boolean = false>(options?: Options<StatsDesktopsStatusData, ThrowOnError>) => (options?.client ?? client).get<StatsDesktopsStatusResponses, StatsDesktopsStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/stats/desktops/status',
    ...options
});

/**
 * Get domains status statistics
 *
 * Returns domain statistics grouped by kind and status.
 */
export const statsDomainsStatus = <ThrowOnError extends boolean = false>(options?: Options<StatsDomainsStatusData, ThrowOnError>) => (options?.client ?? client).get<StatsDomainsStatusResponses, StatsDomainsStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/stats/domains/status',
    ...options
});

/**
 * Get grouped category statistics
 *
 * Returns comprehensive statistics grouped by categories.
 */
export const statsCategories = <ThrowOnError extends boolean = false>(options?: Options<StatsCategoriesData, ThrowOnError>) => (options?.client ?? client).get<StatsCategoriesResponses, StatsCategoriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/stats/categories',
    ...options
});

/**
 * Get category deployments statistics
 *
 * Returns deployment counts grouped by category.
 */
export const statsCategoriesDeployments = <ThrowOnError extends boolean = false>(options?: Options<StatsCategoriesDeploymentsData, ThrowOnError>) => (options?.client ?? client).get<StatsCategoriesDeploymentsResponses, StatsCategoriesDeploymentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/stats/categories/deployments',
    ...options
});

/**
 * Get user statistics
 *
 * Returns a list of all users with their role, category and group.
 */
export const statsUsers = <ThrowOnError extends boolean = false>(options?: Options<StatsUsersData, ThrowOnError>) => (options?.client ?? client).get<StatsUsersResponses, StatsUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/stats/users',
    ...options
});

/**
 * Get desktop statistics
 *
 * Returns a list of all desktops with their owning user.
 */
export const statsDesktops = <ThrowOnError extends boolean = false>(options?: Options<StatsDesktopsData, ThrowOnError>) => (options?.client ?? client).get<StatsDesktopsResponses, StatsDesktopsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/stats/desktops',
    ...options
});

/**
 * Get template statistics
 *
 * Returns a list of all template IDs.
 */
export const statsTemplates = <ThrowOnError extends boolean = false>(options?: Options<StatsTemplatesData, ThrowOnError>) => (options?.client ?? client).get<StatsTemplatesResponses, StatsTemplatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/stats/templates',
    ...options
});

/**
 * Get hypervisor statistics
 *
 * Returns a list of all hypervisors with their status and only_forced flag.
 */
export const statsHypervisors = <ThrowOnError extends boolean = false>(options?: Options<StatsHypervisorsData, ThrowOnError>) => (options?.client ?? client).get<StatsHypervisorsResponses, StatsHypervisorsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/stats/hypervisors',
    ...options
});

/**
 * Get started domains count by category
 *
 * Returns the count of started desktop domains grouped by category.
 */
export const adminDomainsStartedCount = <ThrowOnError extends boolean = false>(options?: Options<AdminDomainsStartedCountData, ThrowOnError>) => (options?.client ?? client).get<AdminDomainsStartedCountResponses, AdminDomainsStartedCountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/domains/started-count',
    ...options
});

/**
 * Get storages by user role
 *
 * Get all storages filtered by the owning user's role. Admin only.
 */
export const adminStorageByRole = <ThrowOnError extends boolean = false>(options: Options<AdminStorageByRoleData, ThrowOnError>) => (options.client ?? client).get<AdminStorageByRoleResponses, AdminStorageByRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/storage/by-role/{role}',
    ...options
});

/**
 * Refresh qemu-img-info size of running desktops' disks
 *
 * Enqueue a low-priority qemu-img-info refresh for every ready, non-readonly disk attached to a currently-running desktop, so a long-running desktop's stored actual-size does not stay frozen at its last stop. Intended to be driven by the scheduler (cron/interval). Admin only.
 */
export const adminStorageRefreshRunningSizes = <ThrowOnError extends boolean = false>(options?: Options<AdminStorageRefreshRunningSizesData, ThrowOnError>) => (options?.client ?? client).post<AdminStorageRefreshRunningSizesResponses, AdminStorageRefreshRunningSizesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/storage/refresh-running-sizes',
    ...options
});

/**
 * Preview a storage-disk migration plan (dry run)
 *
 * Resolve the selection and return what would move, grouped by root tree. Nothing is persisted.
 */
export const adminStorageMigrationPlan = <ThrowOnError extends boolean = false>(options: Options<AdminStorageMigrationPlanData, ThrowOnError>) => (options.client ?? client).post<AdminStorageMigrationPlanResponses, AdminStorageMigrationPlanErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/storage/migrations/plan',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List storage-disk migration jobs
 */
export const adminStorageMigrationList = <ThrowOnError extends boolean = false>(options?: Options<AdminStorageMigrationListData, ThrowOnError>) => (options?.client ?? client).get<AdminStorageMigrationListResponses, AdminStorageMigrationListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/storage/migrations',
    ...options
});

/**
 * Create a storage-disk migration job
 *
 * Resolve + persist a migration (status planned) and its per-disk ledger rows.
 */
export const adminStorageMigrationCreate = <ThrowOnError extends boolean = false>(options: Options<AdminStorageMigrationCreateData, ThrowOnError>) => (options.client ?? client).post<AdminStorageMigrationCreateResponses, AdminStorageMigrationCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/storage/migrations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List real source path-prefixes for the path selection kind
 *
 * Distinct storage.directory_path values (optionally scoped to a source pool) that populate the path-migration dropdown. Read-only.
 */
export const adminStorageMigrationPathPrefixes = <ThrowOnError extends boolean = false>(options?: Options<AdminStorageMigrationPathPrefixesData, ThrowOnError>) => (options?.client ?? client).get<AdminStorageMigrationPathPrefixesResponses, AdminStorageMigrationPathPrefixesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/storage/migrations/path-prefixes',
    ...options
});

/**
 * Download a storage-disk migration report (CSV or JSON)
 *
 * A downloadable per-disk audit of what was moved / failed / skipped / quarantined / in-place, annotated by occurrence for recurring jobs, with a summary header. format=csv (default) | json.
 */
export const adminStorageMigrationLog = <ThrowOnError extends boolean = false>(options: Options<AdminStorageMigrationLogData, ThrowOnError>) => (options.client ?? client).get<AdminStorageMigrationLogResponses, AdminStorageMigrationLogErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/storage/migrations/{migration_id}/log',
    ...options
});

/**
 * Storage-disk migration status (live ledger aggregate)
 */
export const adminStorageMigrationStatus = <ThrowOnError extends boolean = false>(options: Options<AdminStorageMigrationStatusData, ThrowOnError>) => (options.client ?? client).get<AdminStorageMigrationStatusResponses, AdminStorageMigrationStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/storage/migrations/{migration_id}',
    ...options
});

/**
 * Control a storage-disk migration (start, pause, cancel)
 */
export const adminStorageMigrationAction = <ThrowOnError extends boolean = false>(options: Options<AdminStorageMigrationActionData, ThrowOnError>) => (options.client ?? client).post<AdminStorageMigrationActionResponses, AdminStorageMigrationActionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/storage/migrations/{migration_id}/{action}',
    ...options
});

/**
 * Update a storage-disk migration's config
 */
export const adminStorageMigrationConfig = <ThrowOnError extends boolean = false>(options: Options<AdminStorageMigrationConfigData, ThrowOnError>) => (options.client ?? client).put<AdminStorageMigrationConfigResponses, AdminStorageMigrationConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/storage/migrations/{migration_id}/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Pool-scoped migration aggregation (root-tree overview)
 *
 * Enumerate the pool's root trees with per-tree derivative / desktop / byte counts for the admin overview.
 */
export const adminStoragePoolMigrationPlan = <ThrowOnError extends boolean = false>(options: Options<AdminStoragePoolMigrationPlanData, ThrowOnError>) => (options.client ?? client).get<AdminStoragePoolMigrationPlanResponses, AdminStoragePoolMigrationPlanErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/storage-pool/{pool_id}/migration/plan',
    ...options
});

/**
 * Get system logo status
 *
 * Returns whether a custom system-wide logo and/or collapsed logo are currently configured.
 */
export const adminSystemLogoGet = <ThrowOnError extends boolean = false>(options?: Options<AdminSystemLogoGetData, ThrowOnError>) => (options?.client ?? client).get<AdminSystemLogoGetResponses, AdminSystemLogoGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/logo',
    ...options
});

/**
 * Update system logo
 *
 * Uploads, replaces or removes the system-wide default logo and/or collapsed logo. Logo data should be a base64 data URL.
 */
export const adminSystemLogoPut = <ThrowOnError extends boolean = false>(options: Options<AdminSystemLogoPutData, ThrowOnError>) => (options.client ?? client).put<AdminSystemLogoPutResponses, AdminSystemLogoPutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/logo',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Insert a new item into a table
 *
 * Insert a new item into the specified table. Checks for duplicate names in tables that require it.
 */
export const adminTableInsert = <ThrowOnError extends boolean = false>(options: Options<AdminTableInsertData, ThrowOnError>) => (options.client ?? client).post<AdminTableInsertResponses, AdminTableInsertErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/table/add/{table}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update an item in a table
 *
 * Update an existing item in the specified table. Checks for duplicate names in tables that require it.
 */
export const adminTableUpdate = <ThrowOnError extends boolean = false>(options: Options<AdminTableUpdateData, ThrowOnError>) => (options.client ?? client).put<AdminTableUpdateResponses, AdminTableUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/table/update/{table}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an item from a table
 *
 * Delete an item from the specified table by ID. Unassigns resources from desktops and deployments for relevant tables.
 */
export const adminTableDelete = <ThrowOnError extends boolean = false>(options: Options<AdminTableDeleteData, ThrowOnError>) => (options.client ?? client).delete<AdminTableDeleteResponses, AdminTableDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/table/{table}/{item_id}',
    ...options
});

/**
 * Count usage consumers
 *
 * Returns the total count of usage consumption records.
 */
export const adminUsageConsumersCount = <ThrowOnError extends boolean = false>(options?: Options<AdminUsageConsumersCountData, ThrowOnError>) => (options?.client ?? client).get<AdminUsageConsumersCountResponses, AdminUsageConsumersCountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/usage/consumers',
    ...options
});

/**
 * Consolidate all consumption data
 *
 * Triggers consolidation of all usage consumption data.
 */
export const adminUsageConsolidate = <ThrowOnError extends boolean = false>(options?: Options<AdminUsageConsolidateData, ThrowOnError>) => (options?.client ?? client).put<AdminUsageConsolidateResponses, AdminUsageConsolidateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/usage/consolidate',
    ...options
});

/**
 * Consolidate consumption for item type with days
 *
 * Triggers consolidation of usage consumption data for a specific item type and number of days.
 */
export const adminUsageConsolidateItemDays = <ThrowOnError extends boolean = false>(options: Options<AdminUsageConsolidateItemDaysData, ThrowOnError>) => (options.client ?? client).put<AdminUsageConsolidateItemDaysResponses, AdminUsageConsolidateItemDaysErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/usage/consolidate/{item_type}/{days}',
    ...options
});

/**
 * Consolidate consumption for item type
 *
 * Triggers consolidation of usage consumption data for a specific item type.
 */
export const adminUsageConsolidateItem = <ThrowOnError extends boolean = false>(options: Options<AdminUsageConsolidateItemData, ThrowOnError>) => (options.client ?? client).put<AdminUsageConsolidateItemResponses, AdminUsageConsolidateItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/usage/consolidate/{item_type}',
    ...options
});

/**
 * Get usage retention policy
 *
 * Returns the tiered rollup policy applied to ``usage_consumption``: how many months of recent daily granularity to keep, when rows collapse to weekly buckets, and the optional hard delete cap.
 */
export const adminUsageRetentionGet = <ThrowOnError extends boolean = false>(options?: Options<AdminUsageRetentionGetData, ThrowOnError>) => (options?.client ?? client).get<AdminUsageRetentionGetResponses, AdminUsageRetentionGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/usage/retention',
    ...options
});

/**
 * Update usage retention policy
 *
 * Persists the tiered rollup policy. The next incremental rollup (chained after the daily consolidator) will honour the new thresholds; running ``rollup_usage_consumption.py --mode=backfill`` applies them to the historical tail.
 */
export const adminUsageRetentionUpdate = <ThrowOnError extends boolean = false>(options: Options<AdminUsageRetentionUpdateData, ThrowOnError>) => (options.client ?? client).put<AdminUsageRetentionUpdateResponses, AdminUsageRetentionUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/usage/retention',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all usage parameters
 *
 * Returns all usage parameters.
 */
export const adminUsageParametersList = <ThrowOnError extends boolean = false>(options?: Options<AdminUsageParametersListData, ThrowOnError>) => (options?.client ?? client).get<AdminUsageParametersListResponses, AdminUsageParametersListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/usage/parameters',
    ...options
});

/**
 * Create usage parameter
 *
 * Creates a new usage parameter.
 */
export const adminUsageParametersAdd = <ThrowOnError extends boolean = false>(options: Options<AdminUsageParametersAddData, ThrowOnError>) => (options.client ?? client).post<AdminUsageParametersAddResponses, AdminUsageParametersAddErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/usage/parameters',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete usage parameter
 *
 * Deletes a usage parameter by ID.
 */
export const adminUsageParametersDelete = <ThrowOnError extends boolean = false>(options: Options<AdminUsageParametersDeleteData, ThrowOnError>) => (options.client ?? client).delete<AdminUsageParametersDeleteResponses, AdminUsageParametersDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/usage/parameters/{parameter_id}',
    ...options
});

/**
 * Update usage parameter
 *
 * Updates an existing usage parameter.
 */
export const adminUsageParametersUpdate = <ThrowOnError extends boolean = false>(options: Options<AdminUsageParametersUpdateData, ThrowOnError>) => (options.client ?? client).put<AdminUsageParametersUpdateResponses, AdminUsageParametersUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/usage/parameters/{parameter_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all usage limits
 *
 * Returns all usage limits.
 */
export const adminUsageLimitsList = <ThrowOnError extends boolean = false>(options?: Options<AdminUsageLimitsListData, ThrowOnError>) => (options?.client ?? client).get<AdminUsageLimitsListResponses, AdminUsageLimitsListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/usage/limits',
    ...options
});

/**
 * Create usage limit
 *
 * Creates a new usage limit.
 */
export const adminUsageLimitsAdd = <ThrowOnError extends boolean = false>(options: Options<AdminUsageLimitsAddData, ThrowOnError>) => (options.client ?? client).post<AdminUsageLimitsAddResponses, AdminUsageLimitsAddErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/usage/limits',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete usage limit
 *
 * Deletes a usage limit by ID.
 */
export const adminUsageLimitsDelete = <ThrowOnError extends boolean = false>(options: Options<AdminUsageLimitsDeleteData, ThrowOnError>) => (options.client ?? client).delete<AdminUsageLimitsDeleteResponses, AdminUsageLimitsDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/usage/limits/{limit_id}',
    ...options
});

/**
 * Update usage limit
 *
 * Updates an existing usage limit.
 */
export const adminUsageLimitsUpdate = <ThrowOnError extends boolean = false>(options: Options<AdminUsageLimitsUpdateData, ThrowOnError>) => (options.client ?? client).put<AdminUsageLimitsUpdateResponses, AdminUsageLimitsUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/usage/limits/{limit_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all usage groupings
 *
 * Returns all usage groupings (system + custom).
 */
export const adminUsageGroupingsList = <ThrowOnError extends boolean = false>(options?: Options<AdminUsageGroupingsListData, ThrowOnError>) => (options?.client ?? client).get<AdminUsageGroupingsListResponses, AdminUsageGroupingsListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/usage/groupings',
    ...options
});

/**
 * Create usage grouping
 *
 * Creates a new usage grouping.
 */
export const adminUsageGroupingsAdd = <ThrowOnError extends boolean = false>(options: Options<AdminUsageGroupingsAddData, ThrowOnError>) => (options.client ?? client).post<AdminUsageGroupingsAddResponses, AdminUsageGroupingsAddErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/usage/groupings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete usage grouping
 *
 * Deletes a usage grouping by ID.
 */
export const adminUsageGroupingsDelete = <ThrowOnError extends boolean = false>(options: Options<AdminUsageGroupingsDeleteData, ThrowOnError>) => (options.client ?? client).delete<AdminUsageGroupingsDeleteResponses, AdminUsageGroupingsDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/usage/groupings/{grouping_id}',
    ...options
});

/**
 * Update usage grouping
 *
 * Updates an existing usage grouping.
 */
export const adminUsageGroupingsUpdate = <ThrowOnError extends boolean = false>(options: Options<AdminUsageGroupingsUpdateData, ThrowOnError>) => (options.client ?? client).put<AdminUsageGroupingsUpdateResponses, AdminUsageGroupingsUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/usage/groupings/{grouping_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all usage credits
 *
 * Returns all usage credits with category names and grouping names.
 */
export const adminUsageAllCredits = <ThrowOnError extends boolean = false>(options?: Options<AdminUsageAllCreditsData, ThrowOnError>) => (options?.client ?? client).get<AdminUsageAllCreditsResponses, AdminUsageAllCreditsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/usage/category_credits',
    ...options
});

/**
 * Get usage credit by ID
 *
 * Returns a specific usage credit.
 */
export const adminUsageCreditsById = <ThrowOnError extends boolean = false>(options: Options<AdminUsageCreditsByIdData, ThrowOnError>) => (options.client ?? client).get<AdminUsageCreditsByIdResponses, AdminUsageCreditsByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/usage/category_credits/{category_credit_id}',
    ...options
});

/**
 * Create usage credit
 *
 * Creates usage credits for one or more items.
 */
export const adminUsageCreditsAdd = <ThrowOnError extends boolean = false>(options: Options<AdminUsageCreditsAddData, ThrowOnError>) => (options.client ?? client).post<AdminUsageCreditsAddResponses, AdminUsageCreditsAddErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/usage/credits',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete usage credit
 *
 * Deletes a usage credit by ID.
 */
export const adminUsageCreditsDelete = <ThrowOnError extends boolean = false>(options: Options<AdminUsageCreditsDeleteData, ThrowOnError>) => (options.client ?? client).delete<AdminUsageCreditsDeleteResponses, AdminUsageCreditsDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/usage/credits/{credit_id}',
    ...options
});

/**
 * Update usage credit
 *
 * Updates an existing usage credit.
 */
export const adminUsageCreditsUpdate = <ThrowOnError extends boolean = false>(options: Options<AdminUsageCreditsUpdateData, ThrowOnError>) => (options.client ?? client).put<AdminUsageCreditsUpdateResponses, AdminUsageCreditsUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/usage/credits/{credit_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unify item name in consumption records
 *
 * Unifies the item name across all consumption records for the given item.
 */
export const adminUsageUnifyItemName = <ThrowOnError extends boolean = false>(options: Options<AdminUsageUnifyItemNameData, ThrowOnError>) => (options.client ?? client).put<AdminUsageUnifyItemNameResponses, AdminUsageUnifyItemNameErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/usage/unify/{item_id}/item_name',
    ...options
});

/**
 * Set usage reset dates
 *
 * Replaces all usage reset dates with the provided list.
 */
export const adminUsageResetDatesAdd = <ThrowOnError extends boolean = false>(options: Options<AdminUsageResetDatesAddData, ThrowOnError>) => (options.client ?? client).put<AdminUsageResetDatesAddResponses, AdminUsageResetDatesAddErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/usage/reset_dates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete all consumption data
 *
 * Deletes all usage consumption data. This operation runs in the background.
 */
export const adminUsageDeleteConsumptionData = <ThrowOnError extends boolean = false>(options?: Options<AdminUsageDeleteConsumptionDataData, ThrowOnError>) => (options?.client ?? client).delete<AdminUsageDeleteConsumptionDataResponses, AdminUsageDeleteConsumptionDataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/usage/delete_data',
    ...options
});

/**
 * Check overlapping credits
 *
 * Checks if there are overlapping credit intervals for the given credit and date range.
 */
export const adminUsageCheckOverlapping = <ThrowOnError extends boolean = false>(options: Options<AdminUsageCheckOverlappingData, ThrowOnError>) => (options.client ?? client).get<AdminUsageCheckOverlappingResponses, AdminUsageCheckOverlappingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/usage/check/overlapping/{credit_id}/{start_date}/{end_date}',
    ...options
});

/**
 * Auto-register user storage provider
 *
 * Auto-registers a user storage provider with the given credentials.
 */
export const adminUserStorageAutoRegister = <ThrowOnError extends boolean = false>(options: Options<AdminUserStorageAutoRegisterData, ThrowOnError>) => (options.client ?? client).post<AdminUserStorageAutoRegisterResponses, AdminUserStorageAutoRegisterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/user_storage/auto_register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Test user storage connection
 *
 * Tests the connection to a user storage provider.
 */
export const adminUserStorageTest = <ThrowOnError extends boolean = false>(options: Options<AdminUserStorageTestData, ThrowOnError>) => (options.client ?? client).post<AdminUserStorageTestResponses, AdminUserStorageTestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/user_storage/conn_test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get user storage login auth URL
 *
 * Returns the login authentication URL for a user storage provider.
 */
export const adminUserStorageLoginAuth = <ThrowOnError extends boolean = false>(options: Options<AdminUserStorageLoginAuthData, ThrowOnError>) => (options.client ?? client).get<AdminUserStorageLoginAuthResponses, AdminUserStorageLoginAuthErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/user_storage/{provider_id}/login_auth',
    ...options
});

/**
 * List user storage providers
 *
 * Returns all user storage providers.
 */
export const adminUserStorageList = <ThrowOnError extends boolean = false>(options?: Options<AdminUserStorageListData, ThrowOnError>) => (options?.client ?? client).get<AdminUserStorageListResponses, AdminUserStorageListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/user_storage',
    ...options
});

/**
 * List user storage users
 *
 * Returns all users with user storage configured.
 */
export const adminUserStorageUsers = <ThrowOnError extends boolean = false>(options?: Options<AdminUserStorageUsersData, ThrowOnError>) => (options?.client ?? client).get<AdminUserStorageUsersResponses, AdminUserStorageUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/user_storage/users',
    ...options
});

/**
 * Delete user storage provider
 *
 * Deletes a user storage provider by ID.
 */
export const adminUserStorageRemove = <ThrowOnError extends boolean = false>(options: Options<AdminUserStorageRemoveData, ThrowOnError>) => (options.client ?? client).delete<AdminUserStorageRemoveResponses, AdminUserStorageRemoveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/user_storage/{provider_id}',
    ...options
});

/**
 * Get user storage provider
 *
 * Returns a specific user storage provider by ID.
 */
export const adminUserStorageGet = <ThrowOnError extends boolean = false>(options: Options<AdminUserStorageGetData, ThrowOnError>) => (options.client ?? client).get<AdminUserStorageGetResponses, AdminUserStorageGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/user_storage/{provider_id}',
    ...options
});

/**
 * Reset user storage provider
 *
 * Resets a user storage provider by ID.
 */
export const adminUserStorageReset = <ThrowOnError extends boolean = false>(options: Options<AdminUserStorageResetData, ThrowOnError>) => (options.client ?? client).delete<AdminUserStorageResetResponses, AdminUserStorageResetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/user_storage/{provider_id}/reset',
    ...options
});

/**
 * Reset all user storage providers
 *
 * Resets all user storage providers.
 */
export const adminUserStorageResetAll = <ThrowOnError extends boolean = false>(options?: Options<AdminUserStorageResetAllData, ThrowOnError>) => (options?.client ?? client).delete<AdminUserStorageResetAllResponses, AdminUserStorageResetAllErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/user_storage/reset/all',
    ...options
});

/**
 * Add user storage provider
 *
 * Adds a user storage provider using the specified auth protocol (auth_basic or auth_oauth2).
 */
export const adminUserStorageAdd = <ThrowOnError extends boolean = false>(options: Options<AdminUserStorageAddData, ThrowOnError>) => (options.client ?? client).post<AdminUserStorageAddResponses, AdminUserStorageAddErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/user_storage/new/{auth_protocol}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sync user storage provider
 *
 * Syncs groups, users, or all for a user storage provider.
 */
export const adminUserStorageSync = <ThrowOnError extends boolean = false>(options: Options<AdminUserStorageSyncData, ThrowOnError>) => (options.client ?? client).put<AdminUserStorageSyncResponses, AdminUserStorageSyncErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/user_storage/{provider_id}/sync/{item}',
    ...options
});

/**
 * Reset user password
 *
 * Admin resets a user's password.
 */
export const adminResetPassword = <ThrowOnError extends boolean = false>(options: Options<AdminResetPasswordData, ThrowOnError>) => (options.client ?? client).put<AdminResetPasswordResponses, AdminResetPasswordErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/users/reset-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check password reset required
 *
 * Check if a user needs to reset their password.
 */
export const adminCheckPasswordResetRequired = <ThrowOnError extends boolean = false>(options: Options<AdminCheckPasswordResetRequiredData, ThrowOnError>) => (options.client ?? client).get<AdminCheckPasswordResetRequiredResponses, AdminCheckPasswordResetRequiredErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/required/password-reset/{user_id}',
    ...options
});

/**
 * Check email verification required
 *
 * Check if a user needs to verify their email.
 */
export const adminCheckEmailVerification = <ThrowOnError extends boolean = false>(options: Options<AdminCheckEmailVerificationData, ThrowOnError>) => (options.client ?? client).get<AdminCheckEmailVerificationResponses, AdminCheckEmailVerificationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/required/email-verification/{user_id}',
    ...options
});

/**
 * Check disclaimer acknowledgement
 *
 * Check if a user has acknowledged the disclaimer.
 */
export const adminCheckDisclaimer = <ThrowOnError extends boolean = false>(options: Options<AdminCheckDisclaimerData, ThrowOnError>) => (options.client ?? client).get<AdminCheckDisclaimerResponses, AdminCheckDisclaimerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/required/disclaimer-acknowledgement/{user_id}',
    ...options
});

/**
 * Check migration required
 *
 * Check if a user needs to migrate their account.
 */
export const adminCheckMigrationRequired = <ThrowOnError extends boolean = false>(options: Options<AdminCheckMigrationRequiredData, ThrowOnError>) => (options.client ?? client).get<AdminCheckMigrationRequiredResponses, AdminCheckMigrationRequiredErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/required/migration/{user_id}',
    ...options
});

/**
 * List categories
 *
 * Returns all categories.
 */
export const adminListCategories = <ThrowOnError extends boolean = false>(options?: Options<AdminListCategoriesData, ThrowOnError>) => (options?.client ?? client).get<AdminListCategoriesResponses, AdminListCategoriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/categories',
    ...options
});

/**
 * List frontend categories
 *
 * Returns categories for frontend display.
 */
export const adminListCategoriesFrontend = <ThrowOnError extends boolean = false>(options: Options<AdminListCategoriesFrontendData, ThrowOnError>) => (options.client ?? client).get<AdminListCategoriesFrontendResponses, AdminListCategoriesFrontendErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/categories/{frontend}',
    ...options
});

/**
 * Delete category
 *
 * Deletes a category.
 */
export const adminDeleteCategory = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteCategoryData, ThrowOnError>) => (options.client ?? client).delete<AdminDeleteCategoryResponses, AdminDeleteCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/category/{category_id}',
    ...options
});

/**
 * Get category
 *
 * Returns data for a specific category.
 */
export const adminGetCategory = <ThrowOnError extends boolean = false>(options: Options<AdminGetCategoryData, ThrowOnError>) => (options.client ?? client).get<AdminGetCategoryResponses, AdminGetCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/category/{category_id}',
    ...options
});

/**
 * Update category
 *
 * Updates a category.
 */
export const adminUpdateCategory = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateCategoryData, ThrowOnError>) => (options.client ?? client).put<AdminUpdateCategoryResponses, AdminUpdateCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/category/{category_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create category
 *
 * Creates a new category with an associated Main group.
 */
export const adminCreateCategory = <ThrowOnError extends boolean = false>(options: Options<AdminCreateCategoryData, ThrowOnError>) => (options.client ?? client).post<AdminCreateCategoryResponses, AdminCreateCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/category',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update category quota
 *
 * Updates quota for a category.
 */
export const adminUpdateCategoryQuota = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateCategoryQuotaData, ThrowOnError>) => (options.client ?? client).put<AdminUpdateCategoryQuotaResponses, AdminUpdateCategoryQuotaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/quota/category/{category_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update category limits
 *
 * Updates limits for a category.
 */
export const adminUpdateCategoryLimits = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateCategoryLimitsData, ThrowOnError>) => (options.client ?? client).put<AdminUpdateCategoryLimitsResponses, AdminUpdateCategoryLimitsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/limits/category/{category_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get admin secrets
 *
 * Returns admin secrets/keys.
 */
export const adminGetSecrets = <ThrowOnError extends boolean = false>(options?: Options<AdminGetSecretsData, ThrowOnError>) => (options?.client ?? client).get<AdminGetSecretsResponses, AdminGetSecretsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/secrets',
    ...options
});

/**
 * Create admin secret
 *
 * Creates a new admin secret.
 */
export const adminCreateSecret = <ThrowOnError extends boolean = false>(options: Options<AdminCreateSecretData, ThrowOnError>) => (options.client ?? client).post<AdminCreateSecretResponses, AdminCreateSecretErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/secret',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete admin secret
 *
 * Deletes an admin secret.
 */
export const adminDeleteSecret = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteSecretData, ThrowOnError>) => (options.client ?? client).delete<AdminDeleteSecretResponses, AdminDeleteSecretErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/secret/{kid}',
    ...options
});

/**
 * Get user by email and category
 *
 * Returns user ID by email and category.
 */
export const adminGetUserByEmailCategory = <ThrowOnError extends boolean = false>(options: Options<AdminGetUserByEmailCategoryData, ThrowOnError>) => (options.client ?? client).get<AdminGetUserByEmailCategoryResponses, AdminGetUserByEmailCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/email-category/{email}/{category}',
    ...options
});

/**
 * Auto register user
 *
 * Auto-registers a user from the Register-Claims token.
 */
export const adminAutoRegister = <ThrowOnError extends boolean = false>(options: Options<AdminAutoRegisterData, ThrowOnError>) => (options.client ?? client).post<AdminAutoRegisterResponses, AdminAutoRegisterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/user/auto-register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Broadcast admin message
 *
 * Broadcasts a message to all connected users via SocketIO.
 */
export const adminBroadcast = <ThrowOnError extends boolean = false>(options: Options<AdminBroadcastData2, ThrowOnError>) => (options.client ?? client).post<AdminBroadcastResponses, AdminBroadcastErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/socketio/broadcast',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get viewers configuration
 *
 * Returns all viewers configurations as a list — one entry per viewer (``file_rdpgw``, ``file_rdpvpn``, ``file_spice``) with ``key``, ``viewer``, ``custom``, ``default``, ``fixed`` fields. Webapp DataTables consumes the response root as the row array.
 */
export const adminViewersConfig = <ThrowOnError extends boolean = false>(options?: Options<AdminViewersConfigData, ThrowOnError>) => (options?.client ?? client).get<AdminViewersConfigResponses, AdminViewersConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/viewers-config',
    ...options
});

/**
 * Update viewer configuration
 *
 * Updates the custom configuration for a specific viewer.
 */
export const adminViewersConfigUpdate = <ThrowOnError extends boolean = false>(options: Options<AdminViewersConfigUpdateData, ThrowOnError>) => (options.client ?? client).put<AdminViewersConfigUpdateResponses, AdminViewersConfigUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/viewers-config/{viewer}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset viewer configuration
 *
 * Resets a viewer custom configuration to its default. Valid viewers: file_rdpgw, file_rdpvpn, file_spice.
 */
export const adminViewersConfigReset = <ThrowOnError extends boolean = false>(options: Options<AdminViewersConfigResetData, ThrowOnError>) => (options.client ?? client).put<AdminViewersConfigResetResponses, AdminViewersConfigResetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/item/viewers-config/reset/{viewer}',
    ...options
});

/**
 * Get all bookings
 *
 * Returns a list of all bookings (admin only).
 */
export const getAllBookings = <ThrowOnError extends boolean = false>(options?: Options<GetAllBookingsData, ThrowOnError>) => (options?.client ?? client).get<GetAllBookingsResponses, GetAllBookingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/bookings/all',
    ...options
});

/**
 * Get users by priority rule
 *
 * Returns users matching a priority rule.
 */
export const getUsersPriorities = <ThrowOnError extends boolean = false>(options: Options<GetUsersPrioritiesData, ThrowOnError>) => (options.client ?? client).post<GetUsersPrioritiesResponses, GetUsersPrioritiesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/bookings/priorities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete priority
 *
 * Deletes a booking priority by ID.
 */
export const deletePriority = <ThrowOnError extends boolean = false>(options: Options<DeletePriorityData, ThrowOnError>) => (options.client ?? client).delete<DeletePriorityResponses, DeletePriorityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/booking/priority/{priority_id}',
    ...options
});

/**
 * List priority rules
 *
 * Returns a list of all priority rules.
 */
export const listPriorityRules = <ThrowOnError extends boolean = false>(options?: Options<ListPriorityRulesData, ThrowOnError>) => (options?.client ?? client).get<ListPriorityRulesResponses, ListPriorityRulesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/bookings/priority-rules',
    ...options
});

/**
 * Get GPU bookings forecast
 *
 * Returns GPU bookings forecast with current, 30min and 60min projections.
 */
export const getGpuBookingsForecast = <ThrowOnError extends boolean = false>(options?: Options<GetGpuBookingsForecastData, ThrowOnError>) => (options?.client ?? client).get<GetGpuBookingsForecastResponses, GetGpuBookingsForecastErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/bookings/gpu',
    ...options
});

/**
 * Empty all bookings in plan
 *
 * Deletes all bookings associated with a plan.
 */
export const emptyBookingPlan = <ThrowOnError extends boolean = false>(options: Options<EmptyBookingPlanData, ThrowOnError>) => (options.client ?? client).delete<EmptyBookingPlanResponses, EmptyBookingPlanErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/booking/empty/{plan_id}',
    ...options
});

/**
 * Get booking's plans
 *
 * Returns the plans associated with a booking.
 */
export const getBookingPlans = <ThrowOnError extends boolean = false>(options: Options<GetBookingPlansData, ThrowOnError>) => (options.client ?? client).get<GetBookingPlansResponses, GetBookingPlansErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/booking/{booking_id}/plans',
    ...options
});

/**
 * List profiles for a reservable type
 *
 * Returns all profiles for a specific reservable type.
 */
export const listProfiles = <ThrowOnError extends boolean = false>(options: Options<ListProfilesData, ThrowOnError>) => (options.client ?? client).get<ListProfilesResponses, ListProfilesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/reservables/profiles/{reservable_type}',
    ...options
});

/**
 * List bookable reservables with their backing categories
 *
 * Returns the bookable reservables of a type, each enriched with the distinct categories of the delegated GPU cards that back it. Replaces the generic admin table feed for the Bookables admin view.
 */
export const listBookables = <ThrowOnError extends boolean = false>(options: Options<ListBookablesData, ThrowOnError>) => (options.client ?? client).get<ListBookablesResponses, ListBookablesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/bookables/{reservable_type}',
    ...options
});

/**
 * List subitems of a reservable item
 *
 * Returns the catalog of subitems (e.g., vGPU profiles) for a specific reservable item. v3 parity for the admin Hypervisors
 */
export const listReservableSubitems = <ThrowOnError extends boolean = false>(options: Options<ListReservableSubitemsData, ThrowOnError>) => (options.client ?? client).get<ListReservableSubitemsResponses, ListReservableSubitemsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/items/reservables/{reservable_type}/{item_id}',
    ...options
});

/**
 * Add new reservable item
 *
 * Creates a new reservable item of the specified type.
 */
export const addReservableItem = <ThrowOnError extends boolean = false>(options: Options<AddReservableItemData, ThrowOnError>) => (options.client ?? client).post<AddReservableItemResponses, AddReservableItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/reservable/{reservable_type}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enable or disable a reservable subitem
 *
 * Enables or disables a specific reservable subitem (e.g., GPU profile). Pass ``?notify_user=true`` to fan out a ``deleted-gpu`` email to every user whose desktops/deployments/bookings reference the reservable (v3 parity).
 */
export const enableReservableSubitem = <ThrowOnError extends boolean = false>(options: Options<EnableReservableSubitemData, ThrowOnError>) => (options.client ?? client).put<EnableReservableSubitemResponses, EnableReservableSubitemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/reservable/enable/{reservable_type}/{item_id}/{subitem_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check last subitem
 *
 * Checks if a GPU profile was the last enabled and returns affected desktops and plans.
 */
export const checkLastSubitem = <ThrowOnError extends boolean = false>(options: Options<CheckLastSubitemData, ThrowOnError>) => (options.client ?? client).get<CheckLastSubitemResponses, CheckLastSubitemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/reservable/check-last/{reservable_type}/{subitem_id}/{item_id}',
    ...options
});

/**
 * Check last item
 *
 * Checks if a GPU item was the last enabled and returns affected desktops and plans.
 */
export const checkLastItem = <ThrowOnError extends boolean = false>(options: Options<CheckLastItemData, ThrowOnError>) => (options.client ?? client).get<CheckLastItemResponses, CheckLastItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/reservable/check-last/{reservable_type}/{item_id}',
    ...options
});

/**
 * Delete reservable item
 *
 * Deletes a reservable item and all its associated plans and bookings. Pass ``?notify_user=true`` to fan out a ``deleted-gpu`` email to affected users first (v3 parity).
 */
export const deleteReservableItem = <ThrowOnError extends boolean = false>(options: Options<DeleteReservableItemData, ThrowOnError>) => (options.client ?? client).delete<DeleteReservableItemResponses, DeleteReservableItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/reservable/{reservable_type}/{item_id}',
    ...options
});

/**
 * Update reservable item
 *
 * Update name and description of a reservable item (e.g., GPU).
 */
export const updateReservableItem = <ThrowOnError extends boolean = false>(options: Options<UpdateReservableItemData, ThrowOnError>) => (options.client ?? client).put<UpdateReservableItemResponses, UpdateReservableItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/reservables/{reservable_type}/{item_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check planning integrity
 *
 * Checks if any plan item IDs are overlapped.
 */
export const checkIntegrity = <ThrowOnError extends boolean = false>(options?: Options<CheckIntegrityData, ThrowOnError>) => (options?.client ?? client).get<CheckIntegrityResponses, CheckIntegrityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/reservables-planner/check-integrity',
    ...options
});

/**
 * Get actual plan for item
 *
 * Returns the current active plan for a specific item.
 */
export const getActualPlan = <ThrowOnError extends boolean = false>(options: Options<GetActualPlanData, ThrowOnError>) => (options.client ?? client).get<GetActualPlanResponses, GetActualPlanErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/reservables-planner/actual-plan/{item_id}',
    ...options
});

/**
 * Get plan bookings
 *
 * Returns all bookings associated with a specific plan.
 */
export const getPlanBookings = <ThrowOnError extends boolean = false>(options: Options<GetPlanBookingsData, ThrowOnError>) => (options.client ?? client).get<GetPlanBookingsResponses, GetPlanBookingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/reservables-planner/{plan_id}/bookings',
    ...options
});

/**
 * Get all desktops
 *
 * Returns a list of all desktops in the system.
 */
export const getAllDesktops = <ThrowOnError extends boolean = false>(options?: Options<GetAllDesktopsData, ThrowOnError>) => (options?.client ?? client).get<GetAllDesktopsResponses, GetAllDesktopsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/admin/items/desktops',
    ...options
});

/**
 * Register a new user
 *
 * Registers a new user in the system.
 */
export const registerUser = <ThrowOnError extends boolean = false>(options: Options<RegisterUserData, ThrowOnError>) => (options.client ?? client).post<RegisterUserResponses, RegisterUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Apply a registration code to an existing user
 *
 * Updates an existing user's role and group from a registration code.
 */
export const reRegisterUser = <ThrowOnError extends boolean = false>(options: Options<ReRegisterUserData, ThrowOnError>) => (options.client ?? client).put<ReRegisterUserResponses, ReRegisterUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get user password policy
 *
 * Returns the password policy for the user.
 */
export const getUserPasswordPolicy = <ThrowOnError extends boolean = false>(options?: Options<GetUserPasswordPolicyData, ThrowOnError>) => (options?.client ?? client).get<GetUserPasswordPolicyResponses, GetUserPasswordPolicyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/get-password-policy',
    ...options
});

/**
 * Get disclaimer content
 *
 * Returns disclaimer content for the login page.
 */
export const apiV4Disclaimer = <ThrowOnError extends boolean = false>(options?: Options<ApiV4DisclaimerData, ThrowOnError>) => (options?.client ?? client).get<ApiV4DisclaimerResponses, ApiV4DisclaimerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/disclaimer',
    ...options
});

/**
 * Get disclaimer template
 *
 * Returns the disclaimer template for the current user.
 */
export const getDisclaimer = <ThrowOnError extends boolean = false>(options?: Options<GetDisclaimerData, ThrowOnError>) => (options?.client ?? client).get<GetDisclaimerResponses, GetDisclaimerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/disclaimer',
    ...options
});

/**
 * Check desktop viewer ownership
 *
 * Verify that the caller is authorised to reach a running desktop's viewer. Used by rdpgw, websockify and guac as a service-side preflight before proxying a connection.
 *
 * Dispatches on three mutually-exclusive variants:
 * - If the JWT payload carries a ``desktop_id`` (direct-viewer token), the body may contain an ``ip`` which must match the desktop's viewer ``guest_ip``.
 * - Else if the body contains ``ip``, look up the running desktop by ``guest_ip`` index.
 * - Else the body must contain ``proxy_video``, ``proxy_hyper_host`` and ``port``, and the desktop is found via the ``proxies`` index.
 *
 * This endpoint replaces v3's ``GET /user/owns_desktop`` which used a GET-with-body pattern that could not be represented in OpenAPI.
 */
export const userOwnsDesktop = <ThrowOnError extends boolean = false>(options: Options<UserOwnsDesktopData, ThrowOnError>) => (options.client ?? client).post<UserOwnsDesktopResponses, UserOwnsDesktopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/owns-desktop',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get networks of a desktop from a direct viewer token
 *
 * Returns the networks information about an IsardVDI desktop identified by a direct viewer share token. Requires a direct viewer JWT as Authorization bearer.
 */
export const getNetworksFromToken = <ThrowOnError extends boolean = false>(options: Options<GetNetworksFromTokenData, ThrowOnError>) => (options.client ?? client).get<GetNetworksFromTokenResponses, GetNetworksFromTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/token/{token}/get-networks',
    ...options
});

/**
 * Get the details of a desktop from a direct viewer token
 *
 * Returns the details of an IsardVDI desktop identified by a direct viewer share token, including its read-only bastion access info if enabled. Requires a direct viewer JWT as Authorization bearer.
 */
export const getDesktopDetailsFromToken = <ThrowOnError extends boolean = false>(options: Options<GetDesktopDetailsFromTokenData, ThrowOnError>) => (options.client ?? client).get<GetDesktopDetailsFromTokenResponses, GetDesktopDetailsFromTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/token/{token}/get-details',
    ...options
});

/**
 * Start a desktop from a direct viewer token
 *
 * Starts an IsardVDI desktop identified by a direct viewer share token. Requires a direct viewer JWT as Authorization bearer. No-op if the desktop is not in a stopped/failed state.
 */
export const startDesktopFromToken = <ThrowOnError extends boolean = false>(options: Options<StartDesktopFromTokenData, ThrowOnError>) => (options.client ?? client).put<StartDesktopFromTokenResponses, StartDesktopFromTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/token/{token}/start-desktop',
    ...options
});

/**
 * Reset Desktop
 */
export const resetDesktop = <ThrowOnError extends boolean = false>(options: Options<ResetDesktopData, ThrowOnError>) => (options.client ?? client).put<ResetDesktopResponses, ResetDesktopErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/desktop/token/{token}/reset-desktop',
    ...options
});

/**
 * Generate a JWT token to export user data for migration purposes.
 *
 * Generates a JWT token that contains the user's data for migration to another IsardVDI user.
 */
export const migrationExportUser = <ThrowOnError extends boolean = false>(options?: Options<MigrationExportUserData, ThrowOnError>) => (options?.client ?? client).put<MigrationExportUserResponses, MigrationExportUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user-migration/export-user',
    ...options
});

/**
 * Check if provider allows exporting user migrations.
 *
 * Returns whether the authentication provider allows users to export their data for migration.
 */
export const getProviderExportEnabled = <ThrowOnError extends boolean = false>(options: Options<GetProviderExportEnabledData, ThrowOnError>) => (options.client ?? client).get<GetProviderExportEnabledResponses, GetProviderExportEnabledErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/provider/export/{provider_id}',
    ...options
});

/**
 * Check if provider allows importing user migrations.
 *
 * Returns whether the authentication provider allows users to import data from another user.
 */
export const getProviderImportEnabled = <ThrowOnError extends boolean = false>(options: Options<GetProviderImportEnabledData, ThrowOnError>) => (options.client ?? client).get<GetProviderImportEnabledResponses, GetProviderImportEnabledErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/provider/import/{provider_id}',
    ...options
});

/**
 * Set user email
 *
 * Sets the email address for the specified user.
 */
export const setUserEmail = <ThrowOnError extends boolean = false>(options: Options<SetUserEmailData, ThrowOnError>) => (options.client ?? client).put<SetUserEmailResponses, SetUserEmailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v4/item/user/set-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
